// These fields allign with /CRDataNode?qualifier=type.identifier='Function1' AND deleted=0 AND notActive=0 & count=1000
// values match CRDataNode 'value' property => important for matching on the backend
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const functionNodes = [
  `Charcutier`,
  `Tandarts`,
  `Technoloog medische beeldvorming`,
  `Onderzoeker humane wetenschappen`,
  `Osteopaat chiropractor`,
  `Kinesitherapeut`,
  `Arts`,
  `Beeld- en geluidsmonteur`,
  `Revisor`,
  `Geluidstechnicus podium- en audiovisuele producties`,
  `Productieverantwoordelijke podium/audiovisueel`,
  `Klinisch bioloog`,
  `Beeldopnametechnicus`,
  `Decorbouwer-rekwisiteur`,
  `Costumier`,
  `Professioneel sportbeoefenaar`,
  `Circus- en variétéartiest`,
  `Componist`,
  `Zanger`,
  `Choreograaf`,
  `Danser`,
  `Mannequin`,
  `Model`,
  `Presentator`,
  `DJ`,
  `Medewerker openbare veiligheid`,
  `Medewerker civiele veiligheid`,
  `Leidinggevende openbare veiligheid`,
  `Medewerker defensie`,
  `Lijkenbalsemer`,
  `Privédetective`,
  `Leidinggevende privébewaking `,
  `Toezichthouder van lokalen en gebouwen`,
  `Verantwoordelijke eco-industriële onderneming`,
  `Medewerker hygiëne en ongediertebestrijding`,
  `Leidinggevende milieuzorg en sanering`,
  `Leerkracht buitengewoon lager onderwijs`,
  `Uitgever`,
  `Leidinggevende civiele veiligheid`,
  `Filiaalhouder verzekeringen`,
  `Tolk`,
  `Procesoperator drukken in de printmedia`,
  `Voedingsinspecteur`,
  `Cultuurmanager`,
  `Productieoperator drukafwerking in de printmedia`,
  `Leidinggevende printmedia`,
  `Corrector`,
  `Procesoperator hout`,
  `Print en sign medewerker`,
  `Etalateur-decorateur`,
  `Verantwoordelijke publiciteitscampagnes`,
  `Relatie- en gezinsbemiddelaar`,
  `Ruitenwasser`,
  `Psycholoog`,
  `Psychomotorisch en creatief therapeut`,
  `Voogd voor begunstigden van een juridische beschermmaatregel`,
  `Ervaringsdeskundige armoede of verslavingsproblematieken`,
  `Sociaal-cultureel begeleider`,
  `Gemeenschapswacht`,
  `Coördinator vrijwilligerswerk`,
  `Sociale en familiale interveniënt`,
  `Beleidsverantwoordelijke overheidsdienst`,
  `Adviseur volksgezondheid`,
  `Verantwoordelijke gezondheids-, sociale of penitentiaire instelling`,
  `Beleidsuitvoerend medewerker overheidsdienst`,
  `Controleur sociale inspectie`,
  `Medewerker openbare schatkist`,
  `Controleur economische inspectie`,
  `Erfgoedkundige`,
  `Bibliothecaris-archivaris`,
  `Archiefmedewerker`,
  `Bibliotheekdeskundige`,
  `Archiefdeskundige`,
  `Medewerker lokale ontwikkeling`,
  `Jurist in een openbaar ambt of met een mandaat`,
  `Magistraat`,
  `Bemiddelaar welzijn`,
  `Procesoperator drukafwerking in de printmedia`,
  `Leerkracht buitengewoon secundair onderwijs`,
  `Leerkracht deeltijds kunstonderwijs`,
  `Leidinggevende onderwijsinstelling`,
  `Opleidingsadviseur`,
  `Loopbaanbegeleider`,
  `Opvoeder in een onderwijsinstelling`,
  `Vaarinstructeur`,
  `Leerkracht buitengewoon kleuteronderwijs`,
  `Ontwikkelaar verzekeringsproducten`,
  `Verzekeringsmakelaar`,
  `Onderschrijver verzekeringen`,
  `Hoogleraar aan een universiteit`,
  `Adviseur kredieten`,
  `Ontwikkelaar financiële producten`,
  `Kantoorhouder bankfiliaal`,
  `Rentmeester`,
  `Directeur van een grote organisatie`,
  `Verantwoordelijke ICT`,
  `Verantwoordelijke enquêtes`,
  `Agent financiële markten`,
  `Social media manager`,
  `Analist communicatie- en informatiesystemen defensie-veiligheid`,
  `Meteoroloog`,
  `Expert geografische informatiesystemen`,
  `Bodemonderzoeker`,
  `Technicus studiebureau bouw`,
  `Landmeter`,
  `EPB-verslaggever`,
  `Software tester`,
  `Verantwoordelijke ontginningen`,
  `Bediener machines verticale boringen`,
  `Bediener machines horizontale boringen`,
  `Ontginner gassen en vloeistoffen`,
  `Verantwoordelijke ontginningen`,
  `Trappenmaker`,
  `Scheepstimmerman`,
  `Installateur van datacommunicatienetwerken`,
  `Glaswerker`,
  `Slotenmaker`,
  `Plaatser van soepele vloerbekledingen`,
  `Schrijver`,
  `Industrieel isolatiewerker`,
  `Technicus hernieuwbare energietechnieken`,
  `Rijinstructeur`,
  `Kledingretoucheur`,
  `Dekvloerlegger`,
  `Rioollegger`,
  `Plaatser van houten vloerbedekking`,
  `Monitor-begeleider in de sociale economie`,
  `Websitebeheerder`,
  `Productiemedewerker drukafwerking in de printmedia`,
  `Medewerker kuuroord`,
  `Zandvormmaker`,
  `Wikkelaar van elektrische spoelen`,
  `Journalist-redacteur`,
  `Tufter`,
  `Wever`,
  `Medewerker assemblage houtindustrie`,
  `Technisch redacteur`,
  `Orthoptist-optometrist`,
  `Werkvoorbereider hout`,
  `Opleidingscoördinator`,
  `Landschapsarchitect`,
  `Uitbater café-brasserie`,
  `Fotograaf`,
  `Industrieel vormgever`,
  `Muzikant`,
  `Hulpkelner`,
  `Technicus kleurstoffen`,
  `Regisseur podiumkunsten`,
  `Agent van artiesten, modellen en atleten`,
  `Regisseur audiovisuele producties`,
  `Figurant`,
  `Hulpverlener-ambulancier`,
  `Audioloog audicien`,
  `Dentaaltechnicus`,
  `Vroedkundige`,
  `Kamerjongen-Kamermeisje`,
  `Mondhygiënist`,
  `Fitnessbegeleider`,
  `Begeleider culturele en recreatieve activiteiten`,
  `Podoloog`,
  `Orthopedisch technoloog`,
  `Psychomotorisch en creatief therapeut`,
  `Reisagent`,
  `Chocolatier-ijsbereider`,
  `Manicure-pedicure`,
  `Visagist`,
  `Masseur`,
  `Piercer-tatoeëerder`,
  `Kapper-salonbeheerder`,
  `Antiquair`,
  `Galeriehouder`,
  `Verhuurder van gereedschappen en machines, auto's en vrijetijdsmaterieel`,
  `Maître d'hôtel`,
  `Medisch afgevaardigde`,
  `Demonstrateur`,
  `Diëtist`,
  `Hotelconciërge`,
  `Medewerker recreatieve attracties`,
  `Medewerker gokspelen`,
  `Polyvalent hotelmedewerker`,
  `Verantwoordelijke kamerpersoneel`,
  `Schoen- en lederhersteller`,
  `Productiemedewerker drukafwerking,`,
  `Lesgever hoger niet-universitair onderwijs`,
  `Operator productie bouwmaterialen`,
  `Operator in de houtzagerij`,
  `Technicus grafische industrie`,
  `Data engineer`,
  `Grimeur-kapper`,
  `Hulpkok`,
  `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
  `Operator spinnerij`,
  `Leerkracht kleuteronderwijs`,
  `Sommelier`,
  `Operator leerlooierij witlooierij`,
  `Procesoperator kleding, confectie en meubelstoffering prototypes`,
  `Technicus soepele materialen`,
  `Ontwikkelaar patronen kleding- en confectieartikelen`,
  `Voorbewerker afwerker van leder en textielproducten`,
  `Operator non-woven`,
  `Operator productielijn kleding, confectie en meubelstoffering`,
  `Operator raam- en woningdecoratie`,
  `Medewerker productielijn kleding, confectie en meubelstoffering`,
  `Composietverwerker`,
  `Leerkracht lager onderwijs`,
  `Insteller-bediener vonkerosie`,
  `Verantwoordelijke onderhoud van gebouwen en infrastructuur`,
  `Operator in de keramiekindustrie`,
  `Matrijzenmaker`,
  `Industrieel plaatbewerker`,
  `Operator niet-verspanende bewerkingen`,
  `Oppervlaktebehandelaar diverse materialen`,
  `Mallenmaker`,
  `Preventieadviseur verzekeringen`,
  `Operator van een pulpmachine`,
  `Expert aroma's en geuren`,
  `Industrieel polijster`,
  `Thermisch behandelaar`,
  `Onderhoudsmedewerker affichering en straatmeubilair`,
  `Installateur liften`,
  `Verantwoordelijke beheer en onderhoud van voertuigen`,
  `Technicus communicatienetwerken`,
  `Technicus hernieuwbare energietechnieken`,
  `Plaatwerker carrosserie`,
  `Boswachter`,
  `Onderwaterwerker`,
  `Uitvoerder van werken in schadelijke milieus`,
  `Technicus doe-het-zelfmateriaal`,
  `OAD-technicus van personenwagens en lichte bedrijfsvoertuigen`,
  `Maker van vlechtwerk`,
  `Maker van juwelen en zilverwerk`,
  `Taxidermist`,
  `Hoedenmaker`,
  `Lederbewerker`,
  `Artistiek wever`,
  `Technicus elektrische en elektronische toestellen - witgoed`,
  `Natuurbeheerder`,
  `Bosbouwer`,
  `Landbouwkundig adviseur`,
  `Vee- en paardenhouder`,
  `Dierentrimmer`,
  `Medewerker internationaal goederenverkeer`,
  `Uitvoerder van werken op hoogte`,
  `Decorateur van kunst- en artisanale objecten`,
  `Trambestuurder`,
  `Technicus elektrische en elektronische toestellen - bruingoed`,
  `Verantwoordelijke organisatie voor personenvervoer over de weg`,
  `Steward luchtvaart`,
  `Rangeerder`,
  `Onderhoudstechnicus pleziervaart`,
  `Vliegtuigtechnicus`,
  `Technicus werf-, landbouw- en hefmachines`,
  `Landbouwer`,
  `Medisch-technisch assistent`,
  `Graveerder`,
  `Muziekinstrumentenbouwer -hersteller`,
  `Technicus van tuin-, park- en bosmachines`,
  `Zoutwinner`,
  `Schapen- en geitenfokker`,
  `Controleur op openbaar vervoer`,
  `Treinbestuurder`,
  `Werktuigkundige scheepvaart`,
  `Etalateur-decorateur`,
  `Ambachtelijk glasbewerker`,
  `Diamantbewerker`,
  `Uurwerkmaker`,
  `Medewerker in de fruitteelt`,
  `Boomverzorger`,
  `Kweker van vis, week- en schelpdieren`,
  `Boomkweker`,
  `Schipper visserij`,
  `Varkensfokker`,
  `Gezagvoerder zeevaart`,
  `Gezagvoerder kustsleepvaart en havensleepvaart`,
  `Bemanning zeevaart`,
  `Matroos binnenscheepvaart`,
  `Vluchtvoorbereider`,
  `Landbouwkundig onderzoeker`,
  `Verantwoordelijke budgetbeheer`,
  `OD-technicus van zware bedrijfsvoertuigen`,
  `Keramist-pottenbakker`,
  `Boekbinder-restaurateur`,
  `Kleermaker`,
  `Inspecteur land- en tuinbouw`,
  `Medewerker in de veehouderij of viskweek`,
  `Pluim- en kleinveekweker`,
  `Visserijmatroos`,
  `Dierenarts`,
  `service technieker`,
  `Bestuurder van sleepvoertuigen`,
  `Bestuurder van land- en bosbouwmachines`,
  `Dierenverzorger`,
  `Schipper-stuurman binnenvaart`,
  `Metrobestuurder`,
  `Treinbegeleider`,
  `Proces- en productontwikkelaar`,
  `Luchtverkeersleider`,
  `Verantwoordelijke uitbating luchthaven`,
  `Verantwoordelijke binnenscheepvaartbedrijf`,
  `Medewerker textielverzorging`,
  `Yield-revenue manager`,
  `Hoef- en klauwverzorger`,
  `Operator drukafwerking`,
  `Leidinggevende defensie`,
  `Beeldend kunstenaar`,
  `Kweker van wilde dieren of huisdieren`,
  `Dierenartsassistent`,
  `Operator van een mechanische lift`,
  `Animator recreatiecentrum`,
  `Medewerker openbare financiën`,
  `Sorteerder recyclage`,
  `Operator drukken`,
  `Operator digitaal bedrukken van textiel`,
  `Verantwoordelijke aankoopdienst`,
  `Syndicus`,
  `Productiemedewerker drukken in de printmedia`,
  `Klinisch bioloog`,
  `Netwerkbeheerder`,
  `Hoofdverpleegkundige`,
  `Elektronicus`,
  `Diplomatiek vertegenwoordiger`,
  `Begeleider activiteiten dagelijks leven`,
  `Uitsnijder-uitbener`,
  `Back-office medewerker in de financiële sector`,
  `Manager hotel restaurant`,
  `Onderhoudstechnicus waterdistributie en sanering`,
  `Installateur gebouwenautomatisering`,
  `Productieoperator-machineregelaar kunststoffen`,
  `Tekenaar-ontwerper elektriciteit, elektronica`,
  `Productieleider van podiumvoorstellingen en audiovisuele producties`,
  `Gevelreiniger`,
  `Operator glasbewerking`,
  `Dakdekker industriële daken`,
  `Opticien`,
  `Architect bouw`,
  `Multimedia designer`,
  `Medewerker fastfood`,
  `Onderhoudsmedewerker wegennet`,
  `Operator glasproductie`,
  `Opleider volwassenen`,
  `Steigerbouwer`,
  `Bordenbouwer`,
  `Fiscaal controleur`,
  `Verantwoordelijke kinderopvang`,
  `Ergotherapeut`,
  `Property manager`,
  `Arbeider begraafplaatsen`,
  `Medewerker reprografie-copycenter`,
  `Onderhoudsmecanicien van zware bedrijfsvoertuigen`,
  `Leidinggevend bemanningslid luchtvaart`,
  `Douanedeclarant`,
  `Bibliotheekmedewerker`,
  `Productieoperator drukken in de printmedia`,
  `Verzorgende`,
  `Meestergast in de meubel- en houtindustrie`,
  `Operator prepress`,
  `Florist-bloemist`,
  `Magazijnmedewerker`,
  `Milieuwerker`,
  `Directeur van een kleine of middelgrote organisatie`,
  `Trend- en marktanalist`,
  `Technicus verdeelautomaten`,
  `Installateur nutsvoorzieningen`,
  `Verpakker`,
  `ICT architect`,
  `Winkelmanager`,
  `Chef de partie`,
  `Medewerker spoorwegnet`,
  `Sales engineer`,
  `Tekenaar-ontwerper animatiefilms en speciale effecten`,
  `Technicus controle en kwaliteit elektriciteit en elektronica`,
  `Operator textielverzorging`,
  `Directieassistent hotel restaurant`,
  `Grootkeukenkok`,
  `Verhuizer`,
  `Deskundige veiligheid, hygiëne en leefmilieu`,
  `Chauffeur pleziervoertuigen`,
  `Leerkracht secundair onderwijs`,
  `Software analist`,
  `Horecamanager`,
  `Verantwoordelijke laboratorium`,
  `Veiligheidscoördinator`,
  `Operator van een papier- of kartonmachine`,
  `Monteur van elektrische en elektronische producten`,
  `Visual merchandiser`,
  `Juridisch medewerker`,
  `Integratie expert ICT`,
  `Data scientist`,
  `Software ontwikkelaar`,
  `Reisleider-gids`,
  `Spuiter carrosserie`,
  `Apotheker`,
  `Vastgoedbemiddelaar overdracht`,
  `Operator textielveredeling`,
  `Verpleegkundige`,
  `Technicus elektronische installaties`,
  `Brandwacht-veiligheidswacht`,
  `Technicus van bromfietsen en motorfietsen`,
  `Tekenaar-ontwerper mechanica`,
  `Opvoeder-begeleider`,
  `Leidinggevende schoonmaak`,
  `Apotheker`,
  `Controleur gebouwen`,
  `Operator filmlabo`,
  `Afdelingsverantwoordelijke verzekeringen`,
  `Coach persoonlijke ontwikkeling en welzijn`,
  `Farmaceutisch-technisch assistent`,
  `Bestuurder van betonnerings- en asfalteringsmachines`,
  `Uitzendconsulent`,
  `Logopedist`,
  `Operator fotolabo`,
  `Projectleider lokale ontwikkeling`,
  `Sales engineer`,
  `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
  `Redder`,
  `Interieurbouwer`,
  `Arbeidsbemiddelaar-jobcoach `,
  `Medewerker socio-economische studies`,
  `Keukenverantwoordelijke`,
  `Werfbediende`,
  `Orderbegeleider in de grafische sector`,
  `Calculator bouw`,
  `Business analist`,
  `Zorgkundige`,
  `Meubelstoffeerder`,
  `Brouwer van alcoholische dranken`,
  `Licht- en beeldtechnicus podium- en audiovisuele producties`,
  `Assistent winkelmanager`,
  `Verantwoordelijke productiemethodes en industrialisatie`,
  `Landbouwmedewerker`,
  `Hulpkok grootkeuken`,
  `Operator snijafdeling kleding, confectie en meubelstoffering`,
  `Technisch inspecteur industrie`,
  `Verantwoordelijke sport-, recreatieve of toeristische accommodatie`,
  `Kinderbegeleider schoolgaande kinderen`,
  `Vertaler`,
  `Sporttrainer`,
  `Huishoudhulp-poetshulp`,
  `Natuursteenbewerker`,
  `Isoleerder ruwbouw en dak`,
  `Afwerker-hersteller van breigoed- en textielproducten`,
  `Grafisch ontwerper`,
  `Regelaar-afsteller van productie-installaties`,
  `Systeembeheerder`,
  `Operator metaalovens`,
  `Machinebouwer`,
  `Leidinggevende mechanische productie`,
  `Leidinggevende textiel confectie en lederproductie`,
  `Check-in medewerker`,
  `Verantwoordelijke contactcenter`,
  `Visfileerder`,
  `Brug- en sluiswachter`,
  `Productieoperator hout`,
  `Preventiearts`,
  `Pijpfitter`,
  `Elektrodelasser`,
  `Montageoperator in de lederindustrie`,
  `Portefeuillebeheerder`,
  `Operator machines voor eerste metaalverwerking`,
  `Verantwoordelijke rendement toerismeproducten`,
  `Ambachtelijk metaalbewerker`,
  `Technicus onderzoek en ontwikkeling in de procesindustrie`,
  `Manager toerismeproducten`,
  `Interieurarchitect interieurvormgever`,
  `Vastgoedbemiddelaar verkoop en verhuur`,
  `Vastgoedpromotor`,
  `Koeltechnicus`,
  `Verantwoordelijke verkooppromotie`,
  `Bediener baggermachines`,
  `Plaatser van boven- en ondergrondse kabels en leidingen`,
  `Uitvaartondernemer`,
  `Kaasmaker`,
  `Kelner`,
  `Technicus productieproces en methodes`,
  `Autobuschauffeur`,
  `Bediener of medewerker diepfunderingsmachines`,
  `Afwasser`,
  `Schade-expert verzekeringen`,
  `Technicus industriële automatisering`,
  `Medewerker plaatselijke veiligheid`,
  `Verdeler post en drukwerk`,
  `Autogeenlasser`,
  `Brandertechnicus`,
  `Industrieel onderhoudstechnicus`,
  `Native speaker / Vertaler-Tolk`,
  `Social media manager`,
  `Customer relations manager`,
  `Technisch adviseur klantenondersteuning`,
  `Daktimmerman`,
  `Support medewerker ICT`,
  `Koetswerkbouwer`,
  `Maatschappelijk werker`,
  `Beheerder verzekeringen`,
  `Taxichauffeur`,
  `Adviseur bedrijfsorganisatie en management`,
  `Onthaalmedewerker hotel`,
  `Adviseur financieel vermogen`,
  `Commercieel medewerker in de financiële sector`,
  `Accountmanager in de financiële sector`,
  `Accountant - Belastingsconsulent`,
  `Monteur installatietechnieken`,
  `Onthaalmedewerker toerisme`,
  `Torenkraanbediener`,
  `Productiemedewerker prefab beton`,
  `Werfleider`,
  `Elektrotechnicus`,
  `Productiemedewerker kunststofverwerking`,
  `Voorbewerker carrosserie`,
  `Enquêteur`,
  `Horeca algemeen`,
  `Schoonmaker van ruimten en lokalen`,
  `Verantwoordelijke logistieke site`,
  `Sales manager`,
  `Loading supervisor luchtvaart`,
  `Behandelaar luchtvracht`,
  `Productiemedewerker drukken`,
  `Medewerker medisch secretariaat`,
  `Asbestverwijderaar`,
  `Leidinggevende industriële productie`,
  `Manager algemeen`,
  `Stukadoor`,
  `Aankoper`,
  `Verantwoordelijke klantendienst`,
  `Winkelmedewerker`,
  `Leidinggevende productie elektrische en elektronische materialen`,
  `Medewerker industriële afwerking`,
  `Regeltechnicus klimatisatie`,
  `Polyvalent podiumtechnicus`,
  `Verantwoordelijke planning en productiebeheer`,
  `Tuinaanlegger-groenbeheerder`,
  `Aansluiter van waterleidingen, rioleringen en warmtenetten`,
  `Tuinbouwmedewerker`,
  `Technicus PC- en kantoormateriaal`,
  `Insteller-bediener CNC werktuigmachines`,
  `Bankwerker`,
  `Netwerk engineer telecom`,
  `Eventmanager`,
  `Operator energetische en petrochemische installaties`,
  `Bekister-betonneerder`,
  `Promotiemedewerker toerisme`,
  `Kraanbestuurder`,
  `Koerier besteller`,
  `Digitaal drukker`,
  `Bijrijder`,
  `Verantwoordelijke industrieel onderhoud`,
  `Verantwoordelijke organisatie voor goederenvervoer over de weg`,
  `Magazijnbeheerder`,
  `Bestuurder van een rolbrug`,
  `Operator energetische en petrochemische installaties`,
  `Verantwoordelijke werving en opleiding`,
  `Autocarchauffeur`,
  `Meubelmaker`,
  `Procesoperator voedingsindustrie`,
  `Operator productie van stortklaar beton, cement, asfalt en granulaten`,
  `Boekhoudkundig assistent`,
  `Dispatcher personenvervoer over de weg`,
  `Operator CNC-gestuurde houtbewerkingsmachines`,
  `Productieoperator elektrische en elektronische componenten`,
  `Salesteam verantwoordelijke`,
  `Administratief en financieel verantwoordelijke`,
  `Customer experience manager`,
  `Monteur van staalbouwelementen`,
  `Beheerder back- en middle office financiële markten`,
  `Digital sales assistant`,
  `Schoonheidsspecialist`,
  `Keukenmedewerker`,
  `Bewakingsagent `,
  `Brandertechnicus`,
  `Brood- en banketbakker`,
  `Operator voorbereiding en bevoorrading weverij`,
  `Medewerker groen- en tuinbeheer en aanleg`,
  `Dakdekker schuine daken`,
  `Dakdekker platte daken`,
  `Bouwkundig tekenaar`,
  `Technicus veiligheid, hygiëne en leefmilieu`,
  `Beveiligingstechnicus`,
  `Bestuurder stapelaar-pallettruck`,
  `Dossierbeheerder Boekhouden`,
  `Fietshersteller`,
  `Technicus installatietechnieken`,
  `Werkplaatsschrijnwerker`,
  `Medewerker uitvaartdiensten`,
  `Hotelreceptionist`,
  `Technicus installatietechnieken`,
  `Marketingmanager`,
  `Onderzoeker exacte wetenschappen`,
  `Productiemedewerker prefab beton`,
  `Onderhoudsmecanicien van personenwagens en lichte bedrijfsvoertuigen`,
  `Vloerder-tegelzetter`,
  `Financieel analist`,
  `Kinderbegeleider baby's en peuters`,
  `Onderhoudsmecanicien in de industrie`,
  `Front-office medewerker in de financiële sector`,
  `Gevelrenoveerder-betonhersteller`,
  `Rigger-monteerder`,
  `Industrieel elektromecanicien`,
  `Digital marketeer`,
  `Monteur installatietechnieken`,
  `Technicus industriële elektriciteit`,
  `Schilder-decorateur`,
  `Monteur van metalen gevel- en dakelementen`,
  `Vertegenwoordiger B2B`,
  `Vertegenwoordiger B2C`,
  `Elektricien`,
  `Menger-bereider van grondstoffen`,
  `Barman`,
  `Ontginner vaste delfstoffen`,
  `Tuinbouwer`,
  `Projectleider bouw en openbare werken`,
  `Teamleader`,
  `Productiemedewerker textielproductielijn`,
  `Verpakkingsoperator`,
  `Operator montage en assemblage`,
  `Kwaliteitscontroleur textiel leder en confectie`,
  `Plaatser binnenschrijnwerk`,
  `Jurist`,
  `Onderhoudstechnicus liften`,
  `Schrijnwerker houtbouw`,
  `Ambachtelijk houtbewerker`,
  `TIG-lasser`,
  `Kok`,
  `Plaatser buitenschrijnwerk`,
  `Onderhoudsmedewerker gebouwen`,
  `Kapper`,
  `Machinaal houtbewerker`,
  `Vrachtwagenbestuurder`,
  `Chauffeur`,
  `Laborant industriële productie`,
  `Medisch laboratorium technoloog`,
  `Personeelsmedewerker`,
  `Logistiek assistent in zorginstellingen`,
  `Human resources manager`,
  `Management assistent`,
  `Financieel manager`,
  `Voeger`,
  `Technisch-administratief medewerker`,
  `Boekhouder-boekhouder fiscalist`,
  `Monteur bedrader elektronica`,
  `Mode- en textielontwerper`,
  `Elektrotechnisch installateur`,
  `Industrieel reiniger`,
  `Ingenieur algemeen`,
  `Contactcenter medewerker`,
  `Industrieel en logistiek planner`,
  `Productieoperator voedingsindustrie`,
  `Winkelverkoper`,
  `Industrieel schilder`,
  `Kwaliteitscontroleur mechanische en metalen constructies`,
  `Verantwoordelijke kwaliteitscontrole`,
  `Insteller-bediener van conventionele werktuigmachines`,
  `Logistiek verantwoordelijke`,
  `Dispatcher goederenvervoer over de weg`,
  `Reachtruckchauffeur`,
  `Expediteur`,
  `Procesoperator chemische en farmaceutische industrie`,
  `Verzekeringsadviseur`,
  `Planner goederenbehandeling`,
  `Reachtruckchauffeur met attest`,
  `Heftruckchauffeur`,
  `Productieoperator metaalbewerking`,
  `Wegenwerker`,
  `E-commerce manager`,
  `Communicatiedeskundige`,
  `Verantwoordelijke verkoopadministratie`,
  `Orderpicker`,
  `Commercieel medewerker`,
  `Bestuurder van bouwplaatsmachines`,
  `Productieoperator textielproductielijn`,
  `Werfbediener ruwbouw`,
  `Polyvalent administratief medewerker`,
  `Monteur-demonteur carrosserie`,
  `Slager`,
  `Halfautomaatlasser`,
  `Goederenbehandelaar in de haven`,
  `Student`,
  `Lasser`,
  `Productiemanager`,
  `Metselaar`,
  `Administratief medewerker onthaal`,
  `Productiemedewerker`,
  `Technicus onderzoek en ontwikkeling in elektriciteit en elektronica`,
  `Technicus ontwerper industriële automatisering`,
  `Interieurbouwer`,
  `Slachter`,
  `Productmanager`,
  `Projectmanager engineering`,
  `Operator algemeen`,
  `Acteur`,
  `Actuaris`,
  `Orthopedisch technoloog`,
] as const;

export type FunctionNode = (typeof functionNodes)[number];

export const functionOptions: {
  value: FunctionNode;
  labels: { language: 'nl' | 'fr' | 'en'; label: string }[];
}[] = [
  {
    value: `Charcutier`,
    labels: [
      { language: 'nl', label: `Charcutier` },
      { language: 'fr', label: `Charcutier` },
      { language: 'en', label: `Charcutier` },
    ],
  },

  {
    value: `Tandarts`,
    labels: [
      { language: 'nl', label: `Tandarts` },
      { language: 'fr', label: `Dentiste` },
      { language: 'en', label: `Dentist` },
    ],
  },

  {
    value: `Technoloog medische beeldvorming`,
    labels: [
      {
        language: 'nl',
        label: `Technoloog medische beeldvorming`,
      },
      { language: 'fr', label: `Technologue en imagerie médicale` },
      { language: 'en', label: `Medical imaging technologist` },
    ],
  },

  {
    value: `Onderzoeker humane wetenschappen`,
    labels: [
      {
        language: 'nl',
        label: `Onderzoeker humane wetenschappen`,
      },
      { language: 'fr', label: `Chercheur en sciences humaines` },
      { language: 'en', label: `Humanities researcher` },
    ],
  },

  {
    value: `Osteopaat chiropractor`,
    labels: [
      {
        language: 'nl',
        label: `Osteopaat chiropractor`,
      },
      { language: 'fr', label: `Chiropracteur ostéopathe` },
      { language: 'en', label: `Osteopath chiropractor` },
    ],
  },

  {
    value: `Kinesitherapeut`,
    labels: [
      {
        language: 'nl',
        label: `Kinesitherapeut`,
      },
      { language: 'fr', label: `Physiothérapeute` },
      { language: 'en', label: `Physiotherapist` },
    ],
  },

  {
    value: `Arts`,
    labels: [
      { language: 'nl', label: `Arts` },
      { language: 'fr', label: `Médecin` },
      { language: 'en', label: `Doctor` },
    ],
  },

  {
    value: `Beeld- en geluidsmonteur`,
    labels: [
      {
        language: 'nl',
        label: `Beeld- en geluidsmonteur`,
      },
      { language: 'fr', label: `Ingénieur image et son` },
      { language: 'en', label: `Image and sound engineer` },
    ],
  },

  {
    value: `Revisor`,
    labels: [
      { language: 'nl', label: `Revisor` },
      { language: 'fr', label: `Auditeur` },
      { language: 'en', label: `Auditor` },
    ],
  },

  {
    value: `Geluidstechnicus podium- en audiovisuele producties`,
    labels: [
      {
        language: 'nl',
        label: `Geluidstechnicus podium- en audiovisuele producties`,
      },
      {
        language: 'fr',
        label: `Ingénieur du son pour les productions scéniques et audiovisuelles`,
      },
      { language: 'en', label: `Sound engineer for stage and audiovisual productions` },
    ],
  },

  {
    value: `Productieverantwoordelijke podium/audiovisueel`,
    labels: [
      {
        language: 'nl',
        label: `Productieverantwoordelijke podium/audiovisueel`,
      },
      { language: 'fr', label: `Responsable de production scénique/audiovisuelle` },
      { language: 'en', label: `Stage/audiovisual production manager` },
    ],
  },

  {
    value: `Klinisch bioloog`,
    labels: [
      {
        language: 'nl',
        label: `Klinisch bioloog`,
      },
      { language: 'fr', label: `Biologiste clinicien` },
      { language: 'en', label: `Clinical biologist` },
    ],
  },

  {
    value: `Beeldopnametechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Beeldopnametechnicus`,
      },
      { language: 'fr', label: `Technicien en enregistrement d'images` },
      { language: 'en', label: `Image recording technician` },
    ],
  },

  {
    value: `Decorbouwer-rekwisiteur`,
    labels: [
      {
        language: 'nl',
        label: `Decorbouwer-rekwisiteur`,
      },
      { language: 'fr', label: `Définir les accessoires du constructeur` },
      { language: 'en', label: `Set builder-props` },
    ],
  },

  {
    value: `Costumier`,
    labels: [
      { language: 'nl', label: `Costumier` },
      { language: 'fr', label: `Costumier` },
      { language: 'en', label: `Costumier` },
    ],
  },

  {
    value: `Professioneel sportbeoefenaar`,
    labels: [
      {
        language: 'nl',
        label: `Professioneel sportbeoefenaar`,
      },
      { language: 'fr', label: `Sportif professionnel` },
      { language: 'en', label: `Professional sportsman` },
    ],
  },

  {
    value: `Circus- en variétéartiest`,
    labels: [
      {
        language: 'nl',
        label: `Circus- en variétéartiest`,
      },
      { language: 'fr', label: `Artiste de cirque et de variétés` },
      { language: 'en', label: `Circus and variety artist` },
    ],
  },

  {
    value: `Componist`,
    labels: [
      { language: 'nl', label: `Componist` },
      { language: 'fr', label: `Compositeur` },
      { language: 'en', label: `Composer` },
    ],
  },

  {
    value: `Zanger`,
    labels: [
      { language: 'nl', label: `Zanger` },
      { language: 'fr', label: `Chanteur` },
      { language: 'en', label: `Singer` },
    ],
  },

  {
    value: `Choreograaf`,
    labels: [
      { language: 'nl', label: `Choreograaf` },
      { language: 'fr', label: `Chorégraphe` },
      { language: 'en', label: `Choreographer` },
    ],
  },

  {
    value: `Danser`,
    labels: [
      { language: 'nl', label: `Danser` },
      { language: 'fr', label: `Danseur` },
      { language: 'en', label: `Dancer` },
    ],
  },

  {
    value: `Mannequin`,
    labels: [
      { language: 'nl', label: `Mannequin` },
      { language: 'fr', label: `Mannequin` },
      { language: 'en', label: `Mannequin` },
    ],
  },

  {
    value: `Model`,
    labels: [
      { language: 'nl', label: `Model` },
      { language: 'fr', label: `Mannequin` },
      { language: 'en', label: `Fashion model` },
    ],
  },

  {
    value: `Presentator`,
    labels: [
      { language: 'nl', label: `Presentator` },
      { language: 'fr', label: `Présentateur` },
      { language: 'en', label: `Presenter` },
    ],
  },

  {
    value: `DJ`,
    labels: [
      { language: 'nl', label: `DJ` },
      { language: 'fr', label: `DJ` },
      { language: 'en', label: `DJ` },
    ],
  },

  {
    value: `Medewerker openbare veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker openbare veiligheid`,
      },
      { language: 'fr', label: `Employé de la sécurité publique` },
      { language: 'en', label: `Public safety employee` },
    ],
  },

  {
    value: `Medewerker civiele veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker civiele veiligheid`,
      },
      { language: 'fr', label: `Employé de la sécurité civile` },
      { language: 'en', label: `Civil security employee` },
    ],
  },

  {
    value: `Leidinggevende openbare veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende openbare veiligheid`,
      },
      { language: 'fr', label: `Responsable de la sécurité publique` },
      { language: 'en', label: `Public safety manager` },
    ],
  },

  {
    value: `Medewerker defensie`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker defensie`,
      },
      { language: 'fr', label: `Employé de la Défense` },
      { language: 'en', label: `Defense employee` },
    ],
  },

  {
    value: `Lijkenbalsemer`,
    labels: [
      { language: 'nl', label: `Lijkenbalsemer` },
      { language: 'fr', label: `Embaumeur de corps` },
      { language: 'en', label: `Body embalmer` },
    ],
  },

  {
    value: `Privédetective`,
    labels: [
      { language: 'nl', label: `Privédetective` },
      { language: 'fr', label: `Détective privé` },
      { language: 'en', label: `Private detective` },
    ],
  },

  {
    value: `Leidinggevende privébewaking `,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende privébewaking `,
      },
      { language: 'fr', label: `Responsable de la sécurité privée` },
      { language: 'en', label: `Manager of private security` },
    ],
  },

  {
    value: `Toezichthouder van lokalen en gebouwen`,
    labels: [
      {
        language: 'nl',
        label: `Toezichthouder van lokalen en gebouwen`,
      },
      { language: 'fr', label: `Surveillant de locaux et d'immeubles` },
      { language: 'en', label: `Supervisor of premises and buildings` },
    ],
  },

  {
    value: `Verantwoordelijke eco-industriële onderneming`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke eco-industriële onderneming`,
      },
      { language: 'fr', label: `Entreprise éco-industrielle responsable` },
      { language: 'en', label: `Responsible eco-industrial company` },
    ],
  },

  {
    value: `Medewerker hygiëne en ongediertebestrijding`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker hygiëne en ongediertebestrijding`,
      },
      { language: 'fr', label: `Employé d'hygiène et de lutte antiparasitaire` },
      { language: 'en', label: `Hygiene and pest control employee` },
    ],
  },

  {
    value: `Leidinggevende milieuzorg en sanering`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende milieuzorg en sanering`,
      },
      { language: 'fr', label: `Responsable gestion environnementale et dépollution` },
      { language: 'en', label: `Environmental management and remediation manager` },
    ],
  },

  {
    value: `Leerkracht buitengewoon lager onderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht buitengewoon lager onderwijs`,
      },
      { language: 'fr', label: `Enseignante spécialisée en enseignement primaire` },
      { language: 'en', label: `Special primary education teacher` },
    ],
  },

  {
    value: `Uitgever`,
    labels: [
      { language: 'nl', label: `Uitgever` },
      { language: 'fr', label: `Éditeur` },
      { language: 'en', label: `Publisher` },
    ],
  },

  {
    value: `Leidinggevende civiele veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende civiele veiligheid`,
      },
      { language: 'fr', label: `Responsable de la sécurité civile` },
      { language: 'en', label: `Civil security manager` },
    ],
  },

  {
    value: `Filiaalhouder verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Filiaalhouder verzekeringen`,
      },
      { language: 'fr', label: `Responsable de branche assurance` },
      { language: 'en', label: `Insurance branch manager` },
    ],
  },

  {
    value: `Tolk`,
    labels: [
      { language: 'nl', label: `Tolk` },
      { language: 'fr', label: `Interprète` },
      { language: 'en', label: `Interpreter` },
    ],
  },

  {
    value: `Procesoperator drukken in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator drukken in de printmedia`,
      },
      { language: 'fr', label: `Opérateur de processus impression dans les médias imprimés` },
      { language: 'en', label: `Process operator printing in the print media` },
    ],
  },

  {
    value: `Voedingsinspecteur`,
    labels: [
      {
        language: 'nl',
        label: `Voedingsinspecteur`,
      },
      { language: 'fr', label: `Inspecteur des aliments` },
      { language: 'en', label: `Food inspector` },
    ],
  },

  {
    value: `Cultuurmanager`,
    labels: [
      { language: 'nl', label: `Cultuurmanager` },
      { language: 'fr', label: `Responsable culturel` },
      { language: 'en', label: `Cultural manager` },
    ],
  },

  {
    value: `Productieoperator drukafwerking in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator drukafwerking in de printmedia`,
      },
      {
        language: 'fr',
        label: `Opérateur de production finition d'impression dans les médias imprimés`,
      },
      { language: 'en', label: `Production operator print finishing in the print media` },
    ],
  },

  {
    value: `Leidinggevende printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende printmedia`,
      },
      { language: 'fr', label: `Gestionnaire de médias imprimés` },
      { language: 'en', label: `Print media manager` },
    ],
  },

  {
    value: `Corrector`,
    labels: [
      { language: 'nl', label: `Corrector` },
      { language: 'fr', label: `Correcteur` },
      { language: 'en', label: `Corrector` },
    ],
  },

  {
    value: `Procesoperator hout`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator hout`,
      },
      { language: 'fr', label: `Opérateur de transformation bois` },
      { language: 'en', label: `Process operator wood` },
    ],
  },

  {
    value: `Print en sign medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Print en sign medewerker`,
      },
      { language: 'fr', label: `Imprimer et signer l'employé` },
      { language: 'en', label: `Print and sign employee` },
    ],
  },

  {
    value: `Etalateur-decorateur`,
    labels: [
      {
        language: 'nl',
        label: `Etalateur-decorateur`,
      },
      { language: 'fr', label: `Décorateur de vitrines` },
      { language: 'en', label: `Window dresser-decorator` },
    ],
  },

  {
    value: `Verantwoordelijke publiciteitscampagnes`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke publiciteitscampagnes`,
      },
      { language: 'fr', label: `Campagnes publicitaires responsables` },
      { language: 'en', label: `Responsible publicity campaigns` },
    ],
  },

  {
    value: `Relatie- en gezinsbemiddelaar`,
    labels: [
      {
        language: 'nl',
        label: `Relatie- en gezinsbemiddelaar`,
      },
      { language: 'fr', label: `Médiatrice relationnelle et familiale` },
      { language: 'en', label: `Relationship and family mediator` },
    ],
  },

  {
    value: `Ruitenwasser`,
    labels: [
      { language: 'nl', label: `Ruitenwasser` },
      { language: 'fr', label: `Laveur de vitre` },
      { language: 'en', label: `Window cleaner` },
    ],
  },

  {
    value: `Psycholoog`,
    labels: [
      { language: 'nl', label: `Psycholoog` },
      { language: 'fr', label: `Psychologue` },
      { language: 'en', label: `Psychologist` },
    ],
  },

  {
    value: `Psychomotorisch en creatief therapeut`,
    labels: [
      {
        language: 'nl',
        label: `Psychomotorisch en creatief therapeut`,
      },
      { language: 'fr', label: `Psychomotricienne et thérapeute créative` },
      { language: 'en', label: `Psychomotor and creative therapist` },
    ],
  },

  {
    value: `Voogd voor begunstigden van een juridische beschermmaatregel`,
    labels: [
      {
        language: 'nl',
        label: `Voogd voor begunstigden van een juridische beschermmaatregel`,
      },
      { language: 'fr', label: `Tuteur des bénéficiaires d'une mesure de protection juridique` },
      { language: 'en', label: `Guardian for beneficiaries of a legal protection measure` },
    ],
  },

  {
    value: `Ervaringsdeskundige armoede of verslavingsproblematieken`,
    labels: [
      {
        language: 'nl',
        label: `Ervaringsdeskundige armoede of verslavingsproblematieken`,
      },
      {
        language: 'fr',
        label: `Expert expérimenté sur les problèmes de pauvreté ou de dépendance`,
      },
      { language: 'en', label: `Experienced expert on poverty or addiction problems` },
    ],
  },

  {
    value: `Sociaal-cultureel begeleider`,
    labels: [
      {
        language: 'nl',
        label: `Sociaal-cultureel begeleider`,
      },
      { language: 'fr', label: `Conseillère socioculturelle` },
      { language: 'en', label: `Socio-cultural counselor` },
    ],
  },

  {
    value: `Gemeenschapswacht`,
    labels: [
      {
        language: 'nl',
        label: `Gemeenschapswacht`,
      },
      { language: 'fr', label: `Surveillance communautaire` },
      { language: 'en', label: `Community watch` },
    ],
  },

  {
    value: `Coördinator vrijwilligerswerk`,
    labels: [
      {
        language: 'nl',
        label: `Coördinator vrijwilligerswerk`,
      },
      { language: 'fr', label: `Coordonnatrice des bénévoles` },
      { language: 'en', label: `Volunteer coordinator` },
    ],
  },

  {
    value: `Sociale en familiale interveniënt`,
    labels: [
      {
        language: 'nl',
        label: `Sociale en familiale interveniënt`,
      },
      { language: 'fr', label: `Intervenante sociale et familiale` },
      { language: 'en', label: `Social and family intervener` },
    ],
  },

  {
    value: `Beleidsverantwoordelijke overheidsdienst`,
    labels: [
      {
        language: 'nl',
        label: `Beleidsverantwoordelijke overheidsdienst`,
      },
      { language: 'fr', label: `Service gouvernemental responsable de la politique` },
      { language: 'en', label: `Government service responsible for policy` },
    ],
  },

  {
    value: `Adviseur volksgezondheid`,
    labels: [
      {
        language: 'nl',
        label: `Adviseur volksgezondheid`,
      },
      { language: 'fr', label: `Conseiller en santé publique` },
      { language: 'en', label: `Public health advisor` },
    ],
  },

  {
    value: `Verantwoordelijke gezondheids-, sociale of penitentiaire instelling`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke gezondheids-, sociale of penitentiaire instelling`,
      },
      { language: 'fr', label: `Établissement sanitaire, social ou pénitentiaire responsable` },
      { language: 'en', label: `Responsible health, social or penitentiary institution` },
    ],
  },

  {
    value: `Beleidsuitvoerend medewerker overheidsdienst`,
    labels: [
      {
        language: 'nl',
        label: `Beleidsuitvoerend medewerker overheidsdienst`,
      },
      { language: 'fr', label: `Employé du service gouvernemental chargé des politiques` },
      { language: 'en', label: `Policy executive government service employee` },
    ],
  },

  {
    value: `Controleur sociale inspectie`,
    labels: [
      {
        language: 'nl',
        label: `Controleur sociale inspectie`,
      },
      { language: 'fr', label: `Inspecteur de l'inspection sociale` },
      { language: 'en', label: `Social inspection inspector` },
    ],
  },

  {
    value: `Medewerker openbare schatkist`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker openbare schatkist`,
      },
      { language: 'fr', label: `Employé du trésor public` },
      { language: 'en', label: `Public treasury employee` },
    ],
  },

  {
    value: `Controleur economische inspectie`,
    labels: [
      {
        language: 'nl',
        label: `Controleur economische inspectie`,
      },
      { language: 'fr', label: `Inspecteur de l'inspection économique` },
      { language: 'en', label: `Economic inspection inspector` },
    ],
  },

  {
    value: `Erfgoedkundige`,
    labels: [
      { language: 'nl', label: `Erfgoedkundige` },
      { language: 'fr', label: `Expert du patrimoine` },
      { language: 'en', label: `Heritage expert` },
    ],
  },

  {
    value: `Bibliothecaris-archivaris`,
    labels: [
      {
        language: 'nl',
        label: `Bibliothecaris-archivaris`,
      },
      { language: 'fr', label: `Bibliothécaire-archiviste` },
      { language: 'en', label: `Librarian-archivist` },
    ],
  },

  {
    value: `Archiefmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Archiefmedewerker`,
      },
      { language: 'fr', label: `Employé des archives` },
      { language: 'en', label: `Archive employee` },
    ],
  },

  {
    value: `Bibliotheekdeskundige`,
    labels: [
      {
        language: 'nl',
        label: `Bibliotheekdeskundige`,
      },
      { language: 'fr', label: `Expert en bibliothèque` },
      { language: 'en', label: `Library expert` },
    ],
  },

  {
    value: `Archiefdeskundige`,
    labels: [
      {
        language: 'nl',
        label: `Archiefdeskundige`,
      },
      { language: 'fr', label: `Expert en archives` },
      { language: 'en', label: `Archival expert` },
    ],
  },

  {
    value: `Medewerker lokale ontwikkeling`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker lokale ontwikkeling`,
      },
      { language: 'fr', label: `Chargée de développement local` },
      { language: 'en', label: `Local development employee` },
    ],
  },

  {
    value: `Jurist in een openbaar ambt of met een mandaat`,
    labels: [
      {
        language: 'nl',
        label: `Jurist in een openbaar ambt of met een mandaat`,
      },
      { language: 'fr', label: `Avocat dans une fonction publique ou avec mandat` },
      { language: 'en', label: `Lawyer in a public office or with a mandate` },
    ],
  },

  {
    value: `Magistraat`,
    labels: [
      { language: 'nl', label: `Magistraat` },
      { language: 'fr', label: `Magistrat` },
      { language: 'en', label: `Magistrate` },
    ],
  },

  {
    value: `Bemiddelaar welzijn`,
    labels: [
      {
        language: 'nl',
        label: `Bemiddelaar welzijn`,
      },
      { language: 'fr', label: `Médiateur du bien-être` },
      { language: 'en', label: `Well-being mediator` },
    ],
  },

  {
    value: `Procesoperator drukafwerking in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator drukafwerking in de printmedia`,
      },
      {
        language: 'fr',
        label: `Opérateur de processus de finition d'impression dans les supports d'impression`,
      },
      { language: 'en', label: `Process operator print finishing in the print media` },
    ],
  },

  {
    value: `Leerkracht buitengewoon secundair onderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht buitengewoon secundair onderwijs`,
      },
      { language: 'fr', label: `Professeur d'enseignement secondaire spécialisé` },
      { language: 'en', label: `Special secondary education teacher` },
    ],
  },

  {
    value: `Leerkracht deeltijds kunstonderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht deeltijds kunstonderwijs`,
      },
      { language: 'fr', label: `Professeur d'art à temps partiel` },
      { language: 'en', label: `Part-time art teacher` },
    ],
  },

  {
    value: `Leidinggevende onderwijsinstelling`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende onderwijsinstelling`,
      },
      { language: 'fr', label: `Établissement d'enseignement de premier plan` },
      { language: 'en', label: `Leading educational institution` },
    ],
  },

  {
    value: `Opleidingsadviseur`,
    labels: [
      {
        language: 'nl',
        label: `Opleidingsadviseur`,
      },
      { language: 'fr', label: `Conseiller en formation` },
      { language: 'en', label: `Training advisor` },
    ],
  },

  {
    value: `Loopbaanbegeleider`,
    labels: [
      {
        language: 'nl',
        label: `Loopbaanbegeleider`,
      },
      { language: 'fr', label: `Conseiller d'orientation` },
      { language: 'en', label: `Career counselor` },
    ],
  },

  {
    value: `Opvoeder in een onderwijsinstelling`,
    labels: [
      {
        language: 'nl',
        label: `Opvoeder in een onderwijsinstelling`,
      },
      { language: 'fr', label: `Éducateur dans un établissement d'enseignement` },
      { language: 'en', label: `Educator in an educational institution` },
    ],
  },

  {
    value: `Vaarinstructeur`,
    labels: [
      {
        language: 'nl',
        label: `Vaarinstructeur`,
      },
      { language: 'fr', label: `Moniteur de voile` },
      { language: 'en', label: `Sailing instructor` },
    ],
  },

  {
    value: `Leerkracht buitengewoon kleuteronderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht buitengewoon kleuteronderwijs`,
      },
      { language: 'fr', label: `Enseignante en éducation préscolaire spécialisée` },
      { language: 'en', label: `Teacher of special pre-school education` },
    ],
  },

  {
    value: `Ontwikkelaar verzekeringsproducten`,
    labels: [
      {
        language: 'nl',
        label: `Ontwikkelaar verzekeringsproducten`,
      },
      { language: 'fr', label: `Développeur de produits d'assurance` },
      { language: 'en', label: `Insurance product developer` },
    ],
  },

  {
    value: `Verzekeringsmakelaar`,
    labels: [
      {
        language: 'nl',
        label: `Verzekeringsmakelaar`,
      },
      { language: 'fr', label: `Courtier d'assurance` },
      { language: 'en', label: `Insurance broker` },
    ],
  },

  {
    value: `Onderschrijver verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Onderschrijver verzekeringen`,
      },
      { language: 'fr', label: `Souscripteur d'assurance` },
      { language: 'en', label: `Insurance underwriter` },
    ],
  },

  {
    value: `Hoogleraar aan een universiteit`,
    labels: [
      {
        language: 'nl',
        label: `Hoogleraar aan een universiteit`,
      },
      { language: 'fr', label: `Professeur dans une université` },
      { language: 'en', label: `Professor at a university` },
    ],
  },

  {
    value: `Adviseur kredieten`,
    labels: [
      {
        language: 'nl',
        label: `Adviseur kredieten`,
      },
      { language: 'fr', label: `Conseiller en crédit` },
      { language: 'en', label: `Credit advisor` },
    ],
  },

  {
    value: `Ontwikkelaar financiële producten`,
    labels: [
      {
        language: 'nl',
        label: `Ontwikkelaar financiële producten`,
      },
      { language: 'fr', label: `Développeur de produits financiers` },
      { language: 'en', label: `Developer of financial products` },
    ],
  },

  {
    value: `Kantoorhouder bankfiliaal`,
    labels: [
      {
        language: 'nl',
        label: `Kantoorhouder bankfiliaal`,
      },
      { language: 'fr', label: `Responsable d'agence bancaire` },
      { language: 'en', label: `Bank branch office manager` },
    ],
  },

  {
    value: `Rentmeester`,
    labels: [
      { language: 'nl', label: `Rentmeester` },
      { language: 'fr', label: `Intendant` },
      { language: 'en', label: `Steward` },
    ],
  },

  {
    value: `Directeur van een grote organisatie`,
    labels: [
      {
        language: 'nl',
        label: `Directeur van een grote organisatie`,
      },
      { language: 'fr', label: `Directeur d'une grande organisation` },
      { language: 'en', label: `Director of a large organization` },
    ],
  },

  {
    value: `Verantwoordelijke ICT`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke ICT`,
      },
      { language: 'fr', label: `Responsable informatique` },
      { language: 'en', label: `Responsible IT` },
    ],
  },

  {
    value: `Verantwoordelijke enquêtes`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke enquêtes`,
      },
      { language: 'fr', label: `Enquêtes responsables` },
      { language: 'en', label: `Responsible surveys` },
    ],
  },

  {
    value: `Agent financiële markten`,
    labels: [
      {
        language: 'nl',
        label: `Agent financiële markten`,
      },
      { language: 'fr', label: `Agent des marchés financiers` },
      { language: 'en', label: `Financial markets agent` },
    ],
  },

  {
    value: `Social media manager`,
    labels: [
      {
        language: 'nl',
        label: `Social media manager`,
      },
      { language: 'fr', label: `Gestionnaire des médias sociaux` },
      { language: 'en', label: `Social media manager` },
    ],
  },

  {
    value: `Analist communicatie- en informatiesystemen defensie-veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Analist communicatie- en informatiesystemen defensie-veiligheid`,
      },
      {
        language: 'fr',
        label: `Analyste des communications et des systèmes d'information en matière de sécurité de la défense`,
      },
      { language: 'en', label: `Defense security communications and information systems analyst` },
    ],
  },

  {
    value: `Meteoroloog`,
    labels: [
      { language: 'nl', label: `Meteoroloog` },
      { language: 'fr', label: `Météorologue` },
      { language: 'en', label: `Meteorologist` },
    ],
  },

  {
    value: `Expert geografische informatiesystemen`,
    labels: [
      {
        language: 'nl',
        label: `Expert geografische informatiesystemen`,
      },
      { language: 'fr', label: `Expert en systèmes d'information géographique` },
      { language: 'en', label: `Geographic information systems expert` },
    ],
  },

  {
    value: `Bodemonderzoeker`,
    labels: [
      {
        language: 'nl',
        label: `Bodemonderzoeker`,
      },
      { language: 'fr', label: `Chercheur en sols` },
      { language: 'en', label: `Soil researcher` },
    ],
  },

  {
    value: `Technicus studiebureau bouw`,
    labels: [
      {
        language: 'nl',
        label: `Technicus studiebureau bouw`,
      },
      { language: 'fr', label: `Technicien de bureau d'ingénierie en construction` },
      { language: 'en', label: `Construction engineering office technician` },
    ],
  },

  {
    value: `Landmeter`,
    labels: [
      { language: 'nl', label: `Landmeter` },
      { language: 'fr', label: `Arpenteur` },
      { language: 'en', label: `Surveyor` },
    ],
  },

  {
    value: `EPB-verslaggever`,
    labels: [
      {
        language: 'nl',
        label: `EPB-verslaggever`,
      },
      { language: 'fr', label: `Journaliste PEB` },
      { language: 'en', label: `EPB reporter` },
    ],
  },

  {
    value: `Software tester`,
    labels: [
      {
        language: 'nl',
        label: `Software tester`,
      },
      { language: 'fr', label: `Testeur de logiciels` },
      { language: 'en', label: `Software tester` },
    ],
  },

  {
    value: `Verantwoordelijke ontginningen`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke ontginningen`,
      },
      { language: 'fr', label: `Des extractions responsables` },
      { language: 'en', label: `Responsible extractions` },
    ],
  },

  {
    value: `Bediener machines verticale boringen`,
    labels: [
      {
        language: 'nl',
        label: `Bediener machines verticale boringen`,
      },
      { language: 'fr', label: `Opérateur de perceuses verticales` },
      { language: 'en', label: `Operator of vertical drilling machines` },
    ],
  },

  {
    value: `Bediener machines horizontale boringen`,
    labels: [
      {
        language: 'nl',
        label: `Bediener machines horizontale boringen`,
      },
      { language: 'fr', label: `Opérateur de perceuses horizontales` },
      { language: 'en', label: `Operator of horizontal drilling machines` },
    ],
  },

  {
    value: `Ontginner gassen en vloeistoffen`,
    labels: [
      {
        language: 'nl',
        label: `Ontginner gassen en vloeistoffen`,
      },
      { language: 'fr', label: `Extracteur de gaz et de liquides` },
      { language: 'en', label: `Extractor of gases and liquids` },
    ],
  },

  {
    value: `Verantwoordelijke ontginningen`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke ontginningen`,
      },
      { language: 'fr', label: `Des extractions responsables` },
      { language: 'en', label: `Responsible extractions` },
    ],
  },

  {
    value: `Trappenmaker`,
    labels: [
      { language: 'nl', label: `Trappenmaker` },
      { language: 'fr', label: `Constructeur d'escaliers` },
      { language: 'en', label: `Staircase maker` },
    ],
  },

  {
    value: `Scheepstimmerman`,
    labels: [
      {
        language: 'nl',
        label: `Scheepstimmerman`,
      },
      { language: 'fr', label: `Charpentier` },
      { language: 'en', label: `Shipwright` },
    ],
  },

  {
    value: `Installateur van datacommunicatienetwerken`,
    labels: [
      {
        language: 'nl',
        label: `Installateur van datacommunicatienetwerken`,
      },
      { language: 'fr', label: `Installateur de réseaux de communication de données` },
      { language: 'en', label: `Installer of data communication networks` },
    ],
  },

  {
    value: `Glaswerker`,
    labels: [
      { language: 'nl', label: `Glaswerker` },
      { language: 'fr', label: `Verrier` },
      { language: 'en', label: `Glassworker` },
    ],
  },

  {
    value: `Slotenmaker`,
    labels: [
      { language: 'nl', label: `Slotenmaker` },
      { language: 'fr', label: `Serrurier` },
      { language: 'en', label: `Locksmith` },
    ],
  },

  {
    value: `Plaatser van soepele vloerbekledingen`,
    labels: [
      {
        language: 'nl',
        label: `Plaatser van soepele vloerbekledingen`,
      },
      { language: 'fr', label: `Installateur de revêtements de sol souples` },
      { language: 'en', label: `Installer of flexible floor coverings` },
    ],
  },

  {
    value: `Schrijver`,
    labels: [
      { language: 'nl', label: `Schrijver` },
      { language: 'fr', label: `Écrivain` },
      { language: 'en', label: `Writer` },
    ],
  },

  {
    value: `Industrieel isolatiewerker`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel isolatiewerker`,
      },
      { language: 'fr', label: `Ouvrier en isolation industrielle` },
      { language: 'en', label: `Industrial insulation worker` },
    ],
  },

  {
    value: `Technicus hernieuwbare energietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Technicus hernieuwbare energietechnieken`,
      },
      { language: 'fr', label: `Technicien en technologie des énergies renouvelables` },
      { language: 'en', label: `Renewable energy technology technician` },
    ],
  },

  {
    value: `Rijinstructeur`,
    labels: [
      { language: 'nl', label: `Rijinstructeur` },
      { language: 'fr', label: `Moniteur d'auto-école` },
      { language: 'en', label: `Driving instructor` },
    ],
  },

  {
    value: `Kledingretoucheur`,
    labels: [
      {
        language: 'nl',
        label: `Kledingretoucheur`,
      },
      { language: 'fr', label: `Retoucheur de vêtements` },
      { language: 'en', label: `Clothing retoucher` },
    ],
  },

  {
    value: `Dekvloerlegger`,
    labels: [
      { language: 'nl', label: `Dekvloerlegger` },
      { language: 'fr', label: `Couche de chape` },
      { language: 'en', label: `Screed layer` },
    ],
  },

  {
    value: `Rioollegger`,
    labels: [
      { language: 'nl', label: `Rioollegger` },
      { language: 'fr', label: `Couche d'égout` },
      { language: 'en', label: `Sewer layer` },
    ],
  },

  {
    value: `Plaatser van houten vloerbedekking`,
    labels: [
      {
        language: 'nl',
        label: `Plaatser van houten vloerbedekking`,
      },
      { language: 'fr', label: `Poseur de revêtements de sol en bois` },
      { language: 'en', label: `Installer of wooden floor coverings` },
    ],
  },

  {
    value: `Monitor-begeleider in de sociale economie`,
    labels: [
      {
        language: 'nl',
        label: `Monitor-begeleider in de sociale economie`,
      },
      { language: 'fr', label: `Moniteur-superviseur en économie sociale` },
      { language: 'en', label: `Monitor-supervisor in the social economy` },
    ],
  },

  {
    value: `Websitebeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Websitebeheerder`,
      },
      { language: 'fr', label: `Administrateur du site Web` },
      { language: 'en', label: `Website administrator` },
    ],
  },

  {
    value: `Productiemedewerker drukafwerking in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker drukafwerking in de printmedia`,
      },
      {
        language: 'fr',
        label: `Employé de production, finition d'impression dans les médias imprimés`,
      },
      { language: 'en', label: `Production employee print finishing in print media` },
    ],
  },

  {
    value: `Medewerker kuuroord`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker kuuroord`,
      },
      { language: 'fr', label: `Employé de spa` },
      { language: 'en', label: `Spa employee` },
    ],
  },

  {
    value: `Zandvormmaker`,
    labels: [
      { language: 'nl', label: `Zandvormmaker` },
      { language: 'fr', label: `Mouliste en sable` },
      { language: 'en', label: `Sand mold maker` },
    ],
  },

  {
    value: `Wikkelaar van elektrische spoelen`,
    labels: [
      {
        language: 'nl',
        label: `Wikkelaar van elektrische spoelen`,
      },
      { language: 'fr', label: `Enrouleur de bobine électrique` },
      { language: 'en', label: `Electric coil winder` },
    ],
  },

  {
    value: `Journalist-redacteur`,
    labels: [
      {
        language: 'nl',
        label: `Journalist-redacteur`,
      },
      { language: 'fr', label: `Journaliste-rédacteur` },
      { language: 'en', label: `Journalist-editor` },
    ],
  },

  {
    value: `Tufter`,
    labels: [
      { language: 'nl', label: `Tufter` },
      { language: 'fr', label: `Tufteur` },
      { language: 'en', label: `Tufter` },
    ],
  },

  {
    value: `Wever`,
    labels: [
      { language: 'nl', label: `Wever` },
      { language: 'fr', label: `Tisserand` },
      { language: 'en', label: `Weaver` },
    ],
  },

  {
    value: `Medewerker assemblage houtindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker assemblage houtindustrie`,
      },
      { language: 'fr', label: `Ouvrier de montage dans l'industrie du bois` },
      { language: 'en', label: `Wood industry assembly worker` },
    ],
  },

  {
    value: `Technisch redacteur`,
    labels: [
      {
        language: 'nl',
        label: `Technisch redacteur`,
      },
      { language: 'fr', label: `Rédacteur technique` },
      { language: 'en', label: `Technical editor` },
    ],
  },

  {
    value: `Orthoptist-optometrist`,
    labels: [
      {
        language: 'nl',
        label: `Orthoptist-optometrist`,
      },
      { language: 'fr', label: `Orthoptiste-optométriste` },
      { language: 'en', label: `Orthoptist-optometrist` },
    ],
  },

  {
    value: `Werkvoorbereider hout`,
    labels: [
      {
        language: 'nl',
        label: `Werkvoorbereider hout`,
      },
      { language: 'fr', label: `Planificateur de travail du bois` },
      { language: 'en', label: `Wood work planner` },
    ],
  },

  {
    value: `Opleidingscoördinator`,
    labels: [
      {
        language: 'nl',
        label: `Opleidingscoördinator`,
      },
      { language: 'fr', label: `Coordinateur de formation` },
      { language: 'en', label: `Training coordinator` },
    ],
  },

  {
    value: `Landschapsarchitect`,
    labels: [
      {
        language: 'nl',
        label: `Landschapsarchitect`,
      },
      { language: 'fr', label: `Architecte paysagiste` },
      { language: 'en', label: `Landscape architect` },
    ],
  },

  {
    value: `Uitbater café-brasserie`,
    labels: [
      {
        language: 'nl',
        label: `Uitbater café-brasserie`,
      },
      { language: 'fr', label: `Propriétaire d'un café-brasserie` },
      { language: 'en', label: `Owner of café-brasserie` },
    ],
  },

  {
    value: `Fotograaf`,
    labels: [
      { language: 'nl', label: `Fotograaf` },
      { language: 'fr', label: `Photographe` },
      { language: 'en', label: `Photographer` },
    ],
  },

  {
    value: `Industrieel vormgever`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel vormgever`,
      },
      { language: 'fr', label: `Designer industriel` },
      { language: 'en', label: `Industrial designer` },
    ],
  },

  {
    value: `Muzikant`,
    labels: [
      { language: 'nl', label: `Muzikant` },
      { language: 'fr', label: `Musicien` },
      { language: 'en', label: `Musician` },
    ],
  },

  {
    value: `Hulpkelner`,
    labels: [
      { language: 'nl', label: `Hulpkelner` },
      { language: 'fr', label: `Serveur` },
      { language: 'en', label: `Busboy` },
    ],
  },

  {
    value: `Technicus kleurstoffen`,
    labels: [
      {
        language: 'nl',
        label: `Technicus kleurstoffen`,
      },
      { language: 'fr', label: `Teintures techniques` },
      { language: 'en', label: `Technician dyes` },
    ],
  },

  {
    value: `Regisseur podiumkunsten`,
    labels: [
      {
        language: 'nl',
        label: `Regisseur podiumkunsten`,
      },
      { language: 'fr', label: `Directeur des arts du spectacle` },
      { language: 'en', label: `Performing arts director` },
    ],
  },

  {
    value: `Agent van artiesten, modellen en atleten`,
    labels: [
      {
        language: 'nl',
        label: `Agent van artiesten, modellen en atleten`,
      },
      { language: 'fr', label: `Agent d'artistes, mannequins et sportifs` },
      { language: 'en', label: `Agent of artists, models and athletes` },
    ],
  },

  {
    value: `Regisseur audiovisuele producties`,
    labels: [
      {
        language: 'nl',
        label: `Regisseur audiovisuele producties`,
      },
      { language: 'fr', label: `Directeur de productions audiovisuelles` },
      { language: 'en', label: `Director of audiovisual productions` },
    ],
  },

  {
    value: `Figurant`,
    labels: [
      { language: 'nl', label: `Figurant` },
      { language: 'fr', label: `Supplémentaire` },
      { language: 'en', label: `Extra` },
    ],
  },

  {
    value: `Hulpverlener-ambulancier`,
    labels: [
      {
        language: 'nl',
        label: `Hulpverlener-ambulancier`,
      },
      { language: 'fr', label: `Paramédical-paramédical` },
      { language: 'en', label: `Paramedic-paramedic` },
    ],
  },

  {
    value: `Audioloog audicien`,
    labels: [
      {
        language: 'nl',
        label: `Audioloog audicien`,
      },
      { language: 'fr', label: `Audiologiste professionnel de l'audition` },
      { language: 'en', label: `Audiologist hearing care professional` },
    ],
  },

  {
    value: `Dentaaltechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Dentaaltechnicus`,
      },
      { language: 'fr', label: `Technicien dentaire` },
      { language: 'en', label: `Dental technician` },
    ],
  },

  {
    value: `Vroedkundige`,
    labels: [
      { language: 'nl', label: `Vroedkundige` },
      { language: 'fr', label: `Sage-femme` },
      { language: 'en', label: `Midwife` },
    ],
  },

  {
    value: `Kamerjongen-Kamermeisje`,
    labels: [
      {
        language: 'nl',
        label: `Kamerjongen-Kamermeisje`,
      },
      { language: 'fr', label: `Garçon de chambre-femme de chambre` },
      { language: 'en', label: `Chamber boy-chambermaid` },
    ],
  },

  {
    value: `Mondhygiënist`,
    labels: [
      { language: 'nl', label: `Mondhygiënist` },
      { language: 'fr', label: `Hygiéniste dentaire` },
      { language: 'en', label: `Dental hygienist` },
    ],
  },

  {
    value: `Fitnessbegeleider`,
    labels: [
      {
        language: 'nl',
        label: `Fitnessbegeleider`,
      },
      { language: 'fr', label: `Superviseur de conditionnement physique` },
      { language: 'en', label: `Fitness supervisor` },
    ],
  },

  {
    value: `Begeleider culturele en recreatieve activiteiten`,
    labels: [
      {
        language: 'nl',
        label: `Begeleider culturele en recreatieve activiteiten`,
      },
      { language: 'fr', label: `Superviseur des activités culturelles et récréatives` },
      { language: 'en', label: `Supervisor of cultural and recreational activities` },
    ],
  },

  {
    value: `Podoloog`,
    labels: [
      { language: 'nl', label: `Podoloog` },
      { language: 'fr', label: `Podologue` },
      { language: 'en', label: `Podiatrist` },
    ],
  },

  {
    value: `Orthopedisch technoloog`,
    labels: [
      {
        language: 'nl',
        label: `Orthopedisch technoloog`,
      },
      { language: 'fr', label: `Technologue orthopédiste` },
      { language: 'en', label: `Orthopedic technologist` },
    ],
  },

  {
    value: `Psychomotorisch en creatief therapeut`,
    labels: [
      {
        language: 'nl',
        label: `Psychomotorisch en creatief therapeut`,
      },
      { language: 'fr', label: `Psychomotricienne et thérapeute créative` },
      { language: 'en', label: `Psychomotor and creative therapist` },
    ],
  },

  {
    value: `Reisagent`,
    labels: [
      { language: 'nl', label: `Reisagent` },
      { language: 'fr', label: `Agent de voyage` },
      { language: 'en', label: `Travel agent` },
    ],
  },

  {
    value: `Chocolatier-ijsbereider`,
    labels: [
      {
        language: 'nl',
        label: `Chocolatier-ijsbereider`,
      },
      { language: 'fr', label: `Sorbetière chocolatière` },
      { language: 'en', label: `Chocolatier ice cream maker` },
    ],
  },

  {
    value: `Manicure-pedicure`,
    labels: [
      {
        language: 'nl',
        label: `Manicure-pedicure`,
      },
      { language: 'fr', label: `Manucure pédicure` },
      { language: 'en', label: `Manicure pedicure` },
    ],
  },

  {
    value: `Visagist`,
    labels: [
      { language: 'nl', label: `Visagist` },
      { language: 'fr', label: `Maquilleur` },
      { language: 'en', label: `Make-up artist` },
    ],
  },

  {
    value: `Masseur`,
    labels: [
      { language: 'nl', label: `Masseur` },
      { language: 'fr', label: `Masseur` },
      { language: 'en', label: `Masseur` },
    ],
  },

  {
    value: `Piercer-tatoeëerder`,
    labels: [
      {
        language: 'nl',
        label: `Piercer-tatoeëerder`,
      },
      { language: 'fr', label: `Tatoueur perceur` },
      { language: 'en', label: `Piercer tattoo artist` },
    ],
  },

  {
    value: `Kapper-salonbeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Kapper-salonbeheerder`,
      },
      { language: 'fr', label: `Responsable salon de coiffure` },
      { language: 'en', label: `Hairdresser salon manager` },
    ],
  },

  {
    value: `Antiquair`,
    labels: [
      { language: 'nl', label: `Antiquair` },
      { language: 'fr', label: `Antiquaire` },
      { language: 'en', label: `Antique dealer` },
    ],
  },

  {
    value: `Galeriehouder`,
    labels: [
      { language: 'nl', label: `Galeriehouder` },
      { language: 'fr', label: `Propriétaire de la galerie` },
      { language: 'en', label: `Gallery owner` },
    ],
  },

  {
    value: `Verhuurder van gereedschappen en machines, auto's en vrijetijdsmaterieel`,
    labels: [
      {
        language: 'nl',
        label: `Verhuurder van gereedschappen en machines, auto's en vrijetijdsmaterieel`,
      },
      {
        language: 'fr',
        label: `Entreprise de location d'outils et de machines, de voitures et de matériel de loisirs`,
      },
      { language: 'en', label: `Rental company of tools and machines, cars and leisure equipment` },
    ],
  },

  {
    value: `Maître d'hôtel`,
    labels: [
      { language: 'nl', label: `Maître d'hôtel` },
      { language: 'fr', label: `Maître d'hôtel` },
      { language: 'en', label: `Maitre d'hôtel` },
    ],
  },

  {
    value: `Medisch afgevaardigde`,
    labels: [
      {
        language: 'nl',
        label: `Medisch afgevaardigde`,
      },
      { language: 'fr', label: `Délégué médical` },
      { language: 'en', label: `Medical delegate` },
    ],
  },

  {
    value: `Demonstrateur`,
    labels: [
      { language: 'nl', label: `Demonstrateur` },
      { language: 'fr', label: `Démonstrateur` },
      { language: 'en', label: `Demonstrator` },
    ],
  },

  {
    value: `Diëtist`,
    labels: [
      { language: 'nl', label: `Diëtist` },
      { language: 'fr', label: `Diététicien` },
      { language: 'en', label: `Dietician` },
    ],
  },

  {
    value: `Hotelconciërge`,
    labels: [
      { language: 'nl', label: `Hotelconciërge` },
      { language: 'fr', label: `Concierge d'hôtel` },
      { language: 'en', label: `Hotel concierge` },
    ],
  },

  {
    value: `Medewerker recreatieve attracties`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker recreatieve attracties`,
      },
      { language: 'fr', label: `Employé d'attractions récréatives` },
      { language: 'en', label: `Recreational attractions employee` },
    ],
  },

  {
    value: `Medewerker gokspelen`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker gokspelen`,
      },
      { language: 'fr', label: `Employé de jeu` },
      { language: 'en', label: `Gambling employee` },
    ],
  },

  {
    value: `Polyvalent hotelmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Polyvalent hotelmedewerker`,
      },
      { language: 'fr', label: `Employé d'hôtellerie polyvalent` },
      { language: 'en', label: `Multi-purpose hotel employee` },
    ],
  },

  {
    value: `Verantwoordelijke kamerpersoneel`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke kamerpersoneel`,
      },
      { language: 'fr', label: `Personnel de chambre responsable` },
      { language: 'en', label: `Responsible room staff` },
    ],
  },

  {
    value: `Schoen- en lederhersteller`,
    labels: [
      {
        language: 'nl',
        label: `Schoen- en lederhersteller`,
      },
      { language: 'fr', label: `Réparateur de chaussures et de cuir` },
      { language: 'en', label: `Shoe and leather repairer` },
    ],
  },

  {
    value: `Productiemedewerker drukafwerking,`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker drukafwerking,`,
      },
      { language: 'fr', label: `Employé de production en finition d'impression,` },
      { language: 'en', label: `Print finishing production employee,` },
    ],
  },

  {
    value: `Lesgever hoger niet-universitair onderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Lesgever hoger niet-universitair onderwijs`,
      },
      { language: 'fr', label: `Enseignant de l'enseignement supérieur non universitaire` },
      { language: 'en', label: `Teacher of higher non-university education` },
    ],
  },

  {
    value: `Operator productie bouwmaterialen`,
    labels: [
      {
        language: 'nl',
        label: `Operator productie bouwmaterialen`,
      },
      { language: 'fr', label: `Opérateur de production de matériaux de construction` },
      { language: 'en', label: `Operator production building materials` },
    ],
  },

  {
    value: `Operator in de houtzagerij`,
    labels: [
      {
        language: 'nl',
        label: `Operator in de houtzagerij`,
      },
      { language: 'fr', label: `Opérateur en scierie` },
      { language: 'en', label: `Operator in the sawmill` },
    ],
  },

  {
    value: `Technicus grafische industrie`,
    labels: [
      {
        language: 'nl',
        label: `Technicus grafische industrie`,
      },
      { language: 'fr', label: `Technicien en industrie graphique` },
      { language: 'en', label: `Graphics industry technician` },
    ],
  },

  {
    value: `Data engineer`,
    labels: [
      { language: 'nl', label: `Data engineer` },
      { language: 'fr', label: `Ingénieur de données` },
      { language: 'en', label: `Data engineer` },
    ],
  },

  {
    value: `Grimeur-kapper`,
    labels: [
      { language: 'nl', label: `Grimeur-kapper` },
      { language: 'fr', label: `Maquilleuse-coiffeuse` },
      { language: 'en', label: `Make-up artist-hairdresser` },
    ],
  },

  {
    value: `Hulpkok`,
    labels: [
      { language: 'nl', label: `Hulpkok` },
      { language: 'fr', label: `Aide-cuisinier` },
      { language: 'en', label: `Assistant cook` },
    ],
  },

  {
    value: `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
    labels: [
      {
        language: 'nl',
        label: `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
      },
      {
        language: 'fr',
        label: `Opérateur de rayon repassage vêtements et articles de prêt-à-porter et entretien textile`,
      },
      {
        language: 'en',
        label: `Operator of ironing department for clothing and ready-to-wear items and textile care`,
      },
    ],
  },

  {
    value: `Operator spinnerij`,
    labels: [
      {
        language: 'nl',
        label: `Operator spinnerij`,
      },
      { language: 'fr', label: `Opérateur de filature` },
      { language: 'en', label: `Spinning mill operator` },
    ],
  },

  {
    value: `Leerkracht kleuteronderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht kleuteronderwijs`,
      },
      { language: 'fr', label: `Enseignante préscolaire` },
      { language: 'en', label: `Preschool teacher` },
    ],
  },

  {
    value: `Sommelier`,
    labels: [
      { language: 'nl', label: `Sommelier` },
      { language: 'fr', label: `Sommelier` },
      { language: 'en', label: `Sommelier` },
    ],
  },

  {
    value: `Operator leerlooierij witlooierij`,
    labels: [
      {
        language: 'nl',
        label: `Operator leerlooierij witlooierij`,
      },
      { language: 'fr', label: `Opérateur de tannerie blanche` },
      { language: 'en', label: `White tannery tannery operator` },
    ],
  },

  {
    value: `Procesoperator kleding, confectie en meubelstoffering prototypes`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator kleding, confectie en meubelstoffering prototypes`,
      },
      {
        language: 'fr',
        label: `Prototypes d'habillement, de prêt-à-porter et de tapisserie d'ameublement pour opérateurs de process`,
      },
      {
        language: 'en',
        label: `Process operator clothing, ready-to-wear and furniture upholstery prototypes`,
      },
    ],
  },

  {
    value: `Technicus soepele materialen`,
    labels: [
      {
        language: 'nl',
        label: `Technicus soepele materialen`,
      },
      { language: 'fr', label: `Technicien en matériaux flexibles` },
      { language: 'en', label: `Flexible materials technician` },
    ],
  },

  {
    value: `Ontwikkelaar patronen kleding- en confectieartikelen`,
    labels: [
      {
        language: 'nl',
        label: `Ontwikkelaar patronen kleding- en confectieartikelen`,
      },
      { language: 'fr', label: `Créateur de patrons pour vêtements et articles de prêt-à-porter` },
      { language: 'en', label: `Developer of patterns for clothing and ready-to-wear items` },
    ],
  },

  {
    value: `Voorbewerker afwerker van leder en textielproducten`,
    labels: [
      {
        language: 'nl',
        label: `Voorbewerker afwerker van leder en textielproducten`,
      },
      { language: 'fr', label: `Préparateur et finisseur de produits en cuir et textiles` },
      { language: 'en', label: `Preparer and finisher of leather and textile products` },
    ],
  },

  {
    value: `Operator non-woven`,
    labels: [
      {
        language: 'nl',
        label: `Operator non-woven`,
      },
      { language: 'fr', label: `Opérateur non-tissé` },
      { language: 'en', label: `Operator non-woven` },
    ],
  },

  {
    value: `Operator productielijn kleding, confectie en meubelstoffering`,
    labels: [
      {
        language: 'nl',
        label: `Operator productielijn kleding, confectie en meubelstoffering`,
      },
      {
        language: 'fr',
        label: `Opérateur de ligne de production d'habillement, de prêt-à-porter et de tapisserie d'ameublement`,
      },
      {
        language: 'en',
        label: `Operator production line for clothing, ready-to-wear and furniture upholstery`,
      },
    ],
  },

  {
    value: `Operator raam- en woningdecoratie`,
    labels: [
      {
        language: 'nl',
        label: `Operator raam- en woningdecoratie`,
      },
      { language: 'fr', label: `Opérateur de fenêtres et de décoration d'intérieur` },
      { language: 'en', label: `Window and home decoration operator` },
    ],
  },

  {
    value: `Medewerker productielijn kleding, confectie en meubelstoffering`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker productielijn kleding, confectie en meubelstoffering`,
      },
      {
        language: 'fr',
        label: `Employé de chaîne de production d'habillement, de prêt-à-porter et de tapisserie d'ameublement`,
      },
      {
        language: 'en',
        label: `Production line employee for clothing, ready-to-wear and furniture upholstery`,
      },
    ],
  },

  {
    value: `Composietverwerker`,
    labels: [
      {
        language: 'nl',
        label: `Composietverwerker`,
      },
      { language: 'fr', label: `Processeur composite` },
      { language: 'en', label: `Composite processor` },
    ],
  },

  {
    value: `Leerkracht lager onderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht lager onderwijs`,
      },
      { language: 'fr', label: `Instituteur` },
      { language: 'en', label: `Primary Teacher` },
    ],
  },

  {
    value: `Insteller-bediener vonkerosie`,
    labels: [
      {
        language: 'nl',
        label: `Insteller-bediener vonkerosie`,
      },
      { language: 'fr', label: `Opérateur-ajusteur d'électroérosion` },
      { language: 'en', label: `Spark erosion adjuster-operator` },
    ],
  },

  {
    value: `Verantwoordelijke onderhoud van gebouwen en infrastructuur`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke onderhoud van gebouwen en infrastructuur`,
      },
      { language: 'fr', label: `Responsable de l'entretien des bâtiments et des infrastructures` },
      { language: 'en', label: `Responsible for maintenance of buildings and infrastructure` },
    ],
  },

  {
    value: `Operator in de keramiekindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Operator in de keramiekindustrie`,
      },
      { language: 'fr', label: `Opérateur dans l'industrie de la céramique` },
      { language: 'en', label: `Operator in the ceramics industry` },
    ],
  },

  {
    value: `Matrijzenmaker`,
    labels: [
      { language: 'nl', label: `Matrijzenmaker` },
      { language: 'fr', label: `Fabricant de moules` },
      { language: 'en', label: `Mold maker` },
    ],
  },

  {
    value: `Industrieel plaatbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel plaatbewerker`,
      },
      { language: 'fr', label: `Tôlier industriel` },
      { language: 'en', label: `Industrial sheet metal worker` },
    ],
  },

  {
    value: `Operator niet-verspanende bewerkingen`,
    labels: [
      {
        language: 'nl',
        label: `Operator niet-verspanende bewerkingen`,
      },
      { language: 'fr', label: `Opérations de non-usinage de l'opérateur` },
      { language: 'en', label: `Operator non-machining operations` },
    ],
  },

  {
    value: `Oppervlaktebehandelaar diverse materialen`,
    labels: [
      {
        language: 'nl',
        label: `Oppervlaktebehandelaar diverse materialen`,
      },
      { language: 'fr', label: `Traitement de surface pour divers matériaux` },
      { language: 'en', label: `Surface treatment for various materials` },
    ],
  },

  {
    value: `Mallenmaker`,
    labels: [
      { language: 'nl', label: `Mallenmaker` },
      { language: 'fr', label: `Fabricant de moules` },
      { language: 'en', label: `Mold maker` },
    ],
  },

  {
    value: `Preventieadviseur verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Preventieadviseur verzekeringen`,
      },
      { language: 'fr', label: `Conseiller en prévention en assurance` },
      { language: 'en', label: `Insurance prevention advisor` },
    ],
  },

  {
    value: `Operator van een pulpmachine`,
    labels: [
      {
        language: 'nl',
        label: `Operator van een pulpmachine`,
      },
      { language: 'fr', label: `Opérateur de machine à pâte à papier` },
      { language: 'en', label: `Pulp machine operator` },
    ],
  },

  {
    value: `Expert aroma's en geuren`,
    labels: [
      {
        language: 'nl',
        label: `Expert aroma's en geuren`,
      },
      { language: 'fr', label: `Arômes et senteurs experts` },
      { language: 'en', label: `Expert aromas and scents` },
    ],
  },

  {
    value: `Industrieel polijster`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel polijster`,
      },
      { language: 'fr', label: `Polisseuse industrielle` },
      { language: 'en', label: `Industrial polisher` },
    ],
  },

  {
    value: `Thermisch behandelaar`,
    labels: [
      {
        language: 'nl',
        label: `Thermisch behandelaar`,
      },
      { language: 'fr', label: `Traitement thermique` },
      { language: 'en', label: `Thermal treater` },
    ],
  },

  {
    value: `Onderhoudsmedewerker affichering en straatmeubilair`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmedewerker affichering en straatmeubilair`,
      },
      { language: 'fr', label: `Ouvrier d'entretien d'affiches et de mobilier urbain` },
      { language: 'en', label: `Maintenance worker for posters and street furniture` },
    ],
  },

  {
    value: `Installateur liften`,
    labels: [
      {
        language: 'nl',
        label: `Installateur liften`,
      },
      { language: 'fr', label: `Installateur d'ascenseur` },
      { language: 'en', label: `Lift installer` },
    ],
  },

  {
    value: `Verantwoordelijke beheer en onderhoud van voertuigen`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke beheer en onderhoud van voertuigen`,
      },
      { language: 'fr', label: `Responsable de la gestion et de l'entretien des véhicules` },
      { language: 'en', label: `Responsible for management and maintenance of vehicles` },
    ],
  },

  {
    value: `Technicus communicatienetwerken`,
    labels: [
      {
        language: 'nl',
        label: `Technicus communicatienetwerken`,
      },
      { language: 'fr', label: `Technicien en réseaux de communication` },
      { language: 'en', label: `Communications networks technician` },
    ],
  },

  {
    value: `Technicus hernieuwbare energietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Technicus hernieuwbare energietechnieken`,
      },
      { language: 'fr', label: `Technicien en technologie des énergies renouvelables` },
      { language: 'en', label: `Renewable energy technology technician` },
    ],
  },

  {
    value: `Plaatwerker carrosserie`,
    labels: [
      {
        language: 'nl',
        label: `Plaatwerker carrosserie`,
      },
      { language: 'fr', label: `Tôlier en carrosserie` },
      { language: 'en', label: `Bodywork sheet metal worker` },
    ],
  },

  {
    value: `Boswachter`,
    labels: [
      { language: 'nl', label: `Boswachter` },
      { language: 'fr', label: `garde forestier` },
      { language: 'en', label: `Forest ranger` },
    ],
  },

  {
    value: `Onderwaterwerker`,
    labels: [
      {
        language: 'nl',
        label: `Onderwaterwerker`,
      },
      { language: 'fr', label: `Travailleur sous-marin` },
      { language: 'en', label: `Underwater worker` },
    ],
  },

  {
    value: `Uitvoerder van werken in schadelijke milieus`,
    labels: [
      {
        language: 'nl',
        label: `Uitvoerder van werken in schadelijke milieus`,
      },
      { language: 'fr', label: `Exécuteur de travaux en milieux nuisibles` },
      { language: 'en', label: `Executor of works in harmful environments` },
    ],
  },

  {
    value: `Technicus doe-het-zelfmateriaal`,
    labels: [
      {
        language: 'nl',
        label: `Technicus doe-het-zelfmateriaal`,
      },
      { language: 'fr', label: `Technicien en matériel de bricolage` },
      { language: 'en', label: `DIY equipment technician` },
    ],
  },

  {
    value: `OAD-technicus van personenwagens en lichte bedrijfsvoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `OAD-technicus van personenwagens en lichte bedrijfsvoertuigen`,
      },
      {
        language: 'fr',
        label: `Technicien OAD pour voitures particulières et véhicules utilitaires légers`,
      },
      { language: 'en', label: `OAD technician for passenger cars and light commercial vehicles` },
    ],
  },

  {
    value: `Maker van vlechtwerk`,
    labels: [
      {
        language: 'nl',
        label: `Maker van vlechtwerk`,
      },
      { language: 'fr', label: `Fabricant de vannerie` },
      { language: 'en', label: `Maker of wickerwork` },
    ],
  },

  {
    value: `Maker van juwelen en zilverwerk`,
    labels: [
      {
        language: 'nl',
        label: `Maker van juwelen en zilverwerk`,
      },
      { language: 'fr', label: `Fabricant de bijoux et d'argenterie` },
      { language: 'en', label: `Maker of jewelry and silverware` },
    ],
  },

  {
    value: `Taxidermist`,
    labels: [
      { language: 'nl', label: `Taxidermist` },
      { language: 'fr', label: `Taxidermiste` },
      { language: 'en', label: `Taxidermist` },
    ],
  },

  {
    value: `Hoedenmaker`,
    labels: [
      { language: 'nl', label: `Hoedenmaker` },
      { language: 'fr', label: `Chapelier` },
      { language: 'en', label: `Hatter` },
    ],
  },

  {
    value: `Lederbewerker`,
    labels: [
      { language: 'nl', label: `Lederbewerker` },
      { language: 'fr', label: `Travailleur du cuir` },
      { language: 'en', label: `Leather worker` },
    ],
  },

  {
    value: `Artistiek wever`,
    labels: [
      {
        language: 'nl',
        label: `Artistiek wever`,
      },
      { language: 'fr', label: `Tisserand artistique` },
      { language: 'en', label: `Artistic weaver` },
    ],
  },

  {
    value: `Technicus elektrische en elektronische toestellen - witgoed`,
    labels: [
      {
        language: 'nl',
        label: `Technicus elektrische en elektronische toestellen - witgoed`,
      },
      {
        language: 'fr',
        label: `Technicien en appareils électriques et électroniques - électroménager`,
      },
      { language: 'en', label: `Technician electrical and electronic appliances - white goods` },
    ],
  },

  {
    value: `Natuurbeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Natuurbeheerder`,
      },
      { language: 'fr', label: `Gestionnaire nature` },
      { language: 'en', label: `Nature manager` },
    ],
  },

  {
    value: `Bosbouwer`,
    labels: [
      { language: 'nl', label: `Bosbouwer` },
      { language: 'fr', label: `Forestier` },
      { language: 'en', label: `Forester` },
    ],
  },

  {
    value: `Landbouwkundig adviseur`,
    labels: [
      {
        language: 'nl',
        label: `Landbouwkundig adviseur`,
      },
      { language: 'fr', label: `Conseiller agricole` },
      { language: 'en', label: `Agricultural advisor` },
    ],
  },

  {
    value: `Vee- en paardenhouder`,
    labels: [
      {
        language: 'nl',
        label: `Vee- en paardenhouder`,
      },
      { language: 'fr', label: `Éleveur de bovins et de chevaux` },
      { language: 'en', label: `Cattle and horse farmer` },
    ],
  },

  {
    value: `Dierentrimmer`,
    labels: [
      { language: 'nl', label: `Dierentrimmer` },
      { language: 'fr', label: `Toiletteur pour animaux` },
      { language: 'en', label: `Pet groomer` },
    ],
  },

  {
    value: `Medewerker internationaal goederenverkeer`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker internationaal goederenverkeer`,
      },
      { language: 'fr', label: `Employé du trafic de fret international` },
      { language: 'en', label: `International freight traffic employee` },
    ],
  },

  {
    value: `Uitvoerder van werken op hoogte`,
    labels: [
      {
        language: 'nl',
        label: `Uitvoerder van werken op hoogte`,
      },
      { language: 'fr', label: `Exécuteur de travaux en hauteur` },
      { language: 'en', label: `Executor of works at height` },
    ],
  },

  {
    value: `Decorateur van kunst- en artisanale objecten`,
    labels: [
      {
        language: 'nl',
        label: `Decorateur van kunst- en artisanale objecten`,
      },
      { language: 'fr', label: `Décorateur d'objets d'art et artisanaux` },
      { language: 'en', label: `Decorator of art and artisanal objects` },
    ],
  },

  {
    value: `Trambestuurder`,
    labels: [
      { language: 'nl', label: `Trambestuurder` },
      { language: 'fr', label: `Conducteur de tramway` },
      { language: 'en', label: `Tram driver` },
    ],
  },

  {
    value: `Technicus elektrische en elektronische toestellen - bruingoed`,
    labels: [
      {
        language: 'nl',
        label: `Technicus elektrische en elektronische toestellen - bruingoed`,
      },
      {
        language: 'fr',
        label: `Technicien en équipements électriques et électroniques - produits bruns`,
      },
      { language: 'en', label: `Electrical and electronic equipment technician - brown goods` },
    ],
  },

  {
    value: `Verantwoordelijke organisatie voor personenvervoer over de weg`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke organisatie voor personenvervoer over de weg`,
      },
      { language: 'fr', label: `Organisation responsable du transport routier de voyageurs` },
      { language: 'en', label: `Responsible organization for passenger transport by road` },
    ],
  },

  {
    value: `Steward luchtvaart`,
    labels: [
      {
        language: 'nl',
        label: `Steward luchtvaart`,
      },
      { language: 'fr', label: `Hôtesse de l'air` },
      { language: 'en', label: `Flight attendant` },
    ],
  },

  {
    value: `Rangeerder`,
    labels: [
      { language: 'nl', label: `Rangeerder` },
      { language: 'fr', label: `Locotracteur` },
      { language: 'en', label: `Shunter` },
    ],
  },

  {
    value: `Onderhoudstechnicus pleziervaart`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudstechnicus pleziervaart`,
      },
      { language: 'fr', label: `Technicien d'entretien de bateaux de plaisance` },
      { language: 'en', label: `Recreational boat maintenance technician` },
    ],
  },

  {
    value: `Vliegtuigtechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Vliegtuigtechnicus`,
      },
      { language: 'fr', label: `Technicien aéronautique` },
      { language: 'en', label: `Aircraft technician` },
    ],
  },
  {
    value: `Technicus werf-, landbouw- en hefmachines`,
    labels: [
      {
        language: 'nl',
        label: `Technicus werf-, landbouw- en hefmachines`,
      },
      { language: 'fr', label: `Technicien de chantier, matériel agricole et de levage` },
      { language: 'en', label: `Technician site, agricultural and lifting equipment` },
    ],
  },

  {
    value: `Landbouwer`,
    labels: [
      { language: 'nl', label: `Landbouwer` },
      { language: 'fr', label: `Fermier` },
      { language: 'en', label: `Farmer` },
    ],
  },

  {
    value: `Medisch-technisch assistent`,
    labels: [
      {
        language: 'nl',
        label: `Medisch-technisch assistent`,
      },
      { language: 'fr', label: `Assistante technique médicale` },
      { language: 'en', label: `Medical technical assistant` },
    ],
  },

  {
    value: `Graveerder`,
    labels: [
      { language: 'nl', label: `Graveerder` },
      { language: 'fr', label: `Graveur` },
      { language: 'en', label: `Engraver` },
    ],
  },

  {
    value: `Muziekinstrumentenbouwer -hersteller`,
    labels: [
      {
        language: 'nl',
        label: `Muziekinstrumentenbouwer -hersteller`,
      },
      { language: 'fr', label: `Constructeur et réparateur d'instruments de musique` },
      { language: 'en', label: `Musical instrument builder and repairer` },
    ],
  },

  {
    value: `Technicus van tuin-, park- en bosmachines`,
    labels: [
      {
        language: 'nl',
        label: `Technicus van tuin-, park- en bosmachines`,
      },
      { language: 'fr', label: `Technicien de machines de jardin, parc et forêt` },
      { language: 'en', label: `Technician of garden, park and forest machines` },
    ],
  },

  {
    value: `Zoutwinner`,
    labels: [
      { language: 'nl', label: `Zoutwinner` },
      { language: 'fr', label: `Extracteur de sel` },
      { language: 'en', label: `Salt extractor` },
    ],
  },

  {
    value: `Schapen- en geitenfokker`,
    labels: [
      {
        language: 'nl',
        label: `Schapen- en geitenfokker`,
      },
      { language: 'fr', label: `Éleveur de moutons et de chèvres` },
      { language: 'en', label: `Sheep and goat breeder` },
    ],
  },

  {
    value: `Controleur op openbaar vervoer`,
    labels: [
      {
        language: 'nl',
        label: `Controleur op openbaar vervoer`,
      },
      { language: 'fr', label: `Inspecteur des transports publics` },
      { language: 'en', label: `Public transport inspector` },
    ],
  },

  {
    value: `Treinbestuurder`,
    labels: [
      {
        language: 'nl',
        label: `Treinbestuurder`,
      },
      { language: 'fr', label: `Conducteur de train` },
      { language: 'en', label: `Train driver` },
    ],
  },

  {
    value: `Werktuigkundige scheepvaart`,
    labels: [
      {
        language: 'nl',
        label: `Werktuigkundige scheepvaart`,
      },
      { language: 'fr', label: `Mécanicien d'expédition` },
      { language: 'en', label: `Shipping mechanic` },
    ],
  },

  {
    value: `Etalateur-decorateur`,
    labels: [
      {
        language: 'nl',
        label: `Etalateur-decorateur`,
      },
      { language: 'fr', label: `Décorateur de vitrines` },
      { language: 'en', label: `Window dresser-decorator` },
    ],
  },

  {
    value: `Ambachtelijk glasbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Ambachtelijk glasbewerker`,
      },
      { language: 'fr', label: `Artisan verrier` },
      { language: 'en', label: `Artisan glassworker` },
    ],
  },

  {
    value: `Diamantbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Diamantbewerker`,
      },
      { language: 'fr', label: `Travailleur du diamant` },
      { language: 'en', label: `Diamond worker` },
    ],
  },

  {
    value: `Uurwerkmaker`,
    labels: [
      { language: 'nl', label: `Uurwerkmaker` },
      { language: 'fr', label: `Horloger` },
      { language: 'en', label: `Clockmaker` },
    ],
  },

  {
    value: `Medewerker in de fruitteelt`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker in de fruitteelt`,
      },
      { language: 'fr', label: `Employé de culture fruitière` },
      { language: 'en', label: `Fruit growing employee` },
    ],
  },

  {
    value: `Boomverzorger`,
    labels: [
      { language: 'nl', label: `Boomverzorger` },
      { language: 'fr', label: `Arboriculteur` },
      { language: 'en', label: `Arborist` },
    ],
  },

  {
    value: `Kweker van vis, week- en schelpdieren`,
    labels: [
      {
        language: 'nl',
        label: `Kweker van vis, week- en schelpdieren`,
      },
      { language: 'fr', label: `Éleveur de poissons, mollusques et coquillages` },
      { language: 'en', label: `Farmer of fish, molluscs and shellfish` },
    ],
  },

  {
    value: `Boomkweker`,
    labels: [
      { language: 'nl', label: `Boomkweker` },
      { language: 'fr', label: `Arboriculteur` },
      { language: 'en', label: `Arborist` },
    ],
  },

  {
    value: `Schipper visserij`,
    labels: [
      {
        language: 'nl',
        label: `Schipper visserij`,
      },
      { language: 'fr', label: `Pêche au capitaine` },
      { language: 'en', label: `Skipper fishing` },
    ],
  },

  {
    value: `Varkensfokker`,
    labels: [
      { language: 'nl', label: `Varkensfokker` },
      { language: 'fr', label: `Éleveur de porcs` },
      { language: 'en', label: `Pig breeder` },
    ],
  },

  {
    value: `Gezagvoerder zeevaart`,
    labels: [
      {
        language: 'nl',
        label: `Gezagvoerder zeevaart`,
      },
      { language: 'fr', label: `Capitaine maritime` },
      { language: 'en', label: `Maritime captain` },
    ],
  },

  {
    value: `Gezagvoerder kustsleepvaart en havensleepvaart`,
    labels: [
      {
        language: 'nl',
        label: `Gezagvoerder kustsleepvaart en havensleepvaart`,
      },
      { language: 'fr', label: `Capitaine de remorquage côtier et de remorquage portuaire` },
      { language: 'en', label: `Captain of coastal towage and harbor towage` },
    ],
  },

  {
    value: `Bemanning zeevaart`,
    labels: [
      {
        language: 'nl',
        label: `Bemanning zeevaart`,
      },
      { language: 'fr', label: `Équipage maritime` },
      { language: 'en', label: `Maritime crew` },
    ],
  },

  {
    value: `Matroos binnenscheepvaart`,
    labels: [
      {
        language: 'nl',
        label: `Matroos binnenscheepvaart`,
      },
      { language: 'fr', label: `Navigation intérieure de marin` },
      { language: 'en', label: `Sailor inland shipping` },
    ],
  },

  {
    value: `Vluchtvoorbereider`,
    labels: [
      {
        language: 'nl',
        label: `Vluchtvoorbereider`,
      },
      { language: 'fr', label: `Préparateur de vols` },
      { language: 'en', label: `Flight preparer` },
    ],
  },

  {
    value: `Landbouwkundig onderzoeker`,
    labels: [
      {
        language: 'nl',
        label: `Landbouwkundig onderzoeker`,
      },
      { language: 'fr', label: `Chercheur agronome` },
      { language: 'en', label: `Agricultural researcher` },
    ],
  },

  {
    value: `Verantwoordelijke budgetbeheer`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke budgetbeheer`,
      },
      { language: 'fr', label: `Responsable de la gestion budgétaire` },
      { language: 'en', label: `Responsible for budget management` },
    ],
  },

  {
    value: `OD-technicus van zware bedrijfsvoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `OD-technicus van zware bedrijfsvoertuigen`,
      },
      { language: 'fr', label: `Technicien OD pour véhicules lourds` },
      { language: 'en', label: `Heavy Duty Vehicle OD Technician` },
    ],
  },

  {
    value: `Keramist-pottenbakker`,
    labels: [
      {
        language: 'nl',
        label: `Keramist-pottenbakker`,
      },
      { language: 'fr', label: `Céramiste-potier` },
      { language: 'en', label: `Ceramist-potter` },
    ],
  },

  {
    value: `Boekbinder-restaurateur`,
    labels: [
      {
        language: 'nl',
        label: `Boekbinder-restaurateur`,
      },
      { language: 'fr', label: `Relieur-restaurateur` },
      { language: 'en', label: `Bookbinder-restorer` },
    ],
  },

  {
    value: `Kleermaker`,
    labels: [
      { language: 'nl', label: `Kleermaker` },
      { language: 'fr', label: `Tailleur` },
      { language: 'en', label: `Tailor` },
    ],
  },

  {
    value: `Inspecteur land- en tuinbouw`,
    labels: [
      {
        language: 'nl',
        label: `Inspecteur land- en tuinbouw`,
      },
      { language: 'fr', label: `Inspecteur de l'agriculture et de l'horticulture` },
      { language: 'en', label: `Agriculture and horticulture inspector` },
    ],
  },

  {
    value: `Medewerker in de veehouderij of viskweek`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker in de veehouderij of viskweek`,
      },
      { language: 'fr', label: `Salarié en élevage ou pisciculture` },
      { language: 'en', label: `Employee in livestock farming or fish farming` },
    ],
  },

  {
    value: `Pluim- en kleinveekweker`,
    labels: [
      {
        language: 'nl',
        label: `Pluim- en kleinveekweker`,
      },
      { language: 'fr', label: `Éleveur de volailles et de petits bétails` },
      { language: 'en', label: `Poultry and small livestock breeder` },
    ],
  },

  {
    value: `Visserijmatroos`,
    labels: [
      {
        language: 'nl',
        label: `Visserijmatroos`,
      },
      { language: 'fr', label: `Marin de pêche` },
      { language: 'en', label: `Fishery sailor` },
    ],
  },

  {
    value: `Dierenarts`,
    labels: [
      { language: 'nl', label: `Dierenarts` },
      { language: 'fr', label: `Chirurgien vétérinaire` },
      { language: 'en', label: `Veterinary surgeon` },
    ],
  },

  {
    value: `service technieker`,
    labels: [
      {
        language: 'nl',
        label: `service technieker`,
      },
      { language: 'fr', label: `technicien de service` },
      { language: 'en', label: `service technician` },
    ],
  },

  {
    value: `Bestuurder van sleepvoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder van sleepvoertuigen`,
      },
      { language: 'fr', label: `Conducteur de véhicules tracteurs` },
      { language: 'en', label: `Driver of towing vehicles` },
    ],
  },

  {
    value: `Bestuurder van land- en bosbouwmachines`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder van land- en bosbouwmachines`,
      },
      { language: 'fr', label: `Conducteur de machines agricoles et forestières` },
      { language: 'en', label: `Driver of agricultural and forestry machinery` },
    ],
  },

  {
    value: `Dierenverzorger`,
    labels: [
      {
        language: 'nl',
        label: `Dierenverzorger`,
      },
      { language: 'fr', label: `Gardien de zoo` },
      { language: 'en', label: `Zookeeper` },
    ],
  },

  {
    value: `Schipper-stuurman binnenvaart`,
    labels: [
      {
        language: 'nl',
        label: `Schipper-stuurman binnenvaart`,
      },
      { language: 'fr', label: `Navigation intérieure skipper-mate` },
      { language: 'en', label: `Skipper-mate inland shipping` },
    ],
  },

  {
    value: `Metrobestuurder`,
    labels: [
      {
        language: 'nl',
        label: `Metrobestuurder`,
      },
      { language: 'fr', label: `Chauffeur de métro` },
      { language: 'en', label: `Subway driver` },
    ],
  },

  {
    value: `Treinbegeleider`,
    labels: [
      {
        language: 'nl',
        label: `Treinbegeleider`,
      },
      { language: 'fr', label: `Conducteur de train` },
      { language: 'en', label: `Train conductor` },
    ],
  },

  {
    value: `Proces- en productontwikkelaar`,
    labels: [
      {
        language: 'nl',
        label: `Proces- en productontwikkelaar`,
      },
      { language: 'fr', label: `Développeur de procédés et de produits` },
      { language: 'en', label: `Process and product developer` },
    ],
  },

  {
    value: `Luchtverkeersleider`,
    labels: [
      {
        language: 'nl',
        label: `Luchtverkeersleider`,
      },
      { language: 'fr', label: `Contrôleur de trafic aérien` },
      { language: 'en', label: `Air traffic controller` },
    ],
  },

  {
    value: `Verantwoordelijke uitbating luchthaven`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke uitbating luchthaven`,
      },
      { language: 'fr', label: `Exploitation aéroportuaire responsable` },
      { language: 'en', label: `Responsible airport operation` },
    ],
  },

  {
    value: `Verantwoordelijke binnenscheepvaartbedrijf`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke binnenscheepvaartbedrijf`,
      },
      { language: 'fr', label: `Entreprise de navigation intérieure responsable` },
      { language: 'en', label: `Responsible inland shipping company` },
    ],
  },

  {
    value: `Medewerker textielverzorging`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker textielverzorging`,
      },
      { language: 'fr', label: `Employée d'entretien des textiles` },
      { language: 'en', label: `Textile care employee` },
    ],
  },

  {
    value: `Yield-revenue manager`,
    labels: [
      {
        language: 'nl',
        label: `Yield-revenue manager`,
      },
      { language: 'fr', label: `Responsable des revenus de rendement` },
      { language: 'en', label: `Yield revenue manager` },
    ],
  },

  {
    value: `Hoef- en klauwverzorger`,
    labels: [
      {
        language: 'nl',
        label: `Hoef- en klauwverzorger`,
      },
      { language: 'fr', label: `Soigneur des sabots et des onglons` },
      { language: 'en', label: `Hoof and claw caretaker` },
    ],
  },

  {
    value: `Operator drukafwerking`,
    labels: [
      {
        language: 'nl',
        label: `Operator drukafwerking`,
      },
      { language: 'fr', label: `Opérateur de finition d'impression` },
      { language: 'en', label: `Print finishing operator` },
    ],
  },

  {
    value: `Leidinggevende defensie`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende defensie`,
      },
      { language: 'fr', label: `Leadership de la défense` },
      { language: 'en', label: `Defense leadership` },
    ],
  },

  {
    value: `Beeldend kunstenaar`,
    labels: [
      {
        language: 'nl',
        label: `Beeldend kunstenaar`,
      },
      { language: 'fr', label: `Artiste visuel` },
      { language: 'en', label: `Visual artist` },
    ],
  },

  {
    value: `Kweker van wilde dieren of huisdieren`,
    labels: [
      {
        language: 'nl',
        label: `Kweker van wilde dieren of huisdieren`,
      },
      { language: 'fr', label: `Éleveur d'animaux sauvages ou d'animaux domestiques` },
      { language: 'en', label: `Breeder of wild animals or domestic animals` },
    ],
  },

  {
    value: `Dierenartsassistent`,
    labels: [
      {
        language: 'nl',
        label: `Dierenartsassistent`,
      },
      { language: 'fr', label: `Assistante vétérinaire` },
      { language: 'en', label: `Veterinary assistant` },
    ],
  },

  {
    value: `Operator van een mechanische lift`,
    labels: [
      {
        language: 'nl',
        label: `Operator van een mechanische lift`,
      },
      { language: 'fr', label: `Opérateur d'un ascenseur mécanique` },
      { language: 'en', label: `Operator of a mechanical elevator` },
    ],
  },

  {
    value: `Animator recreatiecentrum`,
    labels: [
      {
        language: 'nl',
        label: `Animator recreatiecentrum`,
      },
      { language: 'fr', label: `Animateur centre de loisirs` },
      { language: 'en', label: `Animator recreation center` },
    ],
  },

  {
    value: `Medewerker openbare financiën`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker openbare financiën`,
      },
      { language: 'fr', label: `Chargé des finances publiques` },
      { language: 'en', label: `Public finance officer` },
    ],
  },

  {
    value: `Sorteerder recyclage`,
    labels: [
      {
        language: 'nl',
        label: `Sorteerder recyclage`,
      },
      { language: 'fr', label: `Trieur de recyclage` },
      { language: 'en', label: `Recycling sorter` },
    ],
  },

  {
    value: `Operator drukken`,
    labels: [
      {
        language: 'nl',
        label: `Operator drukken`,
      },
      { language: 'fr', label: `Opérateur de presse` },
      { language: 'en', label: `Press operator` },
    ],
  },

  {
    value: `Operator digitaal bedrukken van textiel`,
    labels: [
      {
        language: 'nl',
        label: `Operator digitaal bedrukken van textiel`,
      },
      { language: 'fr', label: `Opérateur d'impression textile numérique` },
      { language: 'en', label: `Digital textile printing operator` },
    ],
  },

  {
    value: `Verantwoordelijke aankoopdienst`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke aankoopdienst`,
      },
      { language: 'fr', label: `Service des achats responsable` },
      { language: 'en', label: `Responsible purchasing department` },
    ],
  },

  {
    value: `Syndicus`,
    labels: [
      { language: 'nl', label: `Syndicus` },
      { language: 'fr', label: `Syndic` },
      { language: 'en', label: `Syndic` },
    ],
  },

  {
    value: `Productiemedewerker drukken in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker drukken in de printmedia`,
      },
      { language: 'fr', label: `Employé de production imprimant sur des supports imprimés` },
      { language: 'en', label: `Production employee printing in print media` },
    ],
  },

  {
    value: `Klinisch bioloog`,
    labels: [
      {
        language: 'nl',
        label: `Klinisch bioloog`,
      },
      { language: 'fr', label: `Biologiste clinicien` },
      { language: 'en', label: `Clinical biologist` },
    ],
  },

  {
    value: `Netwerkbeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Netwerkbeheerder`,
      },
      { language: 'fr', label: `Administrateur réseau` },
      { language: 'en', label: `Network administrator` },
    ],
  },

  {
    value: `Hoofdverpleegkundige`,
    labels: [
      {
        language: 'nl',
        label: `Hoofdverpleegkundige`,
      },
      { language: 'fr', label: `Infirmière en chef` },
      { language: 'en', label: `Head nurse` },
    ],
  },

  {
    value: `Elektronicus`,
    labels: [
      { language: 'nl', label: `Elektronicus` },
      { language: 'fr', label: `Ingénieur en électronique` },
      { language: 'en', label: `Electronics engineer` },
    ],
  },

  {
    value: `Diplomatiek vertegenwoordiger`,
    labels: [
      {
        language: 'nl',
        label: `Diplomatiek vertegenwoordiger`,
      },
      { language: 'fr', label: `Représentant diplomatique` },
      { language: 'en', label: `Diplomatic representative` },
    ],
  },

  {
    value: `Begeleider activiteiten dagelijks leven`,
    labels: [
      {
        language: 'nl',
        label: `Begeleider activiteiten dagelijks leven`,
      },
      { language: 'fr', label: `Superviseur des activités de la vie quotidienne` },
      { language: 'en', label: `Supervisor of activities of daily living` },
    ],
  },

  {
    value: `Uitsnijder-uitbener`,
    labels: [
      {
        language: 'nl',
        label: `Uitsnijder-uitbener`,
      },
      { language: 'fr', label: `Sculpteur-déosseur` },
      { language: 'en', label: `Carver-boner` },
    ],
  },

  {
    value: `Back-office medewerker in de financiële sector`,
    labels: [
      {
        language: 'nl',
        label: `Back-office medewerker in de financiële sector`,
      },
      { language: 'fr', label: `Employé de back-office dans le secteur financier` },
      { language: 'en', label: `Back-office employee in the financial sector` },
    ],
  },

  {
    value: `Manager hotel restaurant`,
    labels: [
      {
        language: 'nl',
        label: `Manager hotel restaurant`,
      },
      { language: 'fr', label: `Responsable de restaurant d'hôtel` },
      { language: 'en', label: `Hotel restaurant manager` },
    ],
  },

  {
    value: `Onderhoudstechnicus waterdistributie en sanering`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudstechnicus waterdistributie en sanering`,
      },
      {
        language: 'fr',
        label: `Technicien de maintenance pour la distribution d'eau et l'assainissement`,
      },
      { language: 'en', label: `Maintenance technician for water distribution and sanitation` },
    ],
  },

  {
    value: `Installateur gebouwenautomatisering`,
    labels: [
      {
        language: 'nl',
        label: `Installateur gebouwenautomatisering`,
      },
      { language: 'fr', label: `Installateur en immotique` },
      { language: 'en', label: `Building automation installer` },
    ],
  },

  {
    value: `Productieoperator-machineregelaar kunststoffen`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator-machineregelaar kunststoffen`,
      },
      { language: 'fr', label: `Opérateur de production-contrôleur de machine plastiques` },
      { language: 'en', label: `Production operator-machine controller plastics` },
    ],
  },

  {
    value: `Tekenaar-ontwerper elektriciteit, elektronica`,
    labels: [
      {
        language: 'nl',
        label: `Tekenaar-ontwerper elektriciteit, elektronica`,
      },
      { language: 'fr', label: `Dessinateur-concepteur en électricité, électronique` },
      { language: 'en', label: `Draughtsman-designer of electricity, electronics` },
    ],
  },

  {
    value: `Productieleider van podiumvoorstellingen en audiovisuele producties`,
    labels: [
      {
        language: 'nl',
        label: `Productieleider van podiumvoorstellingen en audiovisuele producties`,
      },
      {
        language: 'fr',
        label: `Responsable de production de spectacles scéniques et de productions audiovisuelles`,
      },
      {
        language: 'en',
        label: `Production manager of stage performances and audiovisual productions`,
      },
    ],
  },

  {
    value: `Gevelreiniger`,
    labels: [
      { language: 'nl', label: `Gevelreiniger` },
      { language: 'fr', label: `Nettoyant façade` },
      { language: 'en', label: `Facade cleaner` },
    ],
  },

  {
    value: `Operator glasbewerking`,
    labels: [
      {
        language: 'nl',
        label: `Operator glasbewerking`,
      },
      { language: 'fr', label: `Opérateur de transformation du verre` },
      { language: 'en', label: `Glass processing operator` },
    ],
  },

  {
    value: `Dakdekker industriële daken`,
    labels: [
      {
        language: 'nl',
        label: `Dakdekker industriële daken`,
      },
      { language: 'fr', label: `Couvreur de toitures industrielles` },
      { language: 'en', label: `Roofer industrial roofs` },
    ],
  },

  {
    value: `Opticien`,
    labels: [
      { language: 'nl', label: `Opticien` },
      { language: 'fr', label: `Opticien` },
      { language: 'en', label: `Optician` },
    ],
  },

  {
    value: `Architect bouw`,
    labels: [
      { language: 'nl', label: `Architect bouw` },
      { language: 'fr', label: `Construction d'architecte` },
      { language: 'en', label: `Architect construction` },
    ],
  },

  {
    value: `Multimedia designer`,
    labels: [
      {
        language: 'nl',
        label: `Multimedia designer`,
      },
      { language: 'fr', label: `Concepteur multimédia` },
      { language: 'en', label: `Multimedia designer` },
    ],
  },

  {
    value: `Medewerker fastfood`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker fastfood`,
      },
      { language: 'fr', label: `Ouvrier de restauration rapide` },
      { language: 'en', label: `Fast food worker` },
    ],
  },

  {
    value: `Onderhoudsmedewerker wegennet`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmedewerker wegennet`,
      },
      { language: 'fr', label: `Ouvrier d'entretien du réseau routier` },
      { language: 'en', label: `Road network maintenance worker` },
    ],
  },

  {
    value: `Operator glasproductie`,
    labels: [
      {
        language: 'nl',
        label: `Operator glasproductie`,
      },
      { language: 'fr', label: `Opérateur de production de verre` },
      { language: 'en', label: `Glass production operator` },
    ],
  },

  {
    value: `Opleider volwassenen`,
    labels: [
      {
        language: 'nl',
        label: `Opleider volwassenen`,
      },
      { language: 'fr', label: `Formateur adulte` },
      { language: 'en', label: `Adult trainer` },
    ],
  },

  {
    value: `Steigerbouwer`,
    labels: [
      { language: 'nl', label: `Steigerbouwer` },
      { language: 'fr', label: `Constructeur d'échafaudages` },
      { language: 'en', label: `Scaffolding builder` },
    ],
  },

  {
    value: `Bordenbouwer`,
    labels: [
      { language: 'nl', label: `Bordenbouwer` },
      { language: 'fr', label: `Constructeur de cartes` },
      { language: 'en', label: `Board builder` },
    ],
  },

  {
    value: `Fiscaal controleur`,
    labels: [
      {
        language: 'nl',
        label: `Fiscaal controleur`,
      },
      { language: 'fr', label: `Inspecteur des impôts` },
      { language: 'en', label: `Tax inspector` },
    ],
  },

  {
    value: `Verantwoordelijke kinderopvang`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke kinderopvang`,
      },
      { language: 'fr', label: `Responsable de garde d'enfants responsable` },
      { language: 'en', label: `Responsible childcare provider` },
    ],
  },

  {
    value: `Ergotherapeut`,
    labels: [
      { language: 'nl', label: `Ergotherapeut` },
      { language: 'fr', label: `Ergothérapeute` },
      { language: 'en', label: `Occupational therapist` },
    ],
  },

  {
    value: `Property manager`,
    labels: [
      {
        language: 'nl',
        label: `Property manager`,
      },
      { language: 'fr', label: `Gestionnaire de l'immeuble` },
      { language: 'en', label: `Property manager` },
    ],
  },

  {
    value: `Arbeider begraafplaatsen`,
    labels: [
      {
        language: 'nl',
        label: `Arbeider begraafplaatsen`,
      },
      { language: 'fr', label: `Cimetières ouvriers` },
      { language: 'en', label: `Worker cemeteries` },
    ],
  },

  {
    value: `Medewerker reprografie-copycenter`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker reprografie-copycenter`,
      },
      { language: 'fr', label: `Employé d'un centre de reprographie` },
      { language: 'en', label: `Reprography copy center employee` },
    ],
  },

  {
    value: `Onderhoudsmecanicien van zware bedrijfsvoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmecanicien van zware bedrijfsvoertuigen`,
      },
      { language: 'fr', label: `Mécanicien d'entretien de véhicules utilitaires lourds` },
      { language: 'en', label: `Maintenance mechanic of heavy commercial vehicles` },
    ],
  },

  {
    value: `Leidinggevend bemanningslid luchtvaart`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevend bemanningslid luchtvaart`,
      },
      { language: 'fr', label: `Membre d'équipage aéronautique responsable` },
      { language: 'en', label: `Aviation crew member in charge` },
    ],
  },

  {
    value: `Douanedeclarant`,
    labels: [
      {
        language: 'nl',
        label: `Douanedeclarant`,
      },
      { language: 'fr', label: `Courtier en douane` },
      { language: 'en', label: `Customs broker` },
    ],
  },

  {
    value: `Bibliotheekmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Bibliotheekmedewerker`,
      },
      { language: 'fr', label: `Bibliothécaire` },
      { language: 'en', label: `Librarian` },
    ],
  },

  {
    value: `Productieoperator drukken in de printmedia`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator drukken in de printmedia`,
      },
      { language: 'fr', label: `Opérateur de production pressage dans la presse écrite` },
      { language: 'en', label: `Production operator pressing in the print media` },
    ],
  },

  {
    value: `Verzorgende`,
    labels: [
      { language: 'nl', label: `Verzorgende` },
      { language: 'fr', label: `Soignant` },
      { language: 'en', label: `Caregiver` },
    ],
  },

  {
    value: `Meestergast in de meubel- en houtindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Meestergast in de meubel- en houtindustrie`,
      },
      { language: 'fr', label: `Invité maître de l'industrie du meuble et du bois` },
      { language: 'en', label: `Master guest in the furniture and wood industry` },
    ],
  },

  {
    value: `Operator prepress`,
    labels: [
      {
        language: 'nl',
        label: `Operator prepress`,
      },
      { language: 'fr', label: `Opérateur prépresse` },
      { language: 'en', label: `Prepress operator` },
    ],
  },

  {
    value: `Florist-bloemist`,
    labels: [
      {
        language: 'nl',
        label: `Florist-bloemist`,
      },
      { language: 'fr', label: `Fleuriste fleuriste` },
      { language: 'en', label: `Florist florist` },
    ],
  },

  {
    value: `Magazijnmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Magazijnmedewerker`,
      },
      { language: 'fr', label: `Ouvrier d'entrepôt` },
      { language: 'en', label: `Warehouse worker` },
    ],
  },

  {
    value: `Milieuwerker`,
    labels: [
      { language: 'nl', label: `Milieuwerker` },
      { language: 'fr', label: `Travailleur environnemental` },
      { language: 'en', label: `Environmental worker` },
    ],
  },

  {
    value: `Directeur van een kleine of middelgrote organisatie`,
    labels: [
      {
        language: 'nl',
        label: `Directeur van een kleine of middelgrote organisatie`,
      },
      { language: 'fr', label: `Directeur d'une petite ou moyenne organisation` },
      { language: 'en', label: `Director of a small or medium-sized organization` },
    ],
  },

  {
    value: `Trend- en marktanalist`,
    labels: [
      {
        language: 'nl',
        label: `Trend- en marktanalist`,
      },
      { language: 'fr', label: `Analyste de tendances et de marché` },
      { language: 'en', label: `Trend and market analyst` },
    ],
  },

  {
    value: `Technicus verdeelautomaten`,
    labels: [
      {
        language: 'nl',
        label: `Technicus verdeelautomaten`,
      },
      { language: 'fr', label: `Technicien en distributeurs` },
      { language: 'en', label: `Dispensing machine technician` },
    ],
  },

  {
    value: `Installateur nutsvoorzieningen`,
    labels: [
      {
        language: 'nl',
        label: `Installateur nutsvoorzieningen`,
      },
      { language: 'fr', label: `Installateur d'utilitaires` },
      { language: 'en', label: `Utilities installer` },
    ],
  },

  {
    value: `Verpakker`,
    labels: [
      { language: 'nl', label: `Verpakker` },
      { language: 'fr', label: `Emballeur` },
      { language: 'en', label: `Packer` },
    ],
  },

  {
    value: `ICT architect`,
    labels: [
      { language: 'nl', label: `ICT architect` },
      { language: 'fr', label: `Architecte informatique` },
      { language: 'en', label: `IT architect` },
    ],
  },

  {
    value: `Winkelmanager`,
    labels: [
      { language: 'nl', label: `Winkelmanager` },
      { language: 'fr', label: `Gérant de magasin` },
      { language: 'en', label: `Store manager` },
    ],
  },

  {
    value: `Chef de partie`,
    labels: [
      { language: 'nl', label: `Chef de partie` },
      { language: 'fr', label: `Chef de partie` },
      { language: 'en', label: `Chef de partie` },
    ],
  },

  {
    value: `Medewerker spoorwegnet`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker spoorwegnet`,
      },
      { language: 'fr', label: `Employé du réseau ferroviaire` },
      { language: 'en', label: `Railway network employee` },
    ],
  },

  {
    value: `Sales engineer`,
    labels: [
      { language: 'nl', label: `Sales engineer` },
      { language: 'fr', label: `Ingénieur commercial` },
      { language: 'en', label: `Sales engineer` },
    ],
  },

  {
    value: `Tekenaar-ontwerper animatiefilms en speciale effecten`,
    labels: [
      {
        language: 'nl',
        label: `Tekenaar-ontwerper animatiefilms en speciale effecten`,
      },
      { language: 'fr', label: `Artiste-concepteur de films d'animation et d'effets spéciaux` },
      { language: 'en', label: `Artist-designer of animation films and special effects` },
    ],
  },

  {
    value: `Technicus controle en kwaliteit elektriciteit en elektronica`,
    labels: [
      {
        language: 'nl',
        label: `Technicus controle en kwaliteit elektriciteit en elektronica`,
      },
      {
        language: 'fr',
        label: `Technicien contrôle et qualité de l'électricité et de l'électronique`,
      },
      { language: 'en', label: `Technician checking and quality of electricity and electronics` },
    ],
  },

  {
    value: `Operator textielverzorging`,
    labels: [
      {
        language: 'nl',
        label: `Operator textielverzorging`,
      },
      { language: 'fr', label: `Opérateur d'entretien des textiles` },
      { language: 'en', label: `Textile care operator` },
    ],
  },

  {
    value: `Directieassistent hotel restaurant`,
    labels: [
      {
        language: 'nl',
        label: `Directieassistent hotel restaurant`,
      },
      { language: 'fr', label: `Assistante de direction hôtel restaurant` },
      { language: 'en', label: `Management assistant hotel restaurant` },
    ],
  },

  {
    value: `Grootkeukenkok`,
    labels: [
      { language: 'nl', label: `Grootkeukenkok` },
      { language: 'fr', label: `Chef traiteur` },
      { language: 'en', label: `Catering chef` },
    ],
  },

  {
    value: `Verhuizer`,
    labels: [
      { language: 'nl', label: `Verhuizer` },
      { language: 'fr', label: `Déménageur` },
      { language: 'en', label: `Mover` },
    ],
  },

  {
    value: `Deskundige veiligheid, hygiëne en leefmilieu`,
    labels: [
      {
        language: 'nl',
        label: `Deskundige veiligheid, hygiëne en leefmilieu`,
      },
      { language: 'fr', label: `Expert sécurité, hygiène et environnement` },
      { language: 'en', label: `Expert safety, hygiene and environment` },
    ],
  },

  {
    value: `Chauffeur pleziervoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `Chauffeur pleziervoertuigen`,
      },
      { language: 'fr', label: `Conducteur de véhicule de plaisance` },
      { language: 'en', label: `Pleasure vehicle driver` },
    ],
  },

  {
    value: `Leerkracht secundair onderwijs`,
    labels: [
      {
        language: 'nl',
        label: `Leerkracht secundair onderwijs`,
      },
      { language: 'fr', label: `Professeur d'enseignement secondaire` },
      { language: 'en', label: `Secondary education teacher` },
    ],
  },

  {
    value: `Software analist`,
    labels: [
      {
        language: 'nl',
        label: `Software analist`,
      },
      { language: 'fr', label: `Analyste logiciel` },
      { language: 'en', label: `Software analyst` },
    ],
  },

  {
    value: `Horecamanager`,
    labels: [
      { language: 'nl', label: `Horecamanager` },
      { language: 'fr', label: `Responsable restauration` },
      { language: 'en', label: `Catering manager` },
    ],
  },

  {
    value: `Verantwoordelijke laboratorium`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke laboratorium`,
      },
      { language: 'fr', label: `Laboratoire responsable` },
      { language: 'en', label: `Responsible laboratory` },
    ],
  },

  {
    value: `Veiligheidscoördinator`,
    labels: [
      {
        language: 'nl',
        label: `Veiligheidscoördinator`,
      },
      { language: 'fr', label: `Coordinateur de sécurité` },
      { language: 'en', label: `Safety coordinator` },
    ],
  },

  {
    value: `Operator van een papier- of kartonmachine`,
    labels: [
      {
        language: 'nl',
        label: `Operator van een papier- of kartonmachine`,
      },
      { language: 'fr', label: `Opérateur d'une machine à papier ou à carton` },
      { language: 'en', label: `Operator of a paper or cardboard machine` },
    ],
  },

  {
    value: `Monteur van elektrische en elektronische producten`,
    labels: [
      {
        language: 'nl',
        label: `Monteur van elektrische en elektronische producten`,
      },
      { language: 'fr', label: `Installateur de produits électriques et électroniques` },
      { language: 'en', label: `Installer of electrical and electronic products` },
    ],
  },

  {
    value: `Visual merchandiser`,
    labels: [
      {
        language: 'nl',
        label: `Visual merchandiser`,
      },
      { language: 'fr', label: `Présentoir visuel` },
      { language: 'en', label: `Visual merchandiser` },
    ],
  },

  {
    value: `Juridisch medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Juridisch medewerker`,
      },
      { language: 'fr', label: `Assistant juridique` },
      { language: 'en', label: `Legal assistant` },
    ],
  },

  {
    value: `Integratie expert ICT`,
    labels: [
      {
        language: 'nl',
        label: `Integratie expert ICT`,
      },
      { language: 'fr', label: `Expert en intégration TIC` },
      { language: 'en', label: `ICT integration expert` },
    ],
  },

  {
    value: `Data scientist`,
    labels: [
      { language: 'nl', label: `Data scientist` },
      { language: 'fr', label: `Scientifique des données` },
      { language: 'en', label: `Data scientist` },
    ],
  },

  {
    value: `Software ontwikkelaar`,
    labels: [
      {
        language: 'nl',
        label: `Software ontwikkelaar`,
      },
      { language: 'fr', label: `Développeur de logiciels` },
      { language: 'en', label: `Software developer` },
    ],
  },

  {
    value: `Reisleider-gids`,
    labels: [
      {
        language: 'nl',
        label: `Reisleider-gids`,
      },
      { language: 'fr', label: `Guide-accompagnateur` },
      { language: 'en', label: `Tour leader guide` },
    ],
  },

  {
    value: `Spuiter carrosserie`,
    labels: [
      {
        language: 'nl',
        label: `Spuiter carrosserie`,
      },
      { language: 'fr', label: `Carrosserie du pulvérisateur` },
      { language: 'en', label: `Sprayer bodywork` },
    ],
  },

  {
    value: `Apotheker`,
    labels: [
      { language: 'nl', label: `Apotheker` },
      { language: 'fr', label: `Pharmacien` },
      { language: 'en', label: `Pharmacist` },
    ],
  },

  {
    value: `Vastgoedbemiddelaar overdracht`,
    labels: [
      {
        language: 'nl',
        label: `Vastgoedbemiddelaar overdracht`,
      },
      { language: 'fr', label: `Transfert de courtier immobilier` },
      { language: 'en', label: `Real estate broker transfer` },
    ],
  },

  {
    value: `Operator textielveredeling`,
    labels: [
      {
        language: 'nl',
        label: `Operator textielveredeling`,
      },
      { language: 'fr', label: `Opérateur d'ennoblissement textile` },
      { language: 'en', label: `Textile finishing operator` },
    ],
  },

  {
    value: `Verpleegkundige`,
    labels: [
      {
        language: 'nl',
        label: `Verpleegkundige`,
      },
      { language: 'fr', label: `Infirmière` },
      { language: 'en', label: `Nurse` },
    ],
  },

  {
    value: `Technicus elektronische installaties`,
    labels: [
      {
        language: 'nl',
        label: `Technicus elektronische installaties`,
      },
      { language: 'fr', label: `Technicien en installation électronique` },
      { language: 'en', label: `Electronic installation technician` },
    ],
  },

  {
    value: `Brandwacht-veiligheidswacht`,
    labels: [
      {
        language: 'nl',
        label: `Brandwacht-veiligheidswacht`,
      },
      { language: 'fr', label: `Surveillance incendie-surveillance de sécurité` },
      { language: 'en', label: `Fire watch-safety watch` },
    ],
  },

  {
    value: `Technicus van bromfietsen en motorfietsen`,
    labels: [
      {
        language: 'nl',
        label: `Technicus van bromfietsen en motorfietsen`,
      },
      { language: 'fr', label: `Technicien de cyclomoteurs et motos` },
      { language: 'en', label: `Technician of mopeds and motorcycles` },
    ],
  },

  {
    value: `Tekenaar-ontwerper mechanica`,
    labels: [
      {
        language: 'nl',
        label: `Tekenaar-ontwerper mechanica`,
      },
      { language: 'fr', label: `Dessinateur-concepteur en mécanique` },
      { language: 'en', label: `Mechanics draftsman-designer` },
    ],
  },

  {
    value: `Opvoeder-begeleider`,
    labels: [
      {
        language: 'nl',
        label: `Opvoeder-begeleider`,
      },
      { language: 'fr', label: `Éducateur-superviseur` },
      { language: 'en', label: `Educator-supervisor` },
    ],
  },

  {
    value: `Leidinggevende schoonmaak`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende schoonmaak`,
      },
      { language: 'fr', label: `Responsable nettoyage` },
      { language: 'en', label: `Cleaning manager` },
    ],
  },

  {
    value: `Apotheker`,
    labels: [
      { language: 'nl', label: `Apotheker` },
      { language: 'fr', label: `Pharmacien` },
      { language: 'en', label: `Pharmacist` },
    ],
  },

  {
    value: `Controleur gebouwen`,
    labels: [
      {
        language: 'nl',
        label: `Controleur gebouwen`,
      },
      { language: 'fr', label: `Inspecteur en bâtiment` },
      { language: 'en', label: `Building inspector` },
    ],
  },

  {
    value: `Operator filmlabo`,
    labels: [
      {
        language: 'nl',
        label: `Operator filmlabo`,
      },
      { language: 'fr', label: `Opérateur de laboratoire cinématographique` },
      { language: 'en', label: `Film lab operator` },
    ],
  },

  {
    value: `Afdelingsverantwoordelijke verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Afdelingsverantwoordelijke verzekeringen`,
      },
      { language: 'fr', label: `Responsable du service assurances` },
      { language: 'en', label: `Insurance department responsible` },
    ],
  },

  {
    value: `Coach persoonlijke ontwikkeling en welzijn`,
    labels: [
      {
        language: 'nl',
        label: `Coach persoonlijke ontwikkeling en welzijn`,
      },
      { language: 'fr', label: `Coach en développement personnel et bien-être` },
      { language: 'en', label: `Coach personal development and well-being` },
    ],
  },

  {
    value: `Farmaceutisch-technisch assistent`,
    labels: [
      {
        language: 'nl',
        label: `Farmaceutisch-technisch assistent`,
      },
      { language: 'fr', label: `Assistante technique pharmaceutique` },
      { language: 'en', label: `Pharmaceutical technical assistant` },
    ],
  },

  {
    value: `Bestuurder van betonnerings- en asfalteringsmachines`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder van betonnerings- en asfalteringsmachines`,
      },
      { language: 'fr', label: `Conducteur de machines à bétonner et à asphalter` },
      { language: 'en', label: `Driver of concreting and asphalt paving machines` },
    ],
  },

  {
    value: `Uitzendconsulent`,
    labels: [
      {
        language: 'nl',
        label: `Uitzendconsulent`,
      },
      { language: 'fr', label: `Conseiller en emploi` },
      { language: 'en', label: `Employment consultant` },
    ],
  },

  {
    value: `Logopedist`,
    labels: [
      { language: 'nl', label: `Logopedist` },
      { language: 'fr', label: `Orthophoniste` },
      { language: 'en', label: `Speech therapist` },
    ],
  },

  {
    value: `Operator fotolabo`,
    labels: [
      {
        language: 'nl',
        label: `Operator fotolabo`,
      },
      { language: 'fr', label: `Opérateur de laboratoire photo` },
      { language: 'en', label: `Photo lab operator` },
    ],
  },

  {
    value: `Projectleider lokale ontwikkeling`,
    labels: [
      {
        language: 'nl',
        label: `Projectleider lokale ontwikkeling`,
      },
      { language: 'fr', label: `Chef de projet développement local` },
      { language: 'en', label: `Project leader local development` },
    ],
  },

  {
    value: `Sales engineer`,
    labels: [
      { language: 'nl', label: `Sales engineer` },
      { language: 'fr', label: `Ingénieur commercial` },
      { language: 'en', label: `Sales engineer` },
    ],
  },

  {
    value: `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
    labels: [
      {
        language: 'nl',
        label: `Operator strijkafdeling kleding- en confectieartikelen en textielverzorging`,
      },
      {
        language: 'fr',
        label: `Opérateur de rayon repassage vêtements et articles de prêt-à-porter et entretien textile`,
      },
      {
        language: 'en',
        label: `Operator of ironing department for clothing and ready-to-wear items and textile care`,
      },
    ],
  },

  {
    value: `Redder`,
    labels: [
      { language: 'nl', label: `Redder` },
      { language: 'fr', label: `Sauveur` },
      { language: 'en', label: `Savior` },
    ],
  },

  {
    value: `Interieurbouwer`,
    labels: [
      {
        language: 'nl',
        label: `Interieurbouwer`,
      },
      { language: 'fr', label: `Constructeur d'intérieur` },
      { language: 'en', label: `Interior builder` },
    ],
  },

  {
    value: `Arbeidsbemiddelaar-jobcoach `,
    labels: [
      {
        language: 'nl',
        label: `Arbeidsbemiddelaar-jobcoach `,
      },
      { language: 'fr', label: `Médiatrice d'emploi-coach d'emploi` },
      { language: 'en', label: `Employment mediator-job coach` },
    ],
  },

  {
    value: `Medewerker socio-economische studies`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker socio-economische studies`,
      },
      { language: 'fr', label: `Employé d'études socio-économiques` },
      { language: 'en', label: `Socio-economic studies employee` },
    ],
  },

  {
    value: `Keukenverantwoordelijke`,
    labels: [
      {
        language: 'nl',
        label: `Keukenverantwoordelijke`,
      },
      { language: 'fr', label: `Responsable de cuisine` },
      { language: 'en', label: `Kitchen manager` },
    ],
  },

  {
    value: `Werfbediende`,
    labels: [
      { language: 'nl', label: `Werfbediende` },
      { language: 'fr', label: `Commis de triage` },
      { language: 'en', label: `Yard clerk` },
    ],
  },

  {
    value: `Orderbegeleider in de grafische sector`,
    labels: [
      {
        language: 'nl',
        label: `Orderbegeleider in de grafische sector`,
      },
      { language: 'fr', label: `Responsable des commandes dans le secteur graphique` },
      { language: 'en', label: `Order supervisor in the graphics sector` },
    ],
  },

  {
    value: `Calculator bouw`,
    labels: [
      {
        language: 'nl',
        label: `Calculator bouw`,
      },
      { language: 'fr', label: `Calculateur de construction` },
      { language: 'en', label: `Construction calculator` },
    ],
  },

  {
    value: `Business analist`,
    labels: [
      {
        language: 'nl',
        label: `Business analist`,
      },
      { language: 'fr', label: `Analyste d'affaires` },
      { language: 'en', label: `Business analyst` },
    ],
  },

  {
    value: `Zorgkundige`,
    labels: [
      { language: 'nl', label: `Zorgkundige` },
      { language: 'fr', label: `Professionnel de santé` },
      { language: 'en', label: `Healthcare professional` },
    ],
  },

  {
    value: `Meubelstoffeerder`,
    labels: [
      {
        language: 'nl',
        label: `Meubelstoffeerder`,
      },
      { language: 'fr', label: `Tapissier de meubles` },
      { language: 'en', label: `Furniture upholsterer` },
    ],
  },

  {
    value: `Brouwer van alcoholische dranken`,
    labels: [
      {
        language: 'nl',
        label: `Brouwer van alcoholische dranken`,
      },
      { language: 'fr', label: `Brasseur de boissons alcoolisées` },
      { language: 'en', label: `Brewer of alcoholic drinks` },
    ],
  },

  {
    value: `Licht- en beeldtechnicus podium- en audiovisuele producties`,
    labels: [
      {
        language: 'nl',
        label: `Licht- en beeldtechnicus podium- en audiovisuele producties`,
      },
      {
        language: 'fr',
        label: `Technicien lumière et image pour productions scéniques et audiovisuelles`,
      },
      {
        language: 'en',
        label: `Lighting and image technician for stage and audiovisual productions`,
      },
    ],
  },

  {
    value: `Assistent winkelmanager`,
    labels: [
      {
        language: 'nl',
        label: `Assistent winkelmanager`,
      },
      { language: 'fr', label: `Responsable adjoint de magasin` },
      { language: 'en', label: `Assistant store manager` },
    ],
  },

  {
    value: `Verantwoordelijke productiemethodes en industrialisatie`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke productiemethodes en industrialisatie`,
      },
      { language: 'fr', label: `Méthodes de production et industrialisation responsables` },
      { language: 'en', label: `Responsible production methods and industrialization` },
    ],
  },

  {
    value: `Landbouwmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Landbouwmedewerker`,
      },
      { language: 'fr', label: `Ouvrier agricole` },
      { language: 'en', label: `Agricultural worker` },
    ],
  },

  {
    value: `Hulpkok grootkeuken`,
    labels: [
      {
        language: 'nl',
        label: `Hulpkok grootkeuken`,
      },
      { language: 'fr', label: `Chef adjoint dans une grande cuisine` },
      { language: 'en', label: `Assistant chef in large kitchen` },
    ],
  },

  {
    value: `Operator snijafdeling kleding, confectie en meubelstoffering`,
    labels: [
      {
        language: 'nl',
        label: `Operator snijafdeling kleding, confectie en meubelstoffering`,
      },
      {
        language: 'fr',
        label: `Opérateur du département de découpe de vêtements, de prêt-à-porter et de tapisserie d'ameublement`,
      },
      {
        language: 'en',
        label: `Operator of the clothing, ready-to-wear and furniture upholstery cutting department`,
      },
    ],
  },

  {
    value: `Technisch inspecteur industrie`,
    labels: [
      {
        language: 'nl',
        label: `Technisch inspecteur industrie`,
      },
      { language: 'fr', label: `Inspecteur technique industrie` },
      { language: 'en', label: `Technical inspector industry` },
    ],
  },

  {
    value: `Verantwoordelijke sport-, recreatieve of toeristische accommodatie`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke sport-, recreatieve of toeristische accommodatie`,
      },
      { language: 'fr', label: `Hébergement responsable sportif, récréatif ou touristique` },
      { language: 'en', label: `Responsible sports, recreational or tourist accommodation` },
    ],
  },

  {
    value: `Kinderbegeleider schoolgaande kinderen`,
    labels: [
      {
        language: 'nl',
        label: `Kinderbegeleider schoolgaande kinderen`,
      },
      { language: 'fr', label: `Éducatrice auprès d'enfants d'âge scolaire` },
      { language: 'en', label: `Childcare worker for school-age children` },
    ],
  },

  {
    value: `Vertaler`,
    labels: [
      { language: 'nl', label: `Vertaler` },
      { language: 'fr', label: `Traducteur` },
      { language: 'en', label: `Translator` },
    ],
  },

  {
    value: `Sporttrainer`,
    labels: [
      { language: 'nl', label: `Sporttrainer` },
      { language: 'fr', label: `Entraîneur sportif` },
      { language: 'en', label: `Sports trainer` },
    ],
  },

  {
    value: `Huishoudhulp-poetshulp`,
    labels: [
      {
        language: 'nl',
        label: `Huishoudhulp-poetshulp`,
      },
      { language: 'fr', label: `Aide-ménagère` },
      { language: 'en', label: `Household cleaning helper` },
    ],
  },

  {
    value: `Natuursteenbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Natuursteenbewerker`,
      },
      { language: 'fr', label: `Travailleur de la pierre naturelle` },
      { language: 'en', label: `Natural stone worker` },
    ],
  },

  {
    value: `Isoleerder ruwbouw en dak`,
    labels: [
      {
        language: 'nl',
        label: `Isoleerder ruwbouw en dak`,
      },
      { language: 'fr', label: `Coque isolante et toit` },
      { language: 'en', label: `Insulator shell and roof` },
    ],
  },

  {
    value: `Afwerker-hersteller van breigoed- en textielproducten`,
    labels: [
      {
        language: 'nl',
        label: `Afwerker-hersteller van breigoed- en textielproducten`,
      },
      { language: 'fr', label: `Finisseur-réparateur de tricots et produits textiles` },
      { language: 'en', label: `Finisher-repairer of knitwear and textile products` },
    ],
  },

  {
    value: `Grafisch ontwerper`,
    labels: [
      {
        language: 'nl',
        label: `Grafisch ontwerper`,
      },
      { language: 'fr', label: `Designer graphique` },
      { language: 'en', label: `Graphic designer` },
    ],
  },

  {
    value: `Regelaar-afsteller van productie-installaties`,
    labels: [
      {
        language: 'nl',
        label: `Regelaar-afsteller van productie-installaties`,
      },
      { language: 'fr', label: `Régulateur-ajusteur d'installations de production` },
      { language: 'en', label: `Regulator-adjuster of production installations` },
    ],
  },

  {
    value: `Systeembeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Systeembeheerder`,
      },
      { language: 'fr', label: `Administrateur du système` },
      { language: 'en', label: `System administrator` },
    ],
  },

  {
    value: `Operator metaalovens`,
    labels: [
      {
        language: 'nl',
        label: `Operator metaalovens`,
      },
      { language: 'fr', label: `Opérateur de four à métaux` },
      { language: 'en', label: `Metal furnace operator` },
    ],
  },

  {
    value: `Machinebouwer`,
    labels: [
      { language: 'nl', label: `Machinebouwer` },
      { language: 'fr', label: `Constructeur de machines` },
      { language: 'en', label: `Machine builder` },
    ],
  },

  {
    value: `Leidinggevende mechanische productie`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende mechanische productie`,
      },
      { language: 'fr', label: `Responsable production mécanique` },
      { language: 'en', label: `Mechanical production manager` },
    ],
  },

  {
    value: `Leidinggevende textiel confectie en lederproductie`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende textiel confectie en lederproductie`,
      },
      { language: 'fr', label: `Responsable confection textile et production cuir` },
      { language: 'en', label: `Manager in textile confection and leather production` },
    ],
  },

  {
    value: `Check-in medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Check-in medewerker`,
      },
      { language: 'fr', label: `Employé d'enregistrement` },
      { language: 'en', label: `Check-in employee` },
    ],
  },

  {
    value: `Verantwoordelijke contactcenter`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke contactcenter`,
      },
      { language: 'fr', label: `Centre de contact responsable` },
      { language: 'en', label: `Responsible contact center` },
    ],
  },

  {
    value: `Visfileerder`,
    labels: [
      { language: 'nl', label: `Visfileerder` },
      { language: 'fr', label: `Remplisseur de poisson` },
      { language: 'en', label: `Fish filler` },
    ],
  },

  {
    value: `Brug- en sluiswachter`,
    labels: [
      {
        language: 'nl',
        label: `Brug- en sluiswachter`,
      },
      { language: 'fr', label: `Gardien du pont et de l'écluse` },
      { language: 'en', label: `Bridge and lock keeper` },
    ],
  },

  {
    value: `Productieoperator hout`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator hout`,
      },
      { language: 'fr', label: `Opérateur de production de bois` },
      { language: 'en', label: `Wood production operator` },
    ],
  },

  {
    value: `Preventiearts`,
    labels: [
      { language: 'nl', label: `Preventiearts` },
      { language: 'fr', label: `Médecin de prévention` },
      { language: 'en', label: `Prevention doctor` },
    ],
  },

  {
    value: `Pijpfitter`,
    labels: [
      { language: 'nl', label: `Pijpfitter` },
      { language: 'fr', label: `Tuyauteur` },
      { language: 'en', label: `Pipe fitter` },
    ],
  },

  {
    value: `Elektrodelasser`,
    labels: [
      {
        language: 'nl',
        label: `Elektrodelasser`,
      },
      { language: 'fr', label: `Soudeuse à électrode` },
      { language: 'en', label: `Electrode welder` },
    ],
  },

  {
    value: `Montageoperator in de lederindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Montageoperator in de lederindustrie`,
      },
      { language: 'fr', label: `Opérateur d'assemblage dans l'industrie du cuir` },
      { language: 'en', label: `Assembly operator in the leather industry` },
    ],
  },

  {
    value: `Portefeuillebeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Portefeuillebeheerder`,
      },
      { language: 'fr', label: `Gestionnaire de portefeuille` },
      { language: 'en', label: `Portfolio manager` },
    ],
  },

  {
    value: `Operator machines voor eerste metaalverwerking`,
    labels: [
      {
        language: 'nl',
        label: `Operator machines voor eerste metaalverwerking`,
      },
      { language: 'fr', label: `Machines opérateurs pour le premier traitement des métaux` },
      { language: 'en', label: `Operator machines for first metal processing` },
    ],
  },

  {
    value: `Verantwoordelijke rendement toerismeproducten`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke rendement toerismeproducten`,
      },
      { language: 'fr', label: `Responsable des retours sur les produits touristiques` },
      { language: 'en', label: `Responsible for returns on tourism products` },
    ],
  },

  {
    value: `Ambachtelijk metaalbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Ambachtelijk metaalbewerker`,
      },
      { language: 'fr', label: `Métallurgiste traditionnel` },
      { language: 'en', label: `Traditional metalworker` },
    ],
  },

  {
    value: `Technicus onderzoek en ontwikkeling in de procesindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Technicus onderzoek en ontwikkeling in de procesindustrie`,
      },
      {
        language: 'fr',
        label: `Technicien en recherche et développement dans l'industrie de transformation`,
      },
      { language: 'en', label: `Research and development technician in the process industry` },
    ],
  },

  {
    value: `Manager toerismeproducten`,
    labels: [
      {
        language: 'nl',
        label: `Manager toerismeproducten`,
      },
      { language: 'fr', label: `Responsable produits touristiques` },
      { language: 'en', label: `Tourism products manager` },
    ],
  },

  {
    value: `Interieurarchitect interieurvormgever`,
    labels: [
      {
        language: 'nl',
        label: `Interieurarchitect interieurvormgever`,
      },
      { language: 'fr', label: `Architecte d'intérieur architecte d'intérieur` },
      { language: 'en', label: `Interior architect interior designer` },
    ],
  },

  {
    value: `Vastgoedbemiddelaar verkoop en verhuur`,
    labels: [
      {
        language: 'nl',
        label: `Vastgoedbemiddelaar verkoop en verhuur`,
      },
      { language: 'fr', label: `Agent immobilier en vente et location` },
      { language: 'en', label: `Real estate agent for sales and rental` },
    ],
  },

  {
    value: `Vastgoedpromotor`,
    labels: [
      {
        language: 'nl',
        label: `Vastgoedpromotor`,
      },
      { language: 'fr', label: `Promoteur immobilier` },
      { language: 'en', label: `Real estate promoter` },
    ],
  },

  {
    value: `Koeltechnicus`,
    labels: [
      { language: 'nl', label: `Koeltechnicus` },
      { language: 'fr', label: `Technicien en réfrigération` },
      { language: 'en', label: `Refrigeration technician` },
    ],
  },

  {
    value: `Verantwoordelijke verkooppromotie`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke verkooppromotie`,
      },
      { language: 'fr', label: `Responsable de la promotion des ventes` },
      { language: 'en', label: `Responsible for sales promotion` },
    ],
  },

  {
    value: `Bediener baggermachines`,
    labels: [
      {
        language: 'nl',
        label: `Bediener baggermachines`,
      },
      { language: 'fr', label: `Opérateur de machine de dragage` },
      { language: 'en', label: `Dredging machine operator` },
    ],
  },

  {
    value: `Plaatser van boven- en ondergrondse kabels en leidingen`,
    labels: [
      {
        language: 'nl',
        label: `Plaatser van boven- en ondergrondse kabels en leidingen`,
      },
      { language: 'fr', label: `Installateur de câbles et canalisations aériens et souterrains` },
      { language: 'en', label: `Installer of above-ground and underground cables and pipes` },
    ],
  },

  {
    value: `Uitvaartondernemer`,
    labels: [
      {
        language: 'nl',
        label: `Uitvaartondernemer`,
      },
      { language: 'fr', label: `Directeur des pompes funèbres` },
      { language: 'en', label: `Funeral director` },
    ],
  },

  {
    value: `Kaasmaker`,
    labels: [
      { language: 'nl', label: `Kaasmaker` },
      { language: 'fr', label: `Fromager` },
      { language: 'en', label: `Cheesemaker` },
    ],
  },

  {
    value: `Kelner`,
    labels: [
      { language: 'nl', label: `Kelner` },
      { language: 'fr', label: `Serveur` },
      { language: 'en', label: `Waiter` },
    ],
  },

  {
    value: `Technicus productieproces en methodes`,
    labels: [
      {
        language: 'nl',
        label: `Technicus productieproces en methodes`,
      },
      { language: 'fr', label: `Processus et méthodes de production des techniciens` },
      { language: 'en', label: `Technician production process and methods` },
    ],
  },

  {
    value: `Autobuschauffeur`,
    labels: [
      {
        language: 'nl',
        label: `Autobuschauffeur`,
      },
      { language: 'fr', label: `Conducteur de bus` },
      { language: 'en', label: `Bus driver` },
    ],
  },

  {
    value: `Bediener of medewerker diepfunderingsmachines`,
    labels: [
      {
        language: 'nl',
        label: `Bediener of medewerker diepfunderingsmachines`,
      },
      { language: 'fr', label: `Opérateur ou employé de machines à fondations profondes` },
      { language: 'en', label: `Operator or employee of deep foundation machines` },
    ],
  },

  {
    value: `Afwasser`,
    labels: [
      { language: 'nl', label: `Afwasser` },
      { language: 'fr', label: `Lave-vaisselle` },
      { language: 'en', label: `Dishwasher` },
    ],
  },

  {
    value: `Schade-expert verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Schade-expert verzekeringen`,
      },
      { language: 'fr', label: `Expert en sinistres d'assurance` },
      { language: 'en', label: `Insurance claims adjuster` },
    ],
  },

  {
    value: `Technicus industriële automatisering`,
    labels: [
      {
        language: 'nl',
        label: `Technicus industriële automatisering`,
      },
      { language: 'fr', label: `Technicien en automatisation industrielle` },
      { language: 'en', label: `Industrial automation technician` },
    ],
  },

  {
    value: `Medewerker plaatselijke veiligheid`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker plaatselijke veiligheid`,
      },
      { language: 'fr', label: `Employé de sécurité locale` },
      { language: 'en', label: `Local security employee` },
    ],
  },

  {
    value: `Verdeler post en drukwerk`,
    labels: [
      {
        language: 'nl',
        label: `Verdeler post en drukwerk`,
      },
      { language: 'fr', label: `Distributeur de courrier et d'imprimerie` },
      { language: 'en', label: `Distributor of mail and printing` },
    ],
  },

  {
    value: `Autogeenlasser`,
    labels: [
      { language: 'nl', label: `Autogeenlasser` },
      { language: 'fr', label: `Soudeur autogène` },
      { language: 'en', label: `Autogenous welder` },
    ],
  },

  {
    value: `Brandertechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Brandertechnicus`,
      },
      { language: 'fr', label: `Technicien brûleur` },
      { language: 'en', label: `Burner technician` },
    ],
  },

  {
    value: `Industrieel onderhoudstechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel onderhoudstechnicus`,
      },
      { language: 'fr', label: `Technicien de maintenance industrielle` },
      { language: 'en', label: `Industrial maintenance technician` },
    ],
  },

  {
    value: `Native speaker / Vertaler-Tolk`,
    labels: [
      {
        language: 'nl',
        label: `Native speaker / Vertaler-Tolk`,
      },
      { language: 'fr', label: `Langue maternelle / Traductrice-Interprète` },
      { language: 'en', label: `Native speaker / Translator-Interpreter` },
    ],
  },

  {
    value: `Social media manager`,
    labels: [
      {
        language: 'nl',
        label: `Social media manager`,
      },
      { language: 'fr', label: `Gestionnaire des médias sociaux` },
      { language: 'en', label: `Social media manager` },
    ],
  },

  {
    value: `Customer relations manager`,
    labels: [
      {
        language: 'nl',
        label: `Customer relations manager`,
      },
      { language: 'fr', label: `Responsable relation client` },
      { language: 'en', label: `Customer relations manager` },
    ],
  },

  {
    value: `Technisch adviseur klantenondersteuning`,
    labels: [
      {
        language: 'nl',
        label: `Technisch adviseur klantenondersteuning`,
      },
      { language: 'fr', label: `Conseiller technique support client` },
      { language: 'en', label: `Customer support technical advisor` },
    ],
  },

  {
    value: `Daktimmerman`,
    labels: [
      { language: 'nl', label: `Daktimmerman` },
      { language: 'fr', label: `Charpentier de toiture` },
      { language: 'en', label: `Roof carpenter` },
    ],
  },

  {
    value: `Support medewerker ICT`,
    labels: [
      {
        language: 'nl',
        label: `Support medewerker ICT`,
      },
      { language: 'fr', label: `Employé de support informatique` },
      { language: 'en', label: `IT support employee` },
    ],
  },

  {
    value: `Koetswerkbouwer`,
    labels: [
      {
        language: 'nl',
        label: `Koetswerkbouwer`,
      },
      { language: 'fr', label: `Carrossier` },
      { language: 'en', label: `Coachbuilder` },
    ],
  },

  {
    value: `Maatschappelijk werker`,
    labels: [
      {
        language: 'nl',
        label: `Maatschappelijk werker`,
      },
      { language: 'fr', label: `Travailleur social` },
      { language: 'en', label: `Social worker` },
    ],
  },

  {
    value: `Beheerder verzekeringen`,
    labels: [
      {
        language: 'nl',
        label: `Beheerder verzekeringen`,
      },
      { language: 'fr', label: `Responsable assurance` },
      { language: 'en', label: `Insurance manager` },
    ],
  },

  {
    value: `Taxichauffeur`,
    labels: [
      { language: 'nl', label: `Taxichauffeur` },
      { language: 'fr', label: `Chauffeur de taxi` },
      { language: 'en', label: `Cab driver` },
    ],
  },

  {
    value: `Adviseur bedrijfsorganisatie en management`,
    labels: [
      {
        language: 'nl',
        label: `Adviseur bedrijfsorganisatie en management`,
      },
      { language: 'fr', label: `Consultant en organisation et gestion d'entreprise` },
      { language: 'en', label: `Business organization and management consultant` },
    ],
  },

  {
    value: `Onthaalmedewerker hotel`,
    labels: [
      {
        language: 'nl',
        label: `Onthaalmedewerker hotel`,
      },
      { language: 'fr', label: `Réceptionniste d'hôtel` },
      { language: 'en', label: `Hotel receptionist` },
    ],
  },

  {
    value: `Adviseur financieel vermogen`,
    labels: [
      {
        language: 'nl',
        label: `Adviseur financieel vermogen`,
      },
      { language: 'fr', label: `Conseiller en actifs financiers` },
      { language: 'en', label: `Financial assets advisor` },
    ],
  },

  {
    value: `Commercieel medewerker in de financiële sector`,
    labels: [
      {
        language: 'nl',
        label: `Commercieel medewerker in de financiële sector`,
      },
      { language: 'fr', label: `Employé de commerce dans le secteur financier` },
      { language: 'en', label: `Commercial employee in the financial sector` },
    ],
  },

  {
    value: `Accountmanager in de financiële sector`,
    labels: [
      {
        language: 'nl',
        label: `Accountmanager in de financiële sector`,
      },
      { language: 'fr', label: `Chargé de comptes dans le secteur financier` },
      { language: 'en', label: `Account manager in the financial sector` },
    ],
  },

  {
    value: `Accountant - Belastingsconsulent`,
    labels: [
      {
        language: 'nl',
        label: `Accountant - Belastingsconsulent`,
      },
      { language: 'fr', label: `Comptable - Conseiller fiscal` },
      { language: 'en', label: `Accountant - Tax consultant` },
    ],
  },

  {
    value: `Monteur installatietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Monteur installatietechnieken`,
      },
      { language: 'fr', label: `Technicien d'installation` },
      { language: 'en', label: `Installation technician` },
    ],
  },

  {
    value: `Onthaalmedewerker toerisme`,
    labels: [
      {
        language: 'nl',
        label: `Onthaalmedewerker toerisme`,
      },
      { language: 'fr', label: `Réceptionniste tourisme` },
      { language: 'en', label: `Tourism receptionist` },
    ],
  },

  {
    value: `Torenkraanbediener`,
    labels: [
      {
        language: 'nl',
        label: `Torenkraanbediener`,
      },
      { language: 'fr', label: `Opérateur de grue à tour` },
      { language: 'en', label: `Tower crane operator` },
    ],
  },

  {
    value: `Productiemedewerker prefab beton`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker prefab beton`,
      },
      { language: 'fr', label: `Employé de production béton préfabriqué` },
      { language: 'en', label: `Production employee precast concrete` },
    ],
  },

  {
    value: `Werfleider`,
    labels: [
      { language: 'nl', label: `Werfleider` },
      { language: 'fr', label: `Gestionnaire de chantier` },
      { language: 'en', label: `Site manager` },
    ],
  },

  {
    value: `Elektrotechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Elektrotechnicus`,
      },
      { language: 'fr', label: `Ingénieur éléctricien` },
      { language: 'en', label: `Electrical engineer` },
    ],
  },

  {
    value: `Productiemedewerker kunststofverwerking`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker kunststofverwerking`,
      },
      { language: 'fr', label: `Employé de production en transformation des matières plastiques` },
      { language: 'en', label: `Plastics processing production employee` },
    ],
  },

  {
    value: `Voorbewerker carrosserie`,
    labels: [
      {
        language: 'nl',
        label: `Voorbewerker carrosserie`,
      },
      { language: 'fr', label: `Préparateur de carrosserie` },
      { language: 'en', label: `Bodywork preparator` },
    ],
  },

  {
    value: `Enquêteur`,
    labels: [
      { language: 'nl', label: `Enquêteur` },
      { language: 'fr', label: `Sondeur` },
      { language: 'en', label: `Pollster` },
    ],
  },

  {
    value: `Horeca algemeen`,
    labels: [
      {
        language: 'nl',
        label: `Horeca algemeen`,
      },
      { language: 'fr', label: `L'industrie hôtelière en général` },
      { language: 'en', label: `Hospitality industry in general` },
    ],
  },

  {
    value: `Schoonmaker van ruimten en lokalen`,
    labels: [
      {
        language: 'nl',
        label: `Schoonmaker van ruimten en lokalen`,
      },
      { language: 'fr', label: `Nettoyeur de chambres et de locaux` },
      { language: 'en', label: `Cleaner of rooms and premises` },
    ],
  },

  {
    value: `Verantwoordelijke logistieke site`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke logistieke site`,
      },
      { language: 'fr', label: `Site logistique responsable` },
      { language: 'en', label: `Responsible logistics site` },
    ],
  },

  {
    value: `Sales manager`,
    labels: [
      { language: 'nl', label: `Sales manager` },
      { language: 'fr', label: `Directeur des ventes` },
      { language: 'en', label: `Sales manager` },
    ],
  },

  {
    value: `Loading supervisor luchtvaart`,
    labels: [
      {
        language: 'nl',
        label: `Loading supervisor luchtvaart`,
      },
      { language: 'fr', label: `Superviseur aéronautique de chargement` },
      { language: 'en', label: `Loading aviation supervisor` },
    ],
  },

  {
    value: `Behandelaar luchtvracht`,
    labels: [
      {
        language: 'nl',
        label: `Behandelaar luchtvracht`,
      },
      { language: 'fr', label: `Manutentionnaire de fret aérien` },
      { language: 'en', label: `Air freight handler` },
    ],
  },

  {
    value: `Productiemedewerker drukken`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker drukken`,
      },
      { language: 'fr', label: `Ouvrier de production d'imprimerie` },
      { language: 'en', label: `Printing production worker` },
    ],
  },

  {
    value: `Medewerker medisch secretariaat`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker medisch secretariaat`,
      },
      { language: 'fr', label: `Employée du secrétariat médical` },
      { language: 'en', label: `Medical secretariat employee` },
    ],
  },

  {
    value: `Asbestverwijderaar`,
    labels: [
      {
        language: 'nl',
        label: `Asbestverwijderaar`,
      },
      { language: 'fr', label: `Désamianteur` },
      { language: 'en', label: `Asbestos remover` },
    ],
  },

  {
    value: `Leidinggevende industriële productie`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende industriële productie`,
      },
      { language: 'fr', label: `Production industrielle leader` },
      { language: 'en', label: `Leading industrial production` },
    ],
  },

  {
    value: `Manager algemeen`,
    labels: [
      {
        language: 'nl',
        label: `Manager algemeen`,
      },
      { language: 'fr', label: `directeur général` },
      { language: 'en', label: `General manager` },
    ],
  },

  {
    value: `Stukadoor`,
    labels: [
      { language: 'nl', label: `Stukadoor` },
      { language: 'fr', label: `Plâtrier` },
      { language: 'en', label: `Plasterer` },
    ],
  },

  {
    value: `Aankoper`,
    labels: [
      { language: 'nl', label: `Aankoper` },
      { language: 'fr', label: `Acheteur` },
      { language: 'en', label: `Purchaser` },
    ],
  },

  {
    value: `Verantwoordelijke klantendienst`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke klantendienst`,
      },
      { language: 'fr', label: `Service client responsable` },
      { language: 'en', label: `Responsible customer service` },
    ],
  },

  {
    value: `Winkelmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Winkelmedewerker`,
      },
      { language: 'fr', label: `Vendeur` },
      { language: 'en', label: `Shop assistant` },
    ],
  },

  {
    value: `Leidinggevende productie elektrische en elektronische materialen`,
    labels: [
      {
        language: 'nl',
        label: `Leidinggevende productie elektrische en elektronische materialen`,
      },
      { language: 'fr', label: `Responsable de production de matériel électrique et électronique` },
      { language: 'en', label: `Manager of production of electrical and electronic materials` },
    ],
  },

  {
    value: `Medewerker industriële afwerking`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker industriële afwerking`,
      },
      { language: 'fr', label: `Employé de finition industrielle` },
      { language: 'en', label: `Industrial finishing employee` },
    ],
  },

  {
    value: `Regeltechnicus klimatisatie`,
    labels: [
      {
        language: 'nl',
        label: `Regeltechnicus klimatisatie`,
      },
      { language: 'fr', label: `Technicien en climatisation` },
      { language: 'en', label: `Climate control technician` },
    ],
  },

  {
    value: `Polyvalent podiumtechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Polyvalent podiumtechnicus`,
      },
      { language: 'fr', label: `Technicien de scène polyvalent` },
      { language: 'en', label: `Multipurpose stage technician` },
    ],
  },

  {
    value: `Verantwoordelijke planning en productiebeheer`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke planning en productiebeheer`,
      },
      {
        language: 'fr',
        label: `Responsable de la planification et de la gestion de la production`,
      },
      { language: 'en', label: `Responsible for planning and production management` },
    ],
  },

  {
    value: `Tuinaanlegger-groenbeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Tuinaanlegger-groenbeheerder`,
      },
      { language: 'fr', label: `Jardinier-responsable vert` },
      { language: 'en', label: `Gardener-green manager` },
    ],
  },

  {
    value: `Aansluiter van waterleidingen, rioleringen en warmtenetten`,
    labels: [
      {
        language: 'nl',
        label: `Aansluiter van waterleidingen, rioleringen en warmtenetten`,
      },
      {
        language: 'fr',
        label: `Raccordement des conduites d'eau, des égouts et des réseaux de chaleur`,
      },
      { language: 'en', label: `Connection of water pipes, sewers and heating networks` },
    ],
  },

  {
    value: `Tuinbouwmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Tuinbouwmedewerker`,
      },
      { language: 'fr', label: `Employé d'horticulture` },
      { language: 'en', label: `Horticulture employee` },
    ],
  },

  {
    value: `Technicus PC- en kantoormateriaal`,
    labels: [
      {
        language: 'nl',
        label: `Technicus PC- en kantoormateriaal`,
      },
      { language: 'fr', label: `Technicien informatique et matériel de bureau` },
      { language: 'en', label: `PC and office equipment technician` },
    ],
  },

  {
    value: `Insteller-bediener CNC werktuigmachines`,
    labels: [
      {
        language: 'nl',
        label: `Insteller-bediener CNC werktuigmachines`,
      },
      { language: 'fr', label: `Machines-outils à commande numérique ajusteur-opérateur` },
      { language: 'en', label: `Adjuster-operator CNC machine tools` },
    ],
  },

  {
    value: `Bankwerker`,
    labels: [
      { language: 'nl', label: `Bankwerker` },
      { language: 'fr', label: `Employé de banque` },
      { language: 'en', label: `Bank worker` },
    ],
  },

  {
    value: `Netwerk engineer telecom`,
    labels: [
      {
        language: 'nl',
        label: `Netwerk engineer telecom`,
      },
      { language: 'fr', label: `Ingénieur réseaux télécom` },
      { language: 'en', label: `Network engineer telecom` },
    ],
  },

  {
    value: `Eventmanager`,
    labels: [
      { language: 'nl', label: `Eventmanager` },
      { language: 'fr', label: `Responsable de l'événement` },
      { language: 'en', label: `Event manager` },
    ],
  },

  {
    value: `Operator energetische en petrochemische installaties`,
    labels: [
      {
        language: 'nl',
        label: `Operator energetische en petrochemische installaties`,
      },
      { language: 'fr', label: `Opérateur d'installations énergétiques et pétrochimiques` },
      { language: 'en', label: `Operator of energetic and petrochemical installations` },
    ],
  },

  {
    value: `Bekister-betonneerder`,
    labels: [
      {
        language: 'nl',
        label: `Bekister-betonneerder`,
      },
      { language: 'fr', label: `Coffrage-béton` },
      { language: 'en', label: `Formwork-concreter` },
    ],
  },

  {
    value: `Promotiemedewerker toerisme`,
    labels: [
      {
        language: 'nl',
        label: `Promotiemedewerker toerisme`,
      },
      { language: 'fr', label: `Chargée de promotion touristique` },
      { language: 'en', label: `Tourism promotion officer` },
    ],
  },

  {
    value: `Kraanbestuurder`,
    labels: [
      {
        language: 'nl',
        label: `Kraanbestuurder`,
      },
      { language: 'fr', label: `Grutier` },
      { language: 'en', label: `Crane operator` },
    ],
  },

  {
    value: `Koerier besteller`,
    labels: [
      {
        language: 'nl',
        label: `Koerier besteller`,
      },
      { language: 'fr', label: `Commandeur de messagerie` },
      { language: 'en', label: `Courier orderer` },
    ],
  },

  {
    value: `Digitaal drukker`,
    labels: [
      {
        language: 'nl',
        label: `Digitaal drukker`,
      },
      { language: 'fr', label: `Imprimante numérique` },
      { language: 'en', label: `Digital printer` },
    ],
  },

  {
    value: `Bijrijder`,
    labels: [
      { language: 'nl', label: `Bijrijder` },
      { language: 'fr', label: `Copilote` },
      { language: 'en', label: `Co-driver` },
    ],
  },

  {
    value: `Verantwoordelijke industrieel onderhoud`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke industrieel onderhoud`,
      },
      { language: 'fr', label: `Maintenance industrielle responsable` },
      { language: 'en', label: `Responsible industrial maintenance` },
    ],
  },

  {
    value: `Verantwoordelijke organisatie voor goederenvervoer over de weg`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke organisatie voor goederenvervoer over de weg`,
      },
      { language: 'fr', label: `Organisation responsable du transport routier de marchandises` },
      { language: 'en', label: `Responsible organization for road freight transport` },
    ],
  },

  {
    value: `Magazijnbeheerder`,
    labels: [
      {
        language: 'nl',
        label: `Magazijnbeheerder`,
      },
      { language: 'fr', label: `Directeur d'entrepôt` },
      { language: 'en', label: `Warehouse manager` },
    ],
  },

  {
    value: `Bestuurder van een rolbrug`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder van een rolbrug`,
      },
      { language: 'fr', label: `Conducteur de grue` },
      { language: 'en', label: `Driver of a crane` },
    ],
  },

  {
    value: `Operator energetische en petrochemische installaties`,
    labels: [
      {
        language: 'nl',
        label: `Operator energetische en petrochemische installaties`,
      },
      { language: 'fr', label: `Opérateur d'installations énergétiques et pétrochimiques` },
      { language: 'en', label: `Operator of energetic and petrochemical installations` },
    ],
  },

  {
    value: `Verantwoordelijke werving en opleiding`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke werving en opleiding`,
      },
      { language: 'fr', label: `Responsable du recrutement et de la formation` },
      { language: 'en', label: `Responsible for recruitment and training` },
    ],
  },

  {
    value: `Autocarchauffeur`,
    labels: [
      {
        language: 'nl',
        label: `Autocarchauffeur`,
      },
      { language: 'fr', label: `Chauffeur d'autocar` },
      { language: 'en', label: `Coach driver` },
    ],
  },

  {
    value: `Meubelmaker`,
    labels: [
      { language: 'nl', label: `Meubelmaker` },
      { language: 'fr', label: `Ébéniste` },
      { language: 'en', label: `Cabinet maker` },
    ],
  },

  {
    value: `Procesoperator voedingsindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator voedingsindustrie`,
      },
      { language: 'fr', label: `Opérateur de process agroalimentaire` },
      { language: 'en', label: `Food industry process operator` },
    ],
  },

  {
    value: `Operator productie van stortklaar beton, cement, asfalt en granulaten`,
    labels: [
      {
        language: 'nl',
        label: `Operator productie van stortklaar beton, cement, asfalt en granulaten`,
      },
      {
        language: 'fr',
        label: `Opérateur production de béton prêt à l'emploi, ciment, asphalte et granulés`,
      },
      {
        language: 'en',
        label: `Operator production of ready-mixed concrete, cement, asphalt and granules`,
      },
    ],
  },

  {
    value: `Boekhoudkundig assistent`,
    labels: [
      {
        language: 'nl',
        label: `Boekhoudkundig assistent`,
      },
      { language: 'fr', label: `Assistant de comptabilité` },
      { language: 'en', label: `Accounting assistant` },
    ],
  },

  {
    value: `Dispatcher personenvervoer over de weg`,
    labels: [
      {
        language: 'nl',
        label: `Dispatcher personenvervoer over de weg`,
      },
      { language: 'fr', label: `Répartiteur de transport routier de personnes` },
      { language: 'en', label: `Road passenger transport dispatcher` },
    ],
  },

  {
    value: `Operator CNC-gestuurde houtbewerkingsmachines`,
    labels: [
      {
        language: 'nl',
        label: `Operator CNC-gestuurde houtbewerkingsmachines`,
      },
      { language: 'fr', label: `Opérateur de machines à bois à commande numérique` },
      { language: 'en', label: `Operator CNC controlled woodworking machines` },
    ],
  },

  {
    value: `Productieoperator elektrische en elektronische componenten`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator elektrische en elektronische componenten`,
      },
      {
        language: 'fr',
        label: `Opérateur de production de composants électriques et électroniques`,
      },
      { language: 'en', label: `Production operator of electrical and electronic components` },
    ],
  },

  {
    value: `Salesteam verantwoordelijke`,
    labels: [
      {
        language: 'nl',
        label: `Salesteam verantwoordelijke`,
      },
      { language: 'fr', label: `Responsable équipe commerciale` },
      { language: 'en', label: `Sales team responsible` },
    ],
  },

  {
    value: `Administratief en financieel verantwoordelijke`,
    labels: [
      {
        language: 'nl',
        label: `Administratief en financieel verantwoordelijke`,
      },
      { language: 'fr', label: `Responsable administratif et financier` },
      { language: 'en', label: `Administrative and financial manager` },
    ],
  },

  {
    value: `Customer experience manager`,
    labels: [
      {
        language: 'nl',
        label: `Customer experience manager`,
      },
      { language: 'fr', label: `Responsable expérience client` },
      { language: 'en', label: `Customer experience manager` },
    ],
  },

  {
    value: `Monteur van staalbouwelementen`,
    labels: [
      {
        language: 'nl',
        label: `Monteur van staalbouwelementen`,
      },
      { language: 'fr', label: `Installateur d'éléments de construction en acier` },
      { language: 'en', label: `Installer of steel construction elements` },
    ],
  },

  {
    value: `Beheerder back- en middle office financiële markten`,
    labels: [
      {
        language: 'nl',
        label: `Beheerder back- en middle office financiële markten`,
      },
      { language: 'fr', label: `Responsable back et middle office marchés financiers` },
      { language: 'en', label: `Manager back and middle office financial markets` },
    ],
  },

  {
    value: `Digital sales assistant`,
    labels: [
      {
        language: 'nl',
        label: `Digital sales assistant`,
      },
      { language: 'fr', label: `Assistante commerciale numérique` },
      { language: 'en', label: `Digital sales assistant` },
    ],
  },

  {
    value: `Schoonheidsspecialist`,
    labels: [
      {
        language: 'nl',
        label: `Schoonheidsspecialist`,
      },
      { language: 'fr', label: `Esthéticienne` },
      { language: 'en', label: `Beauty therapist` },
    ],
  },

  {
    value: `Keukenmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Keukenmedewerker`,
      },
      { language: 'fr', label: `Ouvrier de cuisine` },
      { language: 'en', label: `Kitchen worker` },
    ],
  },

  {
    value: `Bewakingsagent `,
    labels: [
      {
        language: 'nl',
        label: `Bewakingsagent `,
      },
      { language: 'fr', label: `Garde de sécurité` },
      { language: 'en', label: `Security guard` },
    ],
  },

  {
    value: `Brandertechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Brandertechnicus`,
      },
      { language: 'fr', label: `Technicien brûleur` },
      { language: 'en', label: `Burner technician` },
    ],
  },

  {
    value: `Brood- en banketbakker`,
    labels: [
      {
        language: 'nl',
        label: `Brood- en banketbakker`,
      },
      { language: 'fr', label: `Boulanger et pâtissier` },
      { language: 'en', label: `Bread and pastry chef` },
    ],
  },

  {
    value: `Operator voorbereiding en bevoorrading weverij`,
    labels: [
      {
        language: 'nl',
        label: `Operator voorbereiding en bevoorrading weverij`,
      },
      {
        language: 'fr',
        label: `Préparation des opérateurs et approvisionnement du métier à tisser`,
      },
      { language: 'en', label: `Operator preparation and supply weaving mill` },
    ],
  },

  {
    value: `Medewerker groen- en tuinbeheer en aanleg`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker groen- en tuinbeheer en aanleg`,
      },
      {
        language: 'fr',
        label: `Employé de gestion des espaces verts et des jardins et de la construction`,
      },
      { language: 'en', label: `Green and garden management and construction employee` },
    ],
  },

  {
    value: `Dakdekker schuine daken`,
    labels: [
      {
        language: 'nl',
        label: `Dakdekker schuine daken`,
      },
      { language: 'fr', label: `Couvreur pour toits en pente` },
      { language: 'en', label: `Roofer for sloping roofs` },
    ],
  },

  {
    value: `Dakdekker platte daken`,
    labels: [
      {
        language: 'nl',
        label: `Dakdekker platte daken`,
      },
      { language: 'fr', label: `Couvreur de toit plat` },
      { language: 'en', label: `Flat roof roofer` },
    ],
  },

  {
    value: `Bouwkundig tekenaar`,
    labels: [
      {
        language: 'nl',
        label: `Bouwkundig tekenaar`,
      },
      { language: 'fr', label: `Dessinateur en architecture` },
      { language: 'en', label: `Architectural draftsman` },
    ],
  },

  {
    value: `Technicus veiligheid, hygiëne en leefmilieu`,
    labels: [
      {
        language: 'nl',
        label: `Technicus veiligheid, hygiëne en leefmilieu`,
      },
      { language: 'fr', label: `Technicien en sécurité, hygiène et environnement` },
      { language: 'en', label: `Safety, hygiene and environment technician` },
    ],
  },

  {
    value: `Beveiligingstechnicus`,
    labels: [
      {
        language: 'nl',
        label: `Beveiligingstechnicus`,
      },
      { language: 'fr', label: `Technicien de sécurité` },
      { language: 'en', label: `Security technician` },
    ],
  },

  {
    value: `Bestuurder stapelaar-pallettruck`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder stapelaar-pallettruck`,
      },
      { language: 'fr', label: `Conducteur de gerbeur-transpalette` },
      { language: 'en', label: `Stacker-pallet truck driver` },
    ],
  },

  {
    value: `Dossierbeheerder Boekhouden`,
    labels: [
      {
        language: 'nl',
        label: `Dossierbeheerder Boekhouden`,
      },
      { language: 'fr', label: `Comptabilité du gestionnaire de fichiers` },
      { language: 'en', label: `File Manager Accounting` },
    ],
  },

  {
    value: `Fietshersteller`,
    labels: [
      {
        language: 'nl',
        label: `Fietshersteller`,
      },
      { language: 'fr', label: `Réparateur de vélos` },
      { language: 'en', label: `Bicycle repairman` },
    ],
  },

  {
    value: `Technicus installatietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Technicus installatietechnieken`,
      },
      { language: 'fr', label: `Techniques d'installation des techniciens` },
      { language: 'en', label: `Technician installation techniques` },
    ],
  },

  {
    value: `Werkplaatsschrijnwerker`,
    labels: [
      {
        language: 'nl',
        label: `Werkplaatsschrijnwerker`,
      },
      { language: 'fr', label: `Charpentier d'atelier` },
      { language: 'en', label: `Workshop carpenter` },
    ],
  },

  {
    value: `Medewerker uitvaartdiensten`,
    labels: [
      {
        language: 'nl',
        label: `Medewerker uitvaartdiensten`,
      },
      { language: 'fr', label: `Employé des services funéraires` },
      { language: 'en', label: `Funeral services employee` },
    ],
  },

  {
    value: `Hotelreceptionist`,
    labels: [
      {
        language: 'nl',
        label: `Hotelreceptionist`,
      },
      { language: 'fr', label: `Réceptionniste d'hôtel` },
      { language: 'en', label: `Hotel receptionist` },
    ],
  },

  {
    value: `Technicus installatietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Technicus installatietechnieken`,
      },
      { language: 'fr', label: `Techniques d'installation des techniciens` },
      { language: 'en', label: `Technician installation techniques` },
    ],
  },

  {
    value: `Marketingmanager`,
    labels: [
      {
        language: 'nl',
        label: `Marketingmanager`,
      },
      { language: 'fr', label: `Responsable marketing` },
      { language: 'en', label: `Marketing manager` },
    ],
  },

  {
    value: `Onderzoeker exacte wetenschappen`,
    labels: [
      {
        language: 'nl',
        label: `Onderzoeker exacte wetenschappen`,
      },
      { language: 'fr', label: `Chercheur en sciences exactes` },
      { language: 'en', label: `Researcher in exact sciences` },
    ],
  },

  {
    value: `Productiemedewerker prefab beton`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker prefab beton`,
      },
      { language: 'fr', label: `Employé de production béton préfabriqué` },
      { language: 'en', label: `Production employee precast concrete` },
    ],
  },

  {
    value: `Onderhoudsmecanicien van personenwagens en lichte bedrijfsvoertuigen`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmecanicien van personenwagens en lichte bedrijfsvoertuigen`,
      },
      {
        language: 'fr',
        label: `Mécanicien d'entretien de voitures particulières et de véhicules utilitaires légers`,
      },
      {
        language: 'en',
        label: `Maintenance mechanic of passenger cars and light commercial vehicles`,
      },
    ],
  },

  {
    value: `Vloerder-tegelzetter`,
    labels: [
      {
        language: 'nl',
        label: `Vloerder-tegelzetter`,
      },
      { language: 'fr', label: `Carreleur` },
      { language: 'en', label: `Floor tiler` },
    ],
  },

  {
    value: `Financieel analist`,
    labels: [
      {
        language: 'nl',
        label: `Financieel analist`,
      },
      { language: 'fr', label: `Analyste financier` },
      { language: 'en', label: `Financial analyst` },
    ],
  },

  {
    value: `Kinderbegeleider baby's en peuters`,
    labels: [
      {
        language: 'nl',
        label: `Kinderbegeleider baby's en peuters`,
      },
      { language: 'fr', label: `Éducatrice en puériculture auprès des bébés et des tout-petits` },
      { language: 'en', label: `Childcare worker for babies and toddlers` },
    ],
  },

  {
    value: `Onderhoudsmecanicien in de industrie`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmecanicien in de industrie`,
      },
      { language: 'fr', label: `Mécanicien d'entretien dans l'industrie` },
      { language: 'en', label: `Maintenance mechanic in the industry` },
    ],
  },

  {
    value: `Front-office medewerker in de financiële sector`,
    labels: [
      {
        language: 'nl',
        label: `Front-office medewerker in de financiële sector`,
      },
      { language: 'fr', label: `Employé de réception dans le secteur financier` },
      { language: 'en', label: `Front office employee in the financial sector` },
    ],
  },

  {
    value: `Gevelrenoveerder-betonhersteller`,
    labels: [
      {
        language: 'nl',
        label: `Gevelrenoveerder-betonhersteller`,
      },
      { language: 'fr', label: `Rénovateur de façade-réparateur de béton` },
      { language: 'en', label: `Facade renovator-concrete repairer` },
    ],
  },

  {
    value: `Rigger-monteerder`,
    labels: [
      {
        language: 'nl',
        label: `Rigger-monteerder`,
      },
      { language: 'fr', label: `Installateur de gréeurs` },
      { language: 'en', label: `Rigger installer` },
    ],
  },

  {
    value: `Industrieel elektromecanicien`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel elektromecanicien`,
      },
      { language: 'fr', label: `Électromécanique industrielle` },
      { language: 'en', label: `Industrial electromechanic` },
    ],
  },

  {
    value: `Digital marketeer`,
    labels: [
      {
        language: 'nl',
        label: `Digital marketeer`,
      },
      { language: 'fr', label: `Spécialiste du marketing numérique` },
      { language: 'en', label: `Digital marketer` },
    ],
  },

  {
    value: `Monteur installatietechnieken`,
    labels: [
      {
        language: 'nl',
        label: `Monteur installatietechnieken`,
      },
      { language: 'fr', label: `Technicien d'installation` },
      { language: 'en', label: `Installation technician` },
    ],
  },

  {
    value: `Technicus industriële elektriciteit`,
    labels: [
      {
        language: 'nl',
        label: `Technicus industriële elektriciteit`,
      },
      { language: 'fr', label: `Technicien en électricité industrielle` },
      { language: 'en', label: `Industrial electricity technician` },
    ],
  },

  {
    value: `Schilder-decorateur`,
    labels: [
      {
        language: 'nl',
        label: `Schilder-decorateur`,
      },
      { language: 'fr', label: `Peintre-décorateur` },
      { language: 'en', label: `Painter-decorator` },
    ],
  },

  {
    value: `Monteur van metalen gevel- en dakelementen`,
    labels: [
      {
        language: 'nl',
        label: `Monteur van metalen gevel- en dakelementen`,
      },
      { language: 'fr', label: `Installateur d'éléments de façade et de toiture métalliques` },
      { language: 'en', label: `Installer of metal facade and roof elements` },
    ],
  },

  {
    value: `Vertegenwoordiger B2B`,
    labels: [
      {
        language: 'nl',
        label: `Vertegenwoordiger B2B`,
      },
      { language: 'fr', label: `Représentant B2B` },
      { language: 'en', label: `B2B Representative` },
    ],
  },

  {
    value: `Vertegenwoordiger B2C`,
    labels: [
      {
        language: 'nl',
        label: `Vertegenwoordiger B2C`,
      },
      { language: 'fr', label: `Représentant B2C` },
      { language: 'en', label: `B2C Representative` },
    ],
  },

  {
    value: `Elektricien`,
    labels: [
      { language: 'nl', label: `Elektricien` },
      { language: 'fr', label: `Électricien` },
      { language: 'en', label: `Electrician` },
    ],
  },

  {
    value: `Menger-bereider van grondstoffen`,
    labels: [
      {
        language: 'nl',
        label: `Menger-bereider van grondstoffen`,
      },
      { language: 'fr', label: `Mélangeur-préparateur de matières premières` },
      { language: 'en', label: `Mixer-preparer of raw materials` },
    ],
  },

  {
    value: `Barman`,
    labels: [
      { language: 'nl', label: `Barman` },
      { language: 'fr', label: `Barman` },
      { language: 'en', label: `Bartender` },
    ],
  },

  {
    value: `Ontginner vaste delfstoffen`,
    labels: [
      {
        language: 'nl',
        label: `Ontginner vaste delfstoffen`,
      },
      { language: 'fr', label: `Extracteur de minéraux solides` },
      { language: 'en', label: `Solid mineral extractor` },
    ],
  },

  {
    value: `Tuinbouwer`,
    labels: [
      { language: 'nl', label: `Tuinbouwer` },
      { language: 'fr', label: `Horticulteur` },
      { language: 'en', label: `Horticulturist` },
    ],
  },

  {
    value: `Projectleider bouw en openbare werken`,
    labels: [
      {
        language: 'nl',
        label: `Projectleider bouw en openbare werken`,
      },
      { language: 'fr', label: `Chef de projet bâtiment et travaux publics` },
      { language: 'en', label: `Project manager construction and public works` },
    ],
  },

  {
    value: `Teamleader`,
    labels: [
      { language: 'nl', label: `Teamleader` },
      { language: 'fr', label: `Chef d'équipe` },
      { language: 'en', label: `Team leader` },
    ],
  },

  {
    value: `Productiemedewerker textielproductielijn`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker textielproductielijn`,
      },
      { language: 'fr', label: `Ouvrier de production ligne de production textile` },
      { language: 'en', label: `Production worker textile production line` },
    ],
  },

  {
    value: `Verpakkingsoperator`,
    labels: [
      {
        language: 'nl',
        label: `Verpakkingsoperator`,
      },
      { language: 'fr', label: `Opérateur de conditionnement` },
      { language: 'en', label: `Packaging operator` },
    ],
  },

  {
    value: `Operator montage en assemblage`,
    labels: [
      {
        language: 'nl',
        label: `Operator montage en assemblage`,
      },
      { language: 'fr', label: `Opérateur d'installation et de montage` },
      { language: 'en', label: `Installation and assembly operator` },
    ],
  },

  {
    value: `Kwaliteitscontroleur textiel leder en confectie`,
    labels: [
      {
        language: 'nl',
        label: `Kwaliteitscontroleur textiel leder en confectie`,
      },
      { language: 'fr', label: `Contrôleur qualité textile, cuir et prêt-à-porter` },
      { language: 'en', label: `Quality controller for textiles, leather and ready-to-wear` },
    ],
  },

  {
    value: `Plaatser binnenschrijnwerk`,
    labels: [
      {
        language: 'nl',
        label: `Plaatser binnenschrijnwerk`,
      },
      { language: 'fr', label: `Installateur de menuiseries intérieures` },
      { language: 'en', label: `Installer of interior joinery` },
    ],
  },

  {
    value: `Jurist`,
    labels: [
      { language: 'nl', label: `Jurist` },
      { language: 'fr', label: `Avocat` },
      { language: 'en', label: `Lawyer` },
    ],
  },

  {
    value: `Onderhoudstechnicus liften`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudstechnicus liften`,
      },
      { language: 'fr', label: `Technicien d'entretien d'ascenseur` },
      { language: 'en', label: `Elevator maintenance technician` },
    ],
  },

  {
    value: `Schrijnwerker houtbouw`,
    labels: [
      {
        language: 'nl',
        label: `Schrijnwerker houtbouw`,
      },
      { language: 'fr', label: `Menuisier en menuiserie` },
      { language: 'en', label: `Woodwork carpenter` },
    ],
  },

  {
    value: `Ambachtelijk houtbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Ambachtelijk houtbewerker`,
      },
      { language: 'fr', label: `Menuisier traditionnel` },
      { language: 'en', label: `Traditional woodworker` },
    ],
  },

  {
    value: `TIG-lasser`,
    labels: [
      { language: 'nl', label: `TIG-lasser` },
      { language: 'fr', label: `Soudeur tig` },
      { language: 'en', label: `TIG welder` },
    ],
  },

  {
    value: `Kok`,
    labels: [
      { language: 'nl', label: `Kok` },
      { language: 'fr', label: `Cuisiner` },
      { language: 'en', label: `Cook` },
    ],
  },

  {
    value: `Plaatser buitenschrijnwerk`,
    labels: [
      {
        language: 'nl',
        label: `Plaatser buitenschrijnwerk`,
      },
      { language: 'fr', label: `Installateur de menuiserie extérieure` },
      { language: 'en', label: `Installer of exterior carpentry` },
    ],
  },

  {
    value: `Onderhoudsmedewerker gebouwen`,
    labels: [
      {
        language: 'nl',
        label: `Onderhoudsmedewerker gebouwen`,
      },
      { language: 'fr', label: `Employé d'entretien d'immeuble` },
      { language: 'en', label: `Building maintenance employee` },
    ],
  },

  {
    value: `Kapper`,
    labels: [
      { language: 'nl', label: `Kapper` },
      { language: 'fr', label: `Coiffeur` },
      { language: 'en', label: `Barber` },
    ],
  },

  {
    value: `Machinaal houtbewerker`,
    labels: [
      {
        language: 'nl',
        label: `Machinaal houtbewerker`,
      },
      { language: 'fr', label: `Menuisier mécanique` },
      { language: 'en', label: `Mechanical woodworker` },
    ],
  },

  {
    value: `Vrachtwagenbestuurder`,
    labels: [
      {
        language: 'nl',
        label: `Vrachtwagenbestuurder`,
      },
      { language: 'fr', label: `Conducteur de camion` },
      { language: 'en', label: `Truck driver` },
    ],
  },

  {
    value: `Chauffeur`,
    labels: [
      { language: 'nl', label: `Chauffeur` },
      { language: 'fr', label: `Conducteur` },
      { language: 'en', label: `Driver` },
    ],
  },

  {
    value: `Laborant industriële productie`,
    labels: [
      {
        language: 'nl',
        label: `Laborant industriële productie`,
      },
      { language: 'fr', label: `Technicien de laboratoire de production industrielle` },
      { language: 'en', label: `Industrial production laboratory technician` },
    ],
  },

  {
    value: `Medisch laboratorium technoloog`,
    labels: [
      {
        language: 'nl',
        label: `Medisch laboratorium technoloog`,
      },
      { language: 'fr', label: `Technologue de laboratoire médical` },
      { language: 'en', label: `Medical laboratory technologist` },
    ],
  },

  {
    value: `Personeelsmedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Personeelsmedewerker`,
      },
      { language: 'fr', label: `Employé RH` },
      { language: 'en', label: `HR employee` },
    ],
  },

  {
    value: `Logistiek assistent in zorginstellingen`,
    labels: [
      {
        language: 'nl',
        label: `Logistiek assistent in zorginstellingen`,
      },
      { language: 'fr', label: `Assistante logistique dans les établissements de santé` },
      { language: 'en', label: `Logistics assistant in healthcare institutions` },
    ],
  },

  {
    value: `Human resources manager`,
    labels: [
      {
        language: 'nl',
        label: `Human resources manager`,
      },
      { language: 'fr', label: `Directeur des Ressources Humaines` },
      { language: 'en', label: `Human resources manager` },
    ],
  },

  {
    value: `Management assistent`,
    labels: [
      {
        language: 'nl',
        label: `Management assistent`,
      },
      { language: 'fr', label: `Assistante de direction` },
      { language: 'en', label: `Management Assistant` },
    ],
  },

  {
    value: `Financieel manager`,
    labels: [
      {
        language: 'nl',
        label: `Financieel manager`,
      },
      { language: 'fr', label: `Manager financier` },
      { language: 'en', label: `Financial manager` },
    ],
  },

  {
    value: `Voeger`,
    labels: [
      { language: 'nl', label: `Voeger` },
      { language: 'fr', label: `Additionneur` },
      { language: 'en', label: `Adder` },
    ],
  },

  {
    value: `Technisch-administratief medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Technisch-administratief medewerker`,
      },
      { language: 'fr', label: `Employé technico-administratif` },
      { language: 'en', label: `Technical-administrative employee` },
    ],
  },

  {
    value: `Boekhouder-boekhouder fiscalist`,
    labels: [
      {
        language: 'nl',
        label: `Boekhouder-boekhouder fiscalist`,
      },
      { language: 'fr', label: `Teneur de livres-comptable fiscaliste` },
      { language: 'en', label: `Bookkeeper-bookkeeper tax specialist` },
    ],
  },

  {
    value: `Monteur bedrader elektronica`,
    labels: [
      {
        language: 'nl',
        label: `Monteur bedrader elektronica`,
      },
      { language: 'fr', label: `Technicien en câblage électronique` },
      { language: 'en', label: `Electronics wiring technician` },
    ],
  },

  {
    value: `Mode- en textielontwerper`,
    labels: [
      {
        language: 'nl',
        label: `Mode- en textielontwerper`,
      },
      { language: 'fr', label: `Créatrice de mode et textile` },
      { language: 'en', label: `Fashion and textile designer` },
    ],
  },

  {
    value: `Elektrotechnisch installateur`,
    labels: [
      {
        language: 'nl',
        label: `Elektrotechnisch installateur`,
      },
      { language: 'fr', label: `Installateur électrique` },
      { language: 'en', label: `Electrical installer` },
    ],
  },

  {
    value: `Industrieel reiniger`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel reiniger`,
      },
      { language: 'fr', label: `Nettoyant industriel` },
      { language: 'en', label: `Industrial cleaner` },
    ],
  },

  {
    value: `Ingenieur algemeen`,
    labels: [
      {
        language: 'nl',
        label: `Ingenieur algemeen`,
      },
      { language: 'fr', label: `Ingénieur généraliste` },
      { language: 'en', label: `General engineer` },
    ],
  },

  {
    value: `Contactcenter medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Contactcenter medewerker`,
      },
      { language: 'fr', label: `Employé du centre de contact` },
      { language: 'en', label: `Contact center employee` },
    ],
  },

  {
    value: `Industrieel en logistiek planner`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel en logistiek planner`,
      },
      { language: 'fr', label: `Planificateur industriel et logistique` },
      { language: 'en', label: `Industrial and logistics planner` },
    ],
  },

  {
    value: `Productieoperator voedingsindustrie`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator voedingsindustrie`,
      },
      { language: 'fr', label: `Opérateur de production agroalimentaire` },
      { language: 'en', label: `Food industry production operator` },
    ],
  },

  {
    value: `Winkelverkoper`,
    labels: [
      { language: 'nl', label: `Winkelverkoper` },
      { language: 'fr', label: `Vendeuse en magasin` },
      { language: 'en', label: `Shop salesperson` },
    ],
  },

  {
    value: `Industrieel schilder`,
    labels: [
      {
        language: 'nl',
        label: `Industrieel schilder`,
      },
      { language: 'fr', label: `Peintre industriel` },
      { language: 'en', label: `Industrial painter` },
    ],
  },

  {
    value: `Kwaliteitscontroleur mechanische en metalen constructies`,
    labels: [
      {
        language: 'nl',
        label: `Kwaliteitscontroleur mechanische en metalen constructies`,
      },
      { language: 'fr', label: `Contrôleur qualité constructions mécaniques et métalliques` },
      { language: 'en', label: `Quality controller mechanical and metal constructions` },
    ],
  },

  {
    value: `Verantwoordelijke kwaliteitscontrole`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke kwaliteitscontrole`,
      },
      { language: 'fr', label: `Contrôle de qualité responsable` },
      { language: 'en', label: `Responsible quality control` },
    ],
  },

  {
    value: `Insteller-bediener van conventionele werktuigmachines`,
    labels: [
      {
        language: 'nl',
        label: `Insteller-bediener van conventionele werktuigmachines`,
      },
      { language: 'fr', label: `Ajusteur-opérateur de machines-outils conventionnelles` },
      { language: 'en', label: `Adjuster-operator of conventional machine tools` },
    ],
  },

  {
    value: `Logistiek verantwoordelijke`,
    labels: [
      {
        language: 'nl',
        label: `Logistiek verantwoordelijke`,
      },
      { language: 'fr', label: `Gestionnaire de la logistique` },
      { language: 'en', label: `Logistics manager` },
    ],
  },

  {
    value: `Dispatcher goederenvervoer over de weg`,
    labels: [
      {
        language: 'nl',
        label: `Dispatcher goederenvervoer over de weg`,
      },
      { language: 'fr', label: `Répartiteur de fret routier` },
      { language: 'en', label: `Road freight dispatcher` },
    ],
  },

  {
    value: `Reachtruckchauffeur`,
    labels: [
      {
        language: 'nl',
        label: `Reachtruckchauffeur`,
      },
      { language: 'fr', label: `Chauffeur de camion` },
      { language: 'en', label: `Reach truck driver` },
    ],
  },

  {
    value: `Expediteur`,
    labels: [
      { language: 'nl', label: `Expediteur` },
      { language: 'fr', label: `Transitaire` },
      { language: 'en', label: `Forwarder` },
    ],
  },

  {
    value: `Procesoperator chemische en farmaceutische industrie`,
    labels: [
      {
        language: 'nl',
        label: `Procesoperator chemische en farmaceutische industrie`,
      },
      {
        language: 'fr',
        label: `Opérateur de procédés dans l'industrie chimique et pharmaceutique`,
      },
      { language: 'en', label: `Process operator in the chemical and pharmaceutical industry` },
    ],
  },

  {
    value: `Verzekeringsadviseur`,
    labels: [
      {
        language: 'nl',
        label: `Verzekeringsadviseur`,
      },
      { language: 'fr', label: `Conseiller en assurance` },
      { language: 'en', label: `Insurance advisor` },
    ],
  },

  {
    value: `Planner goederenbehandeling`,
    labels: [
      {
        language: 'nl',
        label: `Planner goederenbehandeling`,
      },
      { language: 'fr', label: `Planificateur de manutention du fret` },
      { language: 'en', label: `Freight handling planner` },
    ],
  },

  {
    value: `Reachtruckchauffeur met attest`,
    labels: [
      {
        language: 'nl',
        label: `Reachtruckchauffeur met attest`,
      },
      { language: 'fr', label: `Chauffeur de camion avec certificat` },
      { language: 'en', label: `Reach truck driver with certificate` },
    ],
  },

  {
    value: `Heftruckchauffeur`,
    labels: [
      {
        language: 'nl',
        label: `Heftruckchauffeur`,
      },
      { language: 'fr', label: `Conducteur de chariot élévateur` },
      { language: 'en', label: `Forklift driver` },
    ],
  },

  {
    value: `Productieoperator metaalbewerking`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator metaalbewerking`,
      },
      { language: 'fr', label: `Opérateur de production en métallurgie` },
      { language: 'en', label: `Metalworking production operator` },
    ],
  },

  {
    value: `Wegenwerker`,
    labels: [
      { language: 'nl', label: `Wegenwerker` },
      { language: 'fr', label: `Ouvrier routier` },
      { language: 'en', label: `Road worker` },
    ],
  },

  {
    value: `E-commerce manager`,
    labels: [
      {
        language: 'nl',
        label: `E-commerce manager`,
      },
      { language: 'fr', label: `Responsable du commerce électronique` },
      { language: 'en', label: `Ecommerce manager` },
    ],
  },

  {
    value: `Communicatiedeskundige`,
    labels: [
      {
        language: 'nl',
        label: `Communicatiedeskundige`,
      },
      { language: 'fr', label: `Experte en communication` },
      { language: 'en', label: `Communications expert` },
    ],
  },

  {
    value: `Verantwoordelijke verkoopadministratie`,
    labels: [
      {
        language: 'nl',
        label: `Verantwoordelijke verkoopadministratie`,
      },
      { language: 'fr', label: `Administration des ventes responsable` },
      { language: 'en', label: `Responsible sales administration` },
    ],
  },

  {
    value: `Orderpicker`,
    labels: [
      { language: 'nl', label: `Orderpicker` },
      { language: 'fr', label: `Préparateur de commandes` },
      { language: 'en', label: `Order picker` },
    ],
  },

  {
    value: `Commercieel medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Commercieel medewerker`,
      },
      { language: 'fr', label: `Assistant commercial` },
      { language: 'en', label: `Commercial assistant` },
    ],
  },

  {
    value: `Bestuurder van bouwplaatsmachines`,
    labels: [
      {
        language: 'nl',
        label: `Bestuurder van bouwplaatsmachines`,
      },
      { language: 'fr', label: `Opérateur d'engins de chantier` },
      { language: 'en', label: `Construction site machine operator` },
    ],
  },

  {
    value: `Productieoperator textielproductielijn`,
    labels: [
      {
        language: 'nl',
        label: `Productieoperator textielproductielijn`,
      },
      { language: 'fr', label: `Opérateur de production ligne de production textile` },
      { language: 'en', label: `Production operator textile production line` },
    ],
  },

  {
    value: `Werfbediener ruwbouw`,
    labels: [
      {
        language: 'nl',
        label: `Werfbediener ruwbouw`,
      },
      { language: 'fr', label: `Opérateur de chantier` },
      { language: 'en', label: `Construction site operator` },
    ],
  },

  {
    value: `Polyvalent administratief medewerker`,
    labels: [
      {
        language: 'nl',
        label: `Polyvalent administratief medewerker`,
      },
      { language: 'fr', label: `Assistante administrative polyvalente` },
      { language: 'en', label: `Multi-purpose administrative assistant` },
    ],
  },

  {
    value: `Monteur-demonteur carrosserie`,
    labels: [
      {
        language: 'nl',
        label: `Monteur-demonteur carrosserie`,
      },
      { language: 'fr', label: `Mécanicien-démonteur de carrosserie` },
      { language: 'en', label: `Mechanic-dismantler bodywork` },
    ],
  },

  {
    value: `Slager`,
    labels: [
      { language: 'nl', label: `Slager` },
      { language: 'fr', label: `Boucher` },
      { language: 'en', label: `Butcher` },
    ],
  },

  {
    value: `Halfautomaatlasser`,
    labels: [
      {
        language: 'nl',
        label: `Halfautomaatlasser`,
      },
      { language: 'fr', label: `Soudeuse semi-automatique` },
      { language: 'en', label: `Semi-automatic welder` },
    ],
  },

  {
    value: `Goederenbehandelaar in de haven`,
    labels: [
      {
        language: 'nl',
        label: `Goederenbehandelaar in de haven`,
      },
      { language: 'fr', label: `Manutentionnaire au port` },
      { language: 'en', label: `Freight handler in the port` },
    ],
  },

  {
    value: `Student`,
    labels: [
      { language: 'nl', label: `Student` },
      { language: 'fr', label: `Étudiant` },
      { language: 'en', label: `Student` },
    ],
  },

  {
    value: `Lasser`,
    labels: [
      { language: 'nl', label: `Lasser` },
      { language: 'fr', label: `Soudeur` },
      { language: 'en', label: `Welder` },
    ],
  },

  {
    value: `Productiemanager`,
    labels: [
      {
        language: 'nl',
        label: `Productiemanager`,
      },
      { language: 'fr', label: `Directeur de production` },
      { language: 'en', label: `Production manager` },
    ],
  },

  {
    value: `Metselaar`,
    labels: [
      { language: 'nl', label: `Metselaar` },
      { language: 'fr', label: `le maçon` },
      { language: 'en', label: `Mason` },
    ],
  },

  {
    value: `Administratief medewerker onthaal`,
    labels: [
      {
        language: 'nl',
        label: `Administratief medewerker onthaal`,
      },
      { language: 'fr', label: `Accueil des employés administratifs` },
      { language: 'en', label: `Administrative employee reception` },
    ],
  },

  {
    value: `Productiemedewerker`,
    labels: [
      {
        language: 'nl',
        label: `Productiemedewerker`,
      },
      { language: 'fr', label: `Employé de production` },
      { language: 'en', label: `Production employee` },
    ],
  },

  {
    value: `Technicus onderzoek en ontwikkeling in elektriciteit en elektronica`,
    labels: [
      {
        language: 'nl',
        label: `Technicus onderzoek en ontwikkeling in elektriciteit en elektronica`,
      },
      {
        language: 'fr',
        label: `Technicien en recherche et développement en électricité et électronique`,
      },
      {
        language: 'en',
        label: `Research and development technician in electricity and electronics`,
      },
    ],
  },

  {
    value: `Technicus ontwerper industriële automatisering`,
    labels: [
      {
        language: 'nl',
        label: `Technicus ontwerper industriële automatisering`,
      },
      { language: 'fr', label: `Technicien concepteur en automatisation industrielle` },
      { language: 'en', label: `Technician designer industrial automation` },
    ],
  },

  {
    value: `Interieurbouwer`,
    labels: [
      {
        language: 'nl',
        label: `Interieurbouwer`,
      },
      { language: 'fr', label: `Constructeur d'intérieur` },
      { language: 'en', label: `Interior builder` },
    ],
  },

  {
    value: `Slachter`,
    labels: [
      { language: 'nl', label: `Slachter` },
      { language: 'fr', label: `Boucher` },
      { language: 'en', label: `Butcher` },
    ],
  },

  {
    value: `Productmanager`,
    labels: [
      { language: 'nl', label: `Productmanager` },
      { language: 'fr', label: `Chef de produit` },
      { language: 'en', label: `Product manager` },
    ],
  },

  {
    value: `Projectmanager engineering`,
    labels: [
      {
        language: 'nl',
        label: `Projectmanager engineering`,
      },
      { language: 'fr', label: `Ingénierie chef de projet` },
      { language: 'en', label: `Project manager engineering` },
    ],
  },

  {
    value: `Operator algemeen`,
    labels: [
      {
        language: 'nl',
        label: `Operator algemeen`,
      },
      { language: 'fr', label: `Opérateur général` },
      { language: 'en', label: `Operator general` },
    ],
  },

  {
    value: `Acteur`,
    labels: [
      { language: 'nl', label: `Acteur` },
      { language: 'fr', label: `Acteur` },
      { language: 'en', label: `Actor` },
    ],
  },

  {
    value: `Actuaris`,
    labels: [
      { language: 'nl', label: `Actuaris` },
      { language: 'fr', label: `Actuaire` },
      { language: 'en', label: `Actuary` },
    ],
  },

  {
    value: `Orthopedisch technoloog`,
    labels: [
      {
        language: 'nl',
        label: `Orthopedisch technoloog`,
      },
      { language: 'fr', label: `Technologue orthopédiste` },
      { language: 'en', label: `Orthopedic technologist` },
    ],
  },
];

export default functionNodes;
